// import React, { useState, useEffect, useRef } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import { toast } from 'react-toastify';
// import '../../Styles/RouteManage.css';
// import { useNavigate } from 'react-router-dom';
// import RouteActivityLogModal from './RouteActivityLogModal';

// // ============================================================
// // DUMMY DATA
// // ============================================================
// const DUMMY_CITY_SUGGESTIONS = [
//     { id: 'c1', name: 'Kolkata', state: 'West Bengal', terminal: 'Esplanade', address: 'Esplanade, Kolkata' },
//     { id: 'c2', name: 'Digha', state: 'West Bengal', terminal: 'Digha Bus Stand', address: 'Digha, WB' },
//     { id: 'c3', name: 'Delhi', state: 'Delhi', terminal: 'Kashmere Gate', address: 'Kashmere Gate, Delhi' },
//     { id: 'c4', name: 'Manali', state: 'HP', terminal: 'Volvo Stand', address: 'Manali, HP' },
//     { id: 'c5', name: 'Kalyani', state: 'West Bengal', terminal: 'Kalyani Bus Stand', address: 'Kalyani, Nadia' },
//     { id: 'c6', name: 'Durgapur', state: 'West Bengal', terminal: 'Durgapur City Centre', address: 'Durgapur, WB' },
//     { id: 'c7', name: 'Chennai', state: 'Tamil Nadu', terminal: 'CMBT', address: 'CMBT, Chennai' },
//     { id: 'c8', name: 'Mumbai', state: 'Maharashtra', terminal: 'Dadar', address: 'Dadar, Mumbai' },
//     { id: 'c9', name: 'Bhubaneswar', state: 'Odisha', terminal: 'Baramunda', address: 'Baramunda, Odisha' },
//     { id: 'c10', name: 'Varanasi', state: 'UP', terminal: 'Cantt', address: 'Varanasi Cantt' }
// ];

// const DUMMY_PRIMARY_ROUTES = [
//     {
//         _id: 'pr_1',
//         routeName: 'Kalyani → Manali Weekly',
//         localRouteName: 'Himalayan Weekly',
//         isPrimaryRoute: true,
//         departureDays: [1, 4], // Mon + Thu (0=Sun..6=Sat)
//         isRoundTrip: false,
//         isActive: true,
//         origin: {
//             city: 'Kalyani', state: 'West Bengal', terminal: 'Kalyani Bus Stand',
//             departureDay: 1, departureTime: '21:00',
//             coordinates: { lat: 22.9750, lng: 88.4345 }
//         },
//         destination: {
//             city: 'Manali', state: 'HP', terminal: 'Volvo Stand',
//             arrivalDay: 3, arrivalTime: '07:30',
//             coordinates: { lat: 32.2432, lng: 77.1892 }
//         },
//         intermediateStops: [
//             {
//                 sequence: 1, city: 'Durgapur', state: 'WB', terminal: 'City Centre',
//                 arrivalDay: 2, arrivalTime: '10:00',
//                 departureDay: 2, departureTime: '10:20',
//                 coordinates: { lat: 23.5204, lng: 87.3119 },
//                 distanceFromOrigin: 160, stopType: 'both'
//             }
//         ],
//         routeDetails: { totalDistance: 1850, estimatedDuration: { days: 2, hours: 10, minutes: 30 } },
//         createdAt: new Date().toISOString(),
//         updatedAt: new Date().toISOString()
//     },
//     {
//         _id: 'pr_2',
//         routeName: 'Chennai → Kolkata Coastal Weekly',
//         localRouteName: 'Coastal Weekly',
//         isPrimaryRoute: true,
//         departureDays: [0, 3, 6], // Sun, Wed, Sat
//         isRoundTrip: false,
//         isActive: true,
//         origin: {
//             city: 'Chennai', state: 'TN', terminal: 'CMBT',
//             departureDay: 1, departureTime: '06:00',
//             coordinates: { lat: 13.0827, lng: 80.2707 }
//         },
//         destination: {
//             city: 'Kolkata', state: 'WB', terminal: 'Esplanade',
//             arrivalDay: 3, arrivalTime: '14:00',
//             coordinates: { lat: 22.5726, lng: 88.3639 }
//         },
//         intermediateStops: [],
//         routeDetails: { totalDistance: 1670, estimatedDuration: { days: 2, hours: 8, minutes: 0 } },
//         createdAt: new Date().toISOString(),
//         updatedAt: new Date().toISOString()
//     }
// ];

// const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
// const DAY_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// // Return array of 7 { dayNumber, dayName, dayShort, dayIndex } where dayNumber 1 starts
// // from the first selected departure day (sorted). If none selected, defaults to Sunday.
// const getWeeklySchedule = (departureDays = []) => {
//     const sorted = [...new Set(departureDays)].sort((a, b) => a - b);
//     const startIdx = sorted.length > 0 ? sorted[0] : 0;
//     const list = [];
//     for (let i = 0; i < 7; i++) {
//         const dIdx = (startIdx + i) % 7;
//         list.push({
//             dayNumber: i + 1,
//             dayName: DAY_NAMES[dIdx],
//             dayShort: DAY_SHORT[dIdx],
//             dayIndex: dIdx
//         });
//     }
//     return list;
// };

// // Format "Tue (Day 2) 10:00 AM" based on startDayIdx (0-6) or null
// const formatDayTime = (dayNum, time, startDayIdx = null) => {
//     if (!dayNum && !time) return '--:--';
//     let prefix = '';
//     if (dayNum) {
//         if (typeof startDayIdx === 'number' && startDayIdx >= 0 && startDayIdx <= 6) {
//             const idx = (startDayIdx + (dayNum - 1)) % 7;
//             prefix = `${DAY_SHORT[idx]} (Day ${dayNum})`;
//         } else {
//             prefix = `Day ${dayNum}`;
//         }
//     }
//     if (!time) return prefix || '--:--';
//     if (time.includes(':')) {
//         const [h, m] = time.split(':');
//         const hour = parseInt(h);
//         const ampm = hour >= 12 ? 'PM' : 'AM';
//         const dh = hour % 12 || 12;
//         return `${prefix} ${dh}:${m} ${ampm}`.trim();
//     }
//     return `${prefix} ${time}`.trim();
// };

// // Format the resolved per-departure-day occurrence for a stop
// // e.g. dayOffset=2, departures=[1,4] -> "Tue 10:00 AM · Fri 10:00 AM"
// const formatOccurrences = (dayOffset, time, departureDays) => {
//     if (!dayOffset || !time || !departureDays?.length) return '—';
//     const sorted = [...new Set(departureDays)].sort((a, b) => a - b);
//     const [h, m] = time.split(':').map(Number);
//     const ampm = h >= 12 ? 'PM' : 'AM';
//     const dh = h % 12 || 12;
//     return sorted
//         .map(startIdx => {
//             const actualIdx = (startIdx + (dayOffset - 1)) % 7;
//             return `${DAY_SHORT[actualIdx]} ${dh}:${String(m).padStart(2, '0')} ${ampm}`;
//         })
//         .join(' · ');
// };

// const calculatePrimaryDuration = (depDay, depTime, arrDay, arrTime) => {
//     if (!depDay || !depTime || !arrDay || !arrTime) return { days: 0, hours: 0, minutes: 0 };
//     const dDay = parseInt(depDay) || 1;
//     const aDay = parseInt(arrDay) || 1;
//     const [dh, dm] = depTime.split(':').map(Number);
//     const [ah, am] = arrTime.split(':').map(Number);
//     if ([dh, dm, ah, am].some(n => isNaN(n))) return { days: 0, hours: 0, minutes: 0 };
//     const depMins = (dDay - 1) * 1440 + dh * 60 + dm;
//     const arrMins = (aDay - 1) * 1440 + ah * 60 + am;
//     let diff = arrMins - depMins;
//     if (diff < 0) diff = 0;
//     return {
//         days: Math.floor(diff / 1440),
//         hours: Math.floor((diff % 1440) / 60),
//         minutes: diff % 60
//     };
// };

// // ============================================================
// // DAY TIME PICKER — respects startDayIdx for labels
// // ============================================================
// const DayTimePicker = ({
//     day, time, onDayChange, onTimeChange,
//     placeholder = 'Select time', disabled = false,
//     maxDay = 7, minDay = 1, startDayIdx = null
// }) => {
//     const schedule = getWeeklySchedule(startDayIdx !== null ? [startDayIdx] : []);
//     const options = schedule.filter(s => s.dayNumber >= minDay && s.dayNumber <= maxDay);

//     return (
//         <div style={{ display: 'flex', gap: '8px', alignItems: 'center', width: '100%' }}>
//             <select
//                 value={day || minDay}
//                 onChange={(e) => onDayChange(parseInt(e.target.value))}
//                 disabled={disabled}
//                 style={{
//                     padding: '8px 10px', borderRadius: '6px',
//                     border: '1px solid #ddd', minWidth: '130px',
//                     fontSize: '13px', backgroundColor: '#fff'
//                 }}
//             >
//                 {options.map(opt => (
//                     <option key={opt.dayNumber} value={opt.dayNumber}>
//                         {startDayIdx !== null
//                             ? `${opt.dayShort} (Day ${opt.dayNumber})`
//                             : `Day ${opt.dayNumber}`}
//                     </option>
//                 ))}
//             </select>
//             <input
//                 type="time"
//                 value={time || ''}
//                 onChange={(e) => onTimeChange(e.target.value)}
//                 className="edit-input"
//                 placeholder={placeholder}
//                 disabled={disabled}
//                 style={{
//                     flex: 1, padding: '8px 10px', borderRadius: '6px',
//                     border: '1px solid #ddd', fontSize: '13px'
//                 }}
//             />
//         </div>
//     );
// };

// // ============================================================
// // WEEKLY DAYS SELECTOR
// // ============================================================
// const WeeklyDaysSelector = ({ selectedDays, onChange, disabled }) => {
//     const toggle = (idx) => {
//         if (disabled) return;
//         const set = new Set(selectedDays || []);
//         if (set.has(idx)) set.delete(idx); else set.add(idx);
//         onChange([...set].sort((a, b) => a - b));
//     };
//     return (
//         <div style={{
//             display: 'flex', flexWrap: 'wrap', gap: '8px',
//             padding: '12px', background: '#f8f9fa',
//             borderRadius: '8px', border: '1px solid #e0e0e0'
//         }}>
//             {DAY_SHORT.map((d, idx) => {
//                 const active = (selectedDays || []).includes(idx);
//                 return (
//                     <button
//                         key={idx}
//                         type="button"
//                         onClick={() => toggle(idx)}
//                         disabled={disabled}
//                         style={{
//                             padding: '8px 16px',
//                             borderRadius: '20px',
//                             border: active ? '2px solid #1976d2' : '2px solid #ddd',
//                             background: active ? '#1976d2' : '#fff',
//                             color: active ? '#fff' : '#333',
//                             fontWeight: active ? '600' : '400',
//                             fontSize: '13px',
//                             cursor: disabled ? 'not-allowed' : 'pointer',
//                             transition: 'all 0.15s'
//                         }}
//                     >
//                         {d}
//                     </button>
//                 );
//             })}
//         </div>
//     );
// };

// // ============================================================
// // STOP EDIT MODAL
// // ============================================================
// const PrimaryStopEditModal = ({
//     isOpen, stop, stopIndex, departureDays, startDayIdx,
//     onClose, onSave
// }) => {
//     const [form, setForm] = useState({
//         city: '', state: '', address: '', terminal: '',
//         arrivalDay: 1, arrivalTime: '', departureDay: 1, departureTime: '',
//         manualDistFromPrev: '', manualDistToNext: '',
//         isBoarding: false, isDropping: false
//     });

//     useEffect(() => {
//         if (!isOpen || !stop) return;
//         setForm({
//             city: stop.city || '',
//             state: stop.state || '',
//             address: stop.address || '',
//             terminal: stop.terminal || '',
//             arrivalDay: stop.arrivalDay || 1,
//             arrivalTime: stop.arrivalTime || '',
//             departureDay: stop.departureDay || stop.arrivalDay || 1,
//             departureTime: stop.departureTime || '',
//             manualDistFromPrev: stop.manualDistFromPrev || '',
//             manualDistToNext: stop.manualDistToNext || '',
//             isBoarding: stop.stopType === 'boarding' || stop.stopType === 'both',
//             isDropping: stop.stopType === 'dropping' || stop.stopType === 'both'
//         });
//     }, [isOpen, stop]);

//     if (!isOpen || !stop) return null;

//     const handleSave = () => {
//         if (!form.city) return toast.error('City is required');
//         if (!form.state) return toast.error('State is required');
//         if (!form.address) return toast.error('Address is required');
//         if (!form.terminal) return toast.error('Terminal is required');
//         if (!form.arrivalTime) return toast.error('Arrival time is required');

//         let stopType = 'none';
//         if (form.isBoarding && form.isDropping) stopType = 'both';
//         else if (form.isBoarding) stopType = 'boarding';
//         else if (form.isDropping) stopType = 'dropping';

//         onSave(stopIndex, {
//             ...stop,
//             city: form.city, state: form.state,
//             address: form.address, terminal: form.terminal,
//             arrivalDay: form.arrivalDay,
//             arrivalTime: form.arrivalTime,
//             departureDay: form.departureDay,
//             departureTime: form.departureTime || form.arrivalTime,
//             stopType,
//             manualDistFromPrev: form.manualDistFromPrev !== '' ? parseFloat(form.manualDistFromPrev) : stop.manualDistFromPrev,
//             manualDistToNext: form.manualDistToNext !== '' ? parseFloat(form.manualDistToNext) : stop.manualDistToNext
//         });
//         onClose();
//     };

//     return (
//         <div className="modal-overlay" onClick={onClose}>
//             <div className="modal-content" onClick={(e) => e.stopPropagation()}
//                 style={{ maxWidth: '900px', width: '90%' }}>
//                 <div className="modal-header">
//                     <h3>Edit Stop #{stopIndex + 1} — {stop.city}</h3>
//                     <button className="modal-close-btn" onClick={onClose}>×</button>
//                 </div>
//                 <div className="modal-body">
//                     <div className="form-row">
//                         <div className="form-group full-width">
//                             <label>City *</label>
//                             <input type="text" value={form.city}
//                                 onChange={(e) => setForm(p => ({ ...p, city: e.target.value }))}
//                                 className="form-input" />
//                         </div>
//                     </div>
//                     <div className="form-row">
//                         <div className="form-group">
//                             <label>State</label>
//                             <input type="text" value={form.state}
//                                 onChange={(e) => setForm(p => ({ ...p, state: e.target.value }))}
//                                 className="form-input" />
//                         </div>
//                         <div className="form-group">
//                             <label>Terminal</label>
//                             <input type="text" value={form.terminal}
//                                 onChange={(e) => setForm(p => ({ ...p, terminal: e.target.value }))}
//                                 className="form-input" />
//                         </div>
//                     </div>
//                     <div className="form-row">
//                         <div className="form-group full-width">
//                             <label>Address</label>
//                             <input type="text" value={form.address}
//                                 onChange={(e) => setForm(p => ({ ...p, address: e.target.value }))}
//                                 className="form-input" />
//                         </div>
//                     </div>
//                     <div className="form-row">
//                         <div className="form-group">
//                             <label>Distance from Previous (km)</label>
//                             <input type="number" value={form.manualDistFromPrev}
//                                 onChange={(e) => setForm(p => ({ ...p, manualDistFromPrev: e.target.value }))}
//                                 className="form-input" min="0" step="0.1" />
//                         </div>
//                         <div className="form-group">
//                             <label>Distance to Next (km)</label>
//                             <input type="number" value={form.manualDistToNext}
//                                 onChange={(e) => setForm(p => ({ ...p, manualDistToNext: e.target.value }))}
//                                 className="form-input" min="0" step="0.1" />
//                         </div>
//                     </div>

//                     <div className="form-row">
//                         <div className="form-group">
//                             <label>Arrival (Day + Time) *</label>
//                             <DayTimePicker
//                                 day={form.arrivalDay}
//                                 time={form.arrivalTime}
//                                 onDayChange={(d) => setForm(p => ({
//                                     ...p, arrivalDay: d,
//                                     departureDay: Math.max(d, p.departureDay || 1)
//                                 }))}
//                                 onTimeChange={(t) => setForm(p => ({ ...p, arrivalTime: t }))}
//                                 startDayIdx={startDayIdx}
//                             />
//                         </div>
//                         <div className="form-group">
//                             <label>Departure (Day + Time)</label>
//                             <DayTimePicker
//                                 day={form.departureDay || form.arrivalDay}
//                                 time={form.departureTime}
//                                 onDayChange={(d) => setForm(p => ({ ...p, departureDay: d }))}
//                                 onTimeChange={(t) => setForm(p => ({ ...p, departureTime: t }))}
//                                 minDay={form.arrivalDay || 1}
//                                 startDayIdx={startDayIdx}
//                             />
//                         </div>
//                     </div>

//                     {departureDays?.length > 0 && form.arrivalTime && (
//                         <div style={{
//                             marginTop: '10px', padding: '10px 14px',
//                             background: '#e3f2fd', borderRadius: '8px',
//                             fontSize: '12px', color: '#0d47a1'
//                         }}>
//                             <strong>Bus reaches this stop:</strong><br />
//                             {formatOccurrences(form.arrivalDay, form.arrivalTime, departureDays)}
//                         </div>
//                     )}

//                     <div className="form-row checkbox-row">
//                         <Checkbox label="Boarding Point" checked={form.isBoarding}
//                             onChange={() => setForm(p => ({ ...p, isBoarding: !p.isBoarding }))} />
//                         <Checkbox label="Dropping Point" checked={form.isDropping}
//                             onChange={() => setForm(p => ({ ...p, isDropping: !p.isDropping }))} />
//                     </div>
//                 </div>
//                 <div className="modal-footer" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', padding: '16px' }}>
//                     <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
//                     <button className="btn btn-primary" onClick={handleSave}>Save Changes</button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// // ============================================================
// // LOCATION INPUT (dummy)
// // ============================================================
// const LocationInput = ({ value, onChange, placeholder, onLocationSelect }) => {
//     const [searchQuery, setSearchQuery] = useState(value || '');
//     const [suggestions, setSuggestions] = useState([]);
//     const [showSuggestions, setShowSuggestions] = useState(false);
//     const timeoutRef = useRef(null);

//     useEffect(() => { setSearchQuery(value || ''); }, [value]);

//     const searchLocations = (query) => {
//         if (!query || query.trim().length < 2) { setSuggestions([]); return; }
//         const filtered = DUMMY_CITY_SUGGESTIONS.filter(c =>
//             c.name.toLowerCase().includes(query.toLowerCase())
//         );
//         setSuggestions(filtered);
//         setShowSuggestions(filtered.length > 0);
//     };

//     const handleSelect = (city) => {
//         setSearchQuery(city.name);
//         setShowSuggestions(false);
//         if (onLocationSelect) {
//             onLocationSelect({
//                 name: city.name,
//                 address: city.address,
//                 city: city.name,
//                 state: city.state,
//                 terminal: city.terminal,
//                 coordinates: { lat: 20 + Math.random() * 10, lng: 75 + Math.random() * 10 }
//             });
//         }
//     };

//     const handleTextChange = (e) => {
//         const v = e.target.value;
//         setSearchQuery(v);
//         onChange(v);
//         if (timeoutRef.current) clearTimeout(timeoutRef.current);
//         timeoutRef.current = setTimeout(() => searchLocations(v), 300);
//     };

//     useEffect(() => () => { if (timeoutRef.current) clearTimeout(timeoutRef.current); }, []);

//     return (
//         <div className="location-input-container">
//             <div className="location-input-wrapper">
//                 <input type="text" value={searchQuery}
//                     onChange={handleTextChange}
//                     onFocus={() => { if (suggestions.length > 0) setShowSuggestions(true); }}
//                     onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
//                     className="edit-input" placeholder={placeholder} />
//             </div>
//             {showSuggestions && suggestions.length > 0 && (
//                 <div className="location-suggestions">
//                     <div className="suggestions-header"><span>Search Results</span></div>
//                     {suggestions.map((city, i) => (
//                         <div key={city.id || i} className="suggestion-item" onClick={() => handleSelect(city)}>
//                             <div className="suggestion-main">{city.name}</div>
//                             <div className="suggestion-secondary">{city.state} • {city.terminal}</div>
//                         </div>
//                     ))}
//                 </div>
//             )}
//         </div>
//     );
// };

// const Checkbox = ({ label, checked, onChange }) => (
//     <label className="checkbox-container">
//         <input type="checkbox" checked={checked} onChange={onChange} className="checkbox-input" />
//         <span className="checkbox-label">{label}</span>
//     </label>
// );

// // ============================================================
// // MAIN COMPONENT
// // ============================================================
// const PrimaryRouteManage = () => {
//     const { token } = useSelector(state => state.user);
//     const navigate = useNavigate();

//     const [viewMode, setViewMode] = useState('regular');
//     const [routes, setRoutes] = useState([]);
//     const [pendingRoutes] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [logModal, setLogModal] = useState({ show: false, routeId: null, routeName: '' });

//     const [showAddModal, setShowAddModal] = useState(false);
//     const [viewingRoute, setViewingRoute] = useState(null);

//     const [activeRouteTab, setActiveRouteTab] = useState('UP');
//     const [isManualStop, setIsManualStop] = useState(true);
//     const [isCalculatingDistances, setIsCalculatingDistances] = useState(false);
//     const [isDistanceCalculated, setIsDistanceCalculated] = useState({ up: false, down: false });
//     const [isCreatingRoute, setIsCreatingRoute] = useState(false);

//     const [upStops, setUpStops] = useState([]);
//     const [downStops, setDownStops] = useState([]);

//     const [stopEditModal, setStopEditModal] = useState({
//         isOpen: false, stop: null, index: null, type: 'up'
//     });

//     const [newRoute, setNewRoute] = useState({
//         routeName: '',
//         localRouteName: '',
//         departureDays: [1], // default Monday
//         upOriginCity: '', upOriginState: '', upOriginAddress: '', upOriginTerminal: '',
//         upOriginCoords: null, upOriginDepTime: '',
//         upDestCity: '', upDestState: '', upDestAddress: '', upDestTerminal: '',
//         upDestCoords: null, upDestArrDay: 1, upDestArrTime: '',
//         upTotalDistance: '', upDurationDays: 0, upDurationHours: '', upDurationMinutes: '',
//         stopCity: '', stopState: '', stopAddress: '', stopTerminal: '',
//         stopCoords: null, stopArrivalDay: 1, stopArrivalTime: '',
//         stopDepartureDay: 1, stopDepartureTime: '',
//         stopDistFromPrev: '', stopDistToNext: '',
//         isBoarding: false, isDropping: false
//     });

//     // ---- Load dummy data ----
//     useEffect(() => {
//         setLoading(true);
//         setTimeout(() => {
//             setRoutes(DUMMY_PRIMARY_ROUTES.map((r, i) => ({
//                 id: r._id,
//                 serialNo: i + 1,
//                 routeName: r.routeName,
//                 localRouteName: r.localRouteName,
//                 originCity: r.origin?.city || 'N/A',
//                 destinationCity: r.destination?.city || 'N/A',
//                 distance: r.routeDetails?.totalDistance || 0,
//                 durationDays: r.routeDetails?.estimatedDuration?.days || 0,
//                 durationHours: r.routeDetails?.estimatedDuration?.hours || 0,
//                 durationMinutes: r.routeDetails?.estimatedDuration?.minutes || 0,
//                 duration: `${r.routeDetails?.estimatedDuration?.days || 0}d ${r.routeDetails?.estimatedDuration?.hours || 0}h ${r.routeDetails?.estimatedDuration?.minutes || 0}m`,
//                 stops: r.intermediateStops?.length || 0,
//                 status: r.isActive ? 'Active' : 'Inactive',
//                 departureDays: r.departureDays || [],
//                 departureTime: r.origin?.departureTime || 'N/A',
//                 arrivalDay: r.destination?.arrivalDay || 1,
//                 arrivalTime: r.destination?.arrivalTime || 'N/A',
//                 isActive: r.isActive,
//                 isRoundTrip: r.isRoundTrip || false,
//                 fullData: r
//             })));
//             setLoading(false);
//         }, 200);
//     }, []);

//     const getActiveStops = () => activeRouteTab === 'UP' ? upStops : downStops;
//     const setActiveStops = (stops) => {
//         if (activeRouteTab === 'UP') setUpStops(stops);
//         else setDownStops(stops);
//     };

//     // The starting day index for label purposes (first selected departure day)
//     const getStartDayIdx = () => {
//         const sorted = [...new Set(newRoute.departureDays || [])].sort((a, b) => a - b);
//         return sorted.length > 0 ? sorted[0] : null;
//     };

//     // ---- Handlers ----
//     const handleSelectOrigin = (loc) => {
//         setNewRoute(p => ({
//             ...p,
//             upOriginCity: loc.city || '',
//             upOriginState: loc.state || '',
//             upOriginAddress: loc.address || '',
//             upOriginTerminal: loc.terminal || '',
//             upOriginCoords: loc.coordinates || { lat: 0, lng: 0 }
//         }));
//         setIsDistanceCalculated(prev => ({ ...prev, up: false }));
//     };

//     const handleSelectDest = (loc) => {
//         setNewRoute(p => ({
//             ...p,
//             upDestCity: loc.city || '',
//             upDestState: loc.state || '',
//             upDestAddress: loc.address || '',
//             upDestTerminal: loc.terminal || '',
//             upDestCoords: loc.coordinates || { lat: 0, lng: 0 }
//         }));
//         setIsDistanceCalculated(prev => ({ ...prev, up: false }));
//     };

//     const handleSelectStop = (loc) => {
//         setNewRoute(p => ({
//             ...p,
//             stopCity: loc.city || '',
//             stopState: loc.state || p.stopState || '',
//             stopAddress: loc.address || '',
//             stopTerminal: loc.terminal || '',
//             stopCoords: loc.coordinates || { lat: 0, lng: 0 }
//         }));
//         setIsManualStop(false);
//     };

//     const clearStopForm = () => {
//         setNewRoute(p => ({
//             ...p,
//             stopCity: '', stopState: '', stopAddress: '', stopTerminal: '',
//             stopArrivalDay: 1, stopArrivalTime: '',
//             stopDepartureDay: 1, stopDepartureTime: '',
//             stopCoords: null, stopDistFromPrev: '', stopDistToNext: '',
//             isBoarding: false, isDropping: false
//         }));
//         setIsManualStop(true);
//     };

//     const addIntermediateStop = (type = 'up') => {
//         if (!newRoute.stopCity) return toast.error('City is required.');
//         if (!newRoute.stopArrivalTime) return toast.error('Arrival time is required.');

//         const stops = getActiveStops();
//         const isManualLocation = isManualStop || !newRoute.stopCoords ||
//             (newRoute.stopCoords.lat === 0 && newRoute.stopCoords.lng === 0);

//         let coordinates = newRoute.stopCoords;
//         let manualDistFromPrev = null;
//         let distanceFromOrigin = 0;

//         if (isManualLocation) {
//             if (!newRoute.stopDistFromPrev || parseFloat(newRoute.stopDistFromPrev) <= 0) {
//                 return toast.error('Please provide distance from previous stop');
//             }
//             coordinates = { lat: 0, lng: 0 };
//             manualDistFromPrev = parseFloat(newRoute.stopDistFromPrev);
//             if (stops.length > 0) {
//                 const last = stops[stops.length - 1];
//                 distanceFromOrigin = parseFloat(((last.distanceFromOrigin || 0) + manualDistFromPrev).toFixed(2));
//             } else {
//                 distanceFromOrigin = manualDistFromPrev;
//             }
//         }

//         let stopType = 'none';
//         if (newRoute.isBoarding && newRoute.isDropping) stopType = 'both';
//         else if (newRoute.isBoarding) stopType = 'boarding';
//         else if (newRoute.isDropping) stopType = 'dropping';

//         const newStop = {
//             city: newRoute.stopCity,
//             state: newRoute.stopState || '',
//             address: newRoute.stopAddress || `${newRoute.stopCity}, ${newRoute.stopState || 'India'}`,
//             terminal: newRoute.stopTerminal || `${newRoute.stopCity} Bus Stand`,
//             arrivalDay: newRoute.stopArrivalDay || 1,
//             arrivalTime: newRoute.stopArrivalTime,
//             departureDay: newRoute.stopDepartureDay || 1,
//             departureTime: newRoute.stopDepartureTime || newRoute.stopArrivalTime,
//             stopType,
//             coordinates,
//             manualDistFromPrev,
//             manualDistToNext: newRoute.stopDistToNext ? parseFloat(newRoute.stopDistToNext) : null,
//             distanceFromOrigin,
//             isManualStop: isManualLocation,
//             sequence: stops.length + 1
//         };

//         setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));
//         if (type === 'up') setUpStops([...upStops, newStop]);
//         else setDownStops([...downStops, newStop]);
//         toast.success(`Stop "${newRoute.stopCity}" added`);
//         clearStopForm();
//     };

//     const handleDeleteStop = (index) => {
//         const isUp = activeRouteTab === 'UP';
//         setIsDistanceCalculated(prev => ({ ...prev, [isUp ? 'up' : 'down']: false }));
//         if (isUp) setUpStops(upStops.filter((_, i) => i !== index));
//         else setDownStops(downStops.filter((_, i) => i !== index));
//     };

//     const handleOpenStopEditModal = (index) => {
//         const stops = getActiveStops();
//         const stop = stops[index];
//         if (!stop) return;
//         setStopEditModal({ isOpen: true, stop, index, type: activeRouteTab === 'UP' ? 'up' : 'down' });
//     };

//     const handleSaveEditedStop = (index, updatedStop) => {
//         const type = stopEditModal.type;
//         setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));
//         if (type === 'up') {
//             const u = [...upStops]; u[index] = { ...updatedStop, sequence: index + 1 };
//             setUpStops(u);
//         } else {
//             const u = [...downStops]; u[index] = { ...updatedStop, sequence: index + 1 };
//             setDownStops(u);
//         }
//         toast.success('Stop updated');
//     };

//     const handleCalculateDistances = () => {
//         const isUp = activeRouteTab === 'UP';
//         const stops = isUp ? upStops : downStops;
//         if (!newRoute.upOriginCity || !newRoute.upDestCity) {
//             return toast.error("Origin and Destination required.");
//         }
//         setIsCalculatingDistances(true);
//         toast.info(`Calculating ${activeRouteTab} distances...`);
//         setTimeout(() => {
//             let cumulative = 0;
//             const updated = stops.map(s => {
//                 const seg = (s.manualDistFromPrev && parseFloat(s.manualDistFromPrev)) ||
//                     parseFloat((Math.random() * 80 + 40).toFixed(1));
//                 cumulative += seg;
//                 return { ...s, distanceFromOrigin: parseFloat(cumulative.toFixed(1)) };
//             });
//             const total = cumulative + parseFloat((Math.random() * 100 + 50).toFixed(1));
//             setActiveStops(updated);
//             if (isUp) setNewRoute(p => ({ ...p, upTotalDistance: total.toFixed(1) }));
//             setIsDistanceCalculated(prev => ({ ...prev, up: true }));
//             toast.success(`Total: ${total.toFixed(1)} km (dummy)`);
//             setIsCalculatingDistances(false);
//         }, 500);
//     };

//     const handleSaveRoute = () => {
//         if (!newRoute.routeName) return toast.error('Route Name is required');
//         if (!newRoute.upOriginCity || !newRoute.upDestCity) {
//             return toast.error('Origin and Destination required');
//         }
//         if (!newRoute.departureDays || newRoute.departureDays.length === 0) {
//             return toast.error('Please select at least one departure day');
//         }
//         if (!newRoute.upOriginDepTime) return toast.error('Departure time required');
//         if (!newRoute.upDestArrTime) return toast.error('Destination arrival time required');
//         if (!isDistanceCalculated.up) return toast.error('Please calculate distances first');

//         setIsCreatingRoute(true);
//         setTimeout(() => {
//             const created = {
//                 _id: 'pr_' + Date.now(),
//                 routeName: newRoute.routeName.trim(),
//                 localRouteName: newRoute.localRouteName?.trim() || null,
//                 isPrimaryRoute: true,
//                 departureDays: [...new Set(newRoute.departureDays)].sort((a, b) => a - b),
//                 isActive: true,
//                 origin: {
//                     city: newRoute.upOriginCity, state: newRoute.upOriginState,
//                     terminal: newRoute.upOriginTerminal, address: newRoute.upOriginAddress,
//                     coordinates: newRoute.upOriginCoords,
//                     departureDay: 1, departureTime: newRoute.upOriginDepTime
//                 },
//                 destination: {
//                     city: newRoute.upDestCity, state: newRoute.upDestState,
//                     terminal: newRoute.upDestTerminal, address: newRoute.upDestAddress,
//                     coordinates: newRoute.upDestCoords,
//                     arrivalDay: newRoute.upDestArrDay || 1,
//                     arrivalTime: newRoute.upDestArrTime
//                 },
//                 intermediateStops: upStops,
//                 routeDetails: {
//                     totalDistance: parseFloat(newRoute.upTotalDistance || 0),
//                     estimatedDuration: {
//                         days: parseInt(newRoute.upDurationDays || 0, 10),
//                         hours: parseInt(newRoute.upDurationHours || 0, 10),
//                         minutes: parseInt(newRoute.upDurationMinutes || 0, 10)
//                     }
//                 },
//                 createdAt: new Date().toISOString(),
//                 updatedAt: new Date().toISOString()
//             };

//             setRoutes(prev => [...prev, {
//                 id: created._id,
//                 serialNo: prev.length + 1,
//                 routeName: created.routeName,
//                 localRouteName: created.localRouteName,
//                 originCity: created.origin.city,
//                 destinationCity: created.destination.city,
//                 distance: created.routeDetails.totalDistance,
//                 durationDays: created.routeDetails.estimatedDuration.days,
//                 durationHours: created.routeDetails.estimatedDuration.hours,
//                 durationMinutes: created.routeDetails.estimatedDuration.minutes,
//                 duration: `${created.routeDetails.estimatedDuration.days}d ${created.routeDetails.estimatedDuration.hours}h ${created.routeDetails.estimatedDuration.minutes}m`,
//                 stops: created.intermediateStops.length,
//                 status: 'Active', isActive: true,
//                 departureDays: created.departureDays,
//                 departureTime: created.origin.departureTime,
//                 arrivalDay: created.destination.arrivalDay,
//                 arrivalTime: created.destination.arrivalTime,
//                 isRoundTrip: false,
//                 fullData: created
//             }]);

//             toast.success('Primary route created (dummy)!');
//             setShowAddModal(false);
//             resetNewRouteForm();
//             setIsCreatingRoute(false);
//         }, 400);
//     };

//     const resetNewRouteForm = () => {
//         setNewRoute({
//             routeName: '', localRouteName: '', departureDays: [1],
//             upOriginCity: '', upOriginState: '', upOriginAddress: '', upOriginTerminal: '',
//             upOriginCoords: null, upOriginDepTime: '',
//             upDestCity: '', upDestState: '', upDestAddress: '', upDestTerminal: '',
//             upDestCoords: null, upDestArrDay: 1, upDestArrTime: '',
//             upTotalDistance: '', upDurationDays: 0, upDurationHours: '', upDurationMinutes: '',
//             stopCity: '', stopState: '', stopAddress: '', stopTerminal: '',
//             stopCoords: null, stopArrivalDay: 1, stopArrivalTime: '',
//             stopDepartureDay: 1, stopDepartureTime: '',
//             stopDistFromPrev: '', stopDistToNext: '',
//             isBoarding: false, isDropping: false
//         });
//         setUpStops([]); setDownStops([]);
//         setIsDistanceCalculated({ up: false, down: false });
//     };

//     const handleToggleStatus = (routeId, currentStatus) => {
//         const newStatus = !currentStatus;
//         if (!window.confirm(`Are you sure you want to ${newStatus ? 'activate' : 'deactivate'} this route?`)) return;
//         setRoutes(prev => prev.map(r => r.id === routeId
//             ? { ...r, isActive: newStatus, status: newStatus ? 'Active' : 'Inactive' } : r));
//         toast.success(`Route ${newStatus ? 'activated' : 'deactivated'} (dummy)!`);
//     };

//     const handleDeleteRoute = (routeId) => {
//         if (!window.confirm('Delete this route?')) return;
//         setRoutes(prev => prev.filter(r => r.id !== routeId));
//         toast.success('Route deleted (dummy)!');
//     };

//     const handleViewRoute = (route) => setViewingRoute(route.fullData || route);

//     const currentRoutes = viewMode === 'regular' ? routes : pendingRoutes;

//     // ============================================================
//     // RENDER
//     // ============================================================
//     if (loading) {
//         return <div className="management-page"><div className="page-header"><h1>Loading...</h1></div></div>;
//     }

//     return (
//         <div className="management-page">
//             <div className="page-header">
//                 <h1>Primary Route Management</h1>
//                 <div className="header-actions">
//                     <input type="text" placeholder="Search..."
//                         className="search-input" value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)} />
//                     <button className="add-btn" onClick={() => setShowAddModal(true)}>
//                         + Add Primary Route
//                     </button>
//                 </div>
//             </div>

//             <div className="stats-cards">
//                 <div className="stat-card"><h3>Total Routes</h3><p>{routes.length}</p><span>Dummy data</span></div>
//                 <div className="stat-card"><h3>Active</h3><p>{routes.filter(r => r.isActive).length}</p><span>Currently active</span></div>
//                 <div className="stat-card"><h3>Multi-Day</h3><p>{routes.filter(r => r.durationDays > 0).length}</p><span>Routes &gt; 24h</span></div>
//                 <div className="stat-card"><h3>Weekly Runs</h3><p>{routes.reduce((s, r) => s + (r.departureDays?.length || 0), 0)}</p><span>Total weekly trips</span></div>
//             </div>

//             <div style={{ display: 'flex', gap: '10px', margin: '15px' }}>
//                 <button onClick={() => setViewMode('regular')}
//                     style={{
//                         padding: '8px 20px', borderRadius: '20px',
//                         border: '2px solid #007bff',
//                         backgroundColor: viewMode === 'regular' ? '#007bff' : 'transparent',
//                         color: viewMode === 'regular' ? 'white' : '#007bff',
//                         cursor: 'pointer', fontWeight: '500'
//                     }}>🗺️ Regular</button>
//                 <button onClick={() => setViewMode('pending')}
//                     style={{
//                         padding: '8px 20px', borderRadius: '20px',
//                         border: '2px solid #ff9800',
//                         backgroundColor: viewMode === 'pending' ? '#ff9800' : 'transparent',
//                         color: viewMode === 'pending' ? 'white' : '#ff9800',
//                         cursor: 'pointer', fontWeight: '500'
//                     }}>📋 Executive Submitted</button>
//             </div>

//             <div className="table-container">
//                 <table className="data-table">
//                     <thead>
//                         <tr>
//                             <th>No.</th><th>Route Name</th><th>Local Name</th>
//                             <th>Origin → Destination</th>
//                             <th>Runs On (Weekly)</th>
//                             <th>Departure</th>
//                             <th>Duration</th>
//                             <th>Stops</th><th>Status</th><th>Actions</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {currentRoutes.map(route => (
//                             <tr key={route.id}>
//                                 <td>{route.serialNo}</td>
//                                 <td>{route.routeName}</td>
//                                 <td>{route.localRouteName || '—'}</td>
//                                 <td>
//                                     <div><b>{route.originCity}</b> → <b>{route.destinationCity}</b></div>
//                                 </td>
//                                 <td>
//                                     {route.departureDays?.length > 0 ? (
//                                         <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
//                                             {route.departureDays.map(d => (
//                                                 <span key={d} style={{
//                                                     padding: '2px 8px',
//                                                     borderRadius: '10px',
//                                                     background: '#e3f2fd',
//                                                     color: '#0d47a1',
//                                                     fontSize: '11px',
//                                                     fontWeight: '600'
//                                                 }}>{DAY_SHORT[d]}</span>
//                                             ))}
//                                         </div>
//                                     ) : <span style={{ color: '#999' }}>—</span>}
//                                 </td>
//                                 <td>
//                                     <div style={{ fontWeight: '500' }}>{route.departureTime}</div>
//                                     <div style={{ fontSize: '11px', color: '#666' }}>
//                                         Arrives {formatDayTime(route.arrivalDay, route.arrivalTime, route.departureDays?.[0])}
//                                     </div>
//                                 </td>
//                                 <td>{route.duration}</td>
//                                 <td>{route.stops}</td>
//                                 <td>
//                                     <span className={`status-badge ${route.status.toLowerCase()}`}>
//                                         {route.status}
//                                     </span>
//                                 </td>
//                                 <td>
//                                     <div className="action-buttons">
//                                         <button className="action-btn view" onClick={() => handleViewRoute(route)}>View</button>
//                                         <button className={`action-btn ${route.isActive ? 'deactivate' : 'activate'}`}
//                                             onClick={() => handleToggleStatus(route.id, route.isActive)}
//                                             style={{
//                                                 backgroundColor: route.isActive ? '#ffc107' : '#28a745',
//                                                 color: route.isActive ? '#000' : 'white'
//                                             }}>
//                                             {route.isActive ? 'Deactivate' : 'Activate'}
//                                         </button>
//                                         <button className="action-btn delete" onClick={() => handleDeleteRoute(route.id)}>Delete</button>
//                                     </div>
//                                 </td>
//                             </tr>
//                         ))}
//                         {currentRoutes.length === 0 && (
//                             <tr><td colSpan="10" style={{ textAlign: 'center', padding: '30px', color: '#888' }}>
//                                 No routes. Click "+ Add Primary Route" (dummy).
//                             </td></tr>
//                         )}
//                     </tbody>
//                 </table>
//             </div>

//             {/* ============================================================
//                 ADD MODAL
//             ============================================================ */}
//             {showAddModal && (
//                 <div className="modal-overlay add-route-modal" onClick={() => setShowAddModal(false)}>
//                     <div className="modal-content add-route-content" onClick={(e) => e.stopPropagation()}>
//                         <div className="modal-header">
//                             <h3>Create Weekly Primary Route</h3>
//                             <button className="modal-close-btn" onClick={() => setShowAddModal(false)}>×</button>
//                         </div>

//                         <div className="modal-body">
//                             <div style={{
//                                 padding: '12px 16px', backgroundColor: '#e3f2fd',
//                                 borderRadius: '8px', border: '1px solid #90caf9',
//                                 marginBottom: '16px', fontSize: '13px', color: '#0d47a1'
//                             }}>
//                                 🚌 <strong>Weekly Recurring Route:</strong> Pick which days of the week this route runs.
//                                 Buses depart at the <strong>same time</strong> on every selected day. All stop timings
//                                 are entered once and auto-repeated on every departure day.
//                             </div>

//                             <div className="form-sections">
//                                 {/* Route Identity */}
//                                 <div className="form-section">
//                                     <h4>Route Identity</h4>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Route Name *</label>
//                                             <input type="text" value={newRoute.routeName}
//                                                 onChange={(e) => setNewRoute(p => ({ ...p, routeName: e.target.value }))}
//                                                 placeholder="e.g. Kalyani → Manali Weekly"
//                                                 className="form-input" />
//                                         </div>
//                                     </div>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Local Route Name</label>
//                                             <input type="text" value={newRoute.localRouteName}
//                                                 onChange={(e) => setNewRoute(p => ({ ...p, localRouteName: e.target.value }))}
//                                                 placeholder="Optional local name"
//                                                 className="form-input" />
//                                         </div>
//                                     </div>

//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>📅 Runs on These Days (Pick 1 or more) *</label>
//                                             <WeeklyDaysSelector
//                                                 selectedDays={newRoute.departureDays}
//                                                 onChange={(days) => {
//                                                     if (days.length === 0) {
//                                                         toast.warning('At least one day required');
//                                                         return;
//                                                     }
//                                                     setNewRoute(p => ({ ...p, departureDays: days }));
//                                                 }}
//                                             />
//                                             <small style={{ display: 'block', marginTop: '8px', color: '#555' }}>
//                                                 Selected: {newRoute.departureDays.length > 0
//                                                     ? newRoute.departureDays.map(d => DAY_NAMES[d]).join(', ')
//                                                     : 'None'}
//                                                 {newRoute.departureDays.length > 0 && (
//                                                     <>
//                                                         {' '}— <strong>{DAY_SHORT[newRoute.departureDays[0]]}</strong> will be treated as <strong>Day 1</strong> for stop offsets.
//                                                     </>
//                                                 )}
//                                             </small>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Origin */}
//                                 <div className="form-section">
//                                     <h4>Origin *</h4>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Search Location</label>
//                                             <LocationInput value={newRoute.upOriginCity}
//                                                 onChange={(v) => setNewRoute(p => ({ ...p, upOriginCity: v }))}
//                                                 onLocationSelect={handleSelectOrigin}
//                                                 placeholder="Search origin city..." />
//                                         </div>
//                                     </div>
//                                     <div className="form-row">
//                                         <div className="form-group">
//                                             <label>State</label>
//                                             <input type="text" value={newRoute.upOriginState}
//                                                 onChange={(e) => setNewRoute(p => ({ ...p, upOriginState: e.target.value }))}
//                                                 className="form-input" />
//                                         </div>
//                                         <div className="form-group">
//                                             <label>Terminal</label>
//                                             <input type="text" value={newRoute.upOriginTerminal}
//                                                 onChange={(e) => setNewRoute(p => ({ ...p, upOriginTerminal: e.target.value }))}
//                                                 className="form-input" />
//                                         </div>
//                                     </div>

//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Departure Time (Same for Every Selected Day) *</label>
//                                             <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
//                                                 <input
//                                                     type="time"
//                                                     value={newRoute.upOriginDepTime}
//                                                     onChange={(e) => setNewRoute(p => ({ ...p, upOriginDepTime: e.target.value }))}
//                                                     className="form-input"
//                                                     style={{ maxWidth: '200px' }}
//                                                 />
//                                                 {newRoute.departureDays.length > 0 && newRoute.upOriginDepTime && (
//                                                     <span style={{
//                                                         padding: '6px 14px', background: '#e8f5e9',
//                                                         color: '#2e7d32', borderRadius: '20px',
//                                                         fontSize: '12px', fontWeight: '500'
//                                                     }}>
//                                                         {newRoute.departureDays.map(d => DAY_SHORT[d]).join(' · ')} at {newRoute.upOriginDepTime}
//                                                     </span>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Destination */}
//                                 <div className="form-section">
//                                     <h4>Destination *</h4>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Search Location</label>
//                                             <LocationInput value={newRoute.upDestCity}
//                                                 onChange={(v) => setNewRoute(p => ({ ...p, upDestCity: v }))}
//                                                 onLocationSelect={handleSelectDest}
//                                                 placeholder="Search destination city..." />
//                                         </div>
//                                     </div>
//                                     <div className="form-row">
//                                         <div className="form-group">
//                                             <label>State</label>
//                                             <input type="text" value={newRoute.upDestState}
//                                                 onChange={(e) => setNewRoute(p => ({ ...p, upDestState: e.target.value }))}
//                                                 className="form-input" />
//                                         </div>
//                                         <div className="form-group">
//                                             <label>Terminal</label>
//                                             <input type="text" value={newRoute.upDestTerminal}
//                                                 onChange={(e) => setNewRoute(p => ({ ...p, upDestTerminal: e.target.value }))}
//                                                 className="form-input" />
//                                         </div>
//                                     </div>

//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Arrival (Day offset + Time) *</label>
//                                             <DayTimePicker
//                                                 day={newRoute.upDestArrDay}
//                                                 time={newRoute.upDestArrTime}
//                                                 onDayChange={(d) => setNewRoute(p => ({ ...p, upDestArrDay: d }))}
//                                                 onTimeChange={(t) => setNewRoute(p => ({ ...p, upDestArrTime: t }))}
//                                                 maxDay={7}
//                                                 minDay={1}
//                                                 startDayIdx={getStartDayIdx()}
//                                             />
//                                             {newRoute.departureDays.length > 0 && newRoute.upDestArrTime && (
//                                                 <small style={{
//                                                     display: 'block', marginTop: '8px',
//                                                     padding: '8px 12px', background: '#fff8e1',
//                                                     borderRadius: '6px', color: '#8d6e00', fontSize: '12px'
//                                                 }}>
//                                                     Bus arrives: <strong>{formatOccurrences(newRoute.upDestArrDay, newRoute.upDestArrTime, newRoute.departureDays)}</strong>
//                                                 </small>
//                                             )}
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Intermediate Stops */}
//                                 <div className="form-section stops-section">
//                                     <h4>Intermediate Stops</h4>

//                                     <div className="stops-list">
//                                         {getActiveStops().map((stop, index) => (
//                                             <div key={index} className="stop-list-item">
//                                                 <div className="stop-info">
//                                                     <div className="stop-name">
//                                                         {index + 1}. {stop.city}
//                                                         <span className="stop-distance">
//                                                             ({stop.distanceFromOrigin?.toFixed(1) || 0} km)
//                                                         </span>
//                                                     </div>
//                                                     <div className="stop-times">
//                                                         Arr: {formatDayTime(stop.arrivalDay, stop.arrivalTime, getStartDayIdx())} •
//                                                         Dep: {formatDayTime(stop.departureDay, stop.departureTime, getStartDayIdx())}
//                                                     </div>
//                                                     {newRoute.departureDays.length > 0 && stop.arrivalTime && (
//                                                         <div style={{
//                                                             marginTop: '6px', fontSize: '11px',
//                                                             padding: '4px 10px', background: '#e3f2fd',
//                                                             borderRadius: '10px', color: '#0d47a1', display: 'inline-block'
//                                                         }}>
//                                                             🕐 Bus reaches: {formatOccurrences(stop.arrivalDay, stop.arrivalTime, newRoute.departureDays)}
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                                 <div className="stop-actions">
//                                                     <button className="stop-action-btn edit"
//                                                         onClick={() => handleOpenStopEditModal(index)}
//                                                         style={{
//                                                             backgroundColor: '#17a2b8', color: 'white',
//                                                             padding: '4px 12px', borderRadius: '4px',
//                                                             border: 'none', cursor: 'pointer',
//                                                             fontSize: '12px', marginRight: '6px'
//                                                         }}>Edit</button>
//                                                     <button className="stop-action-btn delete"
//                                                         onClick={() => handleDeleteStop(index)}>Delete</button>
//                                                 </div>
//                                             </div>
//                                         ))}
//                                         {getActiveStops().length === 0 && (
//                                             <div style={{ textAlign: 'center', padding: '20px', color: '#999', fontSize: '13px' }}>
//                                                 No intermediate stops yet.
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div className="stop-form" style={{
//                                         marginTop: '20px', padding: '16px',
//                                         border: '1px dashed #90caf9', borderRadius: '10px',
//                                         background: '#f5f9ff'
//                                     }}>
//                                         <h5 style={{ marginBottom: '12px' }}>➕ Add Intermediate Stop</h5>

//                                         <div className="form-row">
//                                             <Checkbox label="Manually Typed Stop"
//                                                 checked={!isManualStop}
//                                                 onChange={() => setIsManualStop(!isManualStop)} />
//                                         </div>

//                                         <div className="form-row">
//                                             <div className="form-group full-width">
//                                                 <label>City *</label>
//                                                 <LocationInput value={newRoute.stopCity}
//                                                     onChange={(v) => setNewRoute(p => ({ ...p, stopCity: v }))}
//                                                     onLocationSelect={handleSelectStop}
//                                                     placeholder="Search stop city..." />
//                                             </div>
//                                         </div>

//                                         {(isManualStop || !newRoute.stopCoords) && (
//                                             <div className="form-row">
//                                                 <div className="form-group full-width">
//                                                     <label>Distance from Previous Stop (km) *</label>
//                                                     <input type="number" value={newRoute.stopDistFromPrev}
//                                                         onChange={(e) => setNewRoute(p => ({ ...p, stopDistFromPrev: e.target.value }))}
//                                                         className="form-input" min="0" step="0.1" />
//                                                 </div>
//                                             </div>
//                                         )}

//                                         <div className="form-row">
//                                             <div className="form-group">
//                                                 <label>State</label>
//                                                 <input type="text" value={newRoute.stopState}
//                                                     onChange={(e) => setNewRoute(p => ({ ...p, stopState: e.target.value }))}
//                                                     className="form-input" />
//                                             </div>
//                                             <div className="form-group">
//                                                 <label>Terminal</label>
//                                                 <input type="text" value={newRoute.stopTerminal}
//                                                     onChange={(e) => setNewRoute(p => ({ ...p, stopTerminal: e.target.value }))}
//                                                     className="form-input" />
//                                             </div>
//                                         </div>

//                                         <div className="form-row">
//                                             <div className="form-group">
//                                                 <label>Arrival (Day + Time) *</label>
//                                                 <DayTimePicker
//                                                     day={newRoute.stopArrivalDay}
//                                                     time={newRoute.stopArrivalTime}
//                                                     onDayChange={(d) => setNewRoute(p => ({
//                                                         ...p, stopArrivalDay: d,
//                                                         stopDepartureDay: Math.max(d, p.stopDepartureDay || 1)
//                                                     }))}
//                                                     onTimeChange={(t) => setNewRoute(p => ({ ...p, stopArrivalTime: t }))}
//                                                     startDayIdx={getStartDayIdx()}
//                                                 />
//                                             </div>
//                                             <div className="form-group">
//                                                 <label>Departure (Day + Time)</label>
//                                                 <DayTimePicker
//                                                     day={newRoute.stopDepartureDay}
//                                                     time={newRoute.stopDepartureTime}
//                                                     onDayChange={(d) => setNewRoute(p => ({ ...p, stopDepartureDay: d }))}
//                                                     onTimeChange={(t) => setNewRoute(p => ({ ...p, stopDepartureTime: t }))}
//                                                     minDay={newRoute.stopArrivalDay || 1}
//                                                     startDayIdx={getStartDayIdx()}
//                                                 />
//                                             </div>
//                                         </div>

//                                         {newRoute.departureDays.length > 0 && newRoute.stopArrivalTime && (
//                                             <div style={{
//                                                 padding: '10px 14px', background: '#e8f5e9',
//                                                 borderRadius: '8px', fontSize: '12px',
//                                                 color: '#2e7d32', marginBottom: '12px'
//                                             }}>
//                                                 ✅ Bus will reach <strong>{newRoute.stopCity || 'this stop'}</strong> at:
//                                                 <br />
//                                                 <strong>{formatOccurrences(newRoute.stopArrivalDay, newRoute.stopArrivalTime, newRoute.departureDays)}</strong>
//                                             </div>
//                                         )}

//                                         <div className="form-row checkbox-row">
//                                             <Checkbox label="Boarding Point" checked={newRoute.isBoarding}
//                                                 onChange={() => setNewRoute(p => ({ ...p, isBoarding: !p.isBoarding }))} />
//                                             <Checkbox label="Dropping Point" checked={newRoute.isDropping}
//                                                 onChange={() => setNewRoute(p => ({ ...p, isDropping: !p.isDropping }))} />
//                                         </div>

//                                         <button className="btn btn-secondary add-stop-btn"
//                                             onClick={() => addIntermediateStop('up')}
//                                             disabled={!newRoute.stopCity || !newRoute.stopArrivalTime}>
//                                             + Add Stop
//                                         </button>
//                                     </div>
//                                 </div>

//                                 {/* Summary */}
//                                 <div className="form-section">
//                                     <h4>Summary</h4>
//                                     <button className="btn btn-success calculate-btn"
//                                         onClick={handleCalculateDistances}
//                                         disabled={isCalculatingDistances}>
//                                         {isCalculatingDistances ? 'Calculating...' : 'Auto-Calculate Distances'}
//                                     </button>

//                                     <div className="form-row summary-fields">
//                                         <div className="form-group">
//                                             <label>Total Distance (KM)</label>
//                                             <input type="number" value={newRoute.upTotalDistance}
//                                                 onChange={(e) => setNewRoute(p => ({ ...p, upTotalDistance: e.target.value }))}
//                                                 className="form-input" min="0" step="0.1" />
//                                         </div>
//                                     </div>

//                                     <div className="form-row summary-fields">
//                                         <div className="form-group full-width">
//                                             <label>Estimated Duration</label>
//                                             <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
//                                                 <input type="number" value={newRoute.upDurationDays}
//                                                     onChange={(e) => setNewRoute(p => ({ ...p, upDurationDays: Math.min(7, Math.max(0, parseInt(e.target.value) || 0)) }))}
//                                                     className="form-input" placeholder="Days" min="0" max="7" style={{ width: '80px' }} />
//                                                 <span>days</span>
//                                                 <input type="number" value={newRoute.upDurationHours}
//                                                     onChange={(e) => setNewRoute(p => ({ ...p, upDurationHours: Math.min(23, Math.max(0, parseInt(e.target.value) || 0)) }))}
//                                                     className="form-input" placeholder="Hours" min="0" max="23" style={{ width: '80px' }} />
//                                                 <span>h</span>
//                                                 <input type="number" value={newRoute.upDurationMinutes}
//                                                     onChange={(e) => setNewRoute(p => ({ ...p, upDurationMinutes: Math.min(59, Math.max(0, parseInt(e.target.value) || 0)) }))}
//                                                     className="form-input" placeholder="Min" min="0" max="59" style={{ width: '80px' }} />
//                                                 <span>m</span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="form-actions">
//                                 <button className="btn btn-primary save-route-btn"
//                                     onClick={handleSaveRoute}
//                                     disabled={isCreatingRoute}>
//                                     {isCreatingRoute ? 'Creating...' : 'Add Primary Route'}
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* VIEW MODAL */}
//             {viewingRoute && (
//                 <div className="modal-overlay" onClick={() => setViewingRoute(null)}>
//                     <div className="modal-content1" onClick={(e) => e.stopPropagation()}
//                         style={{ maxWidth: '800px', width: '90%', padding: '24px', background: '#fff', borderRadius: '12px' }}>
//                         <div className="modal-header">
//                             <h3>{viewingRoute.routeName}</h3>
//                             <button className="modal-close-btn" onClick={() => setViewingRoute(null)}>×</button>
//                         </div>
//                         <div style={{ marginTop: '16px' }}>
//                             <p><b>Local Name:</b> {viewingRoute.localRouteName || '—'}</p>
//                             <p>
//                                 <b>Runs On:</b>{' '}
//                                 {viewingRoute.departureDays?.length > 0
//                                     ? viewingRoute.departureDays.map(d => DAY_NAMES[d]).join(', ')
//                                     : '—'}
//                             </p>
//                             <p>
//                                 <b>Origin:</b> {viewingRoute.origin?.city} — Departs <b>{viewingRoute.origin?.departureTime}</b> on all selected days
//                             </p>
//                             <p>
//                                 <b>Destination:</b> {viewingRoute.destination?.city} — Arrives{' '}
//                                 {formatOccurrences(
//                                     viewingRoute.destination?.arrivalDay || 1,
//                                     viewingRoute.destination?.arrivalTime,
//                                     viewingRoute.departureDays
//                                 )}
//                             </p>
//                             <p><b>Distance:</b> {viewingRoute.routeDetails?.totalDistance} km</p>
//                             <p>
//                                 <b>Duration:</b> {viewingRoute.routeDetails?.estimatedDuration?.days || 0}d{' '}
//                                 {viewingRoute.routeDetails?.estimatedDuration?.hours || 0}h{' '}
//                                 {viewingRoute.routeDetails?.estimatedDuration?.minutes || 0}m
//                             </p>

//                             {viewingRoute.intermediateStops?.length > 0 && (
//                                 <>
//                                     <h4 style={{ marginTop: '20px' }}>Intermediate Stops</h4>
//                                     {viewingRoute.intermediateStops.map((s, i) => (
//                                         <div key={i} style={{
//                                             padding: '10px 14px', background: '#f8f9fa',
//                                             borderRadius: '8px', marginBottom: '8px'
//                                         }}>
//                                             <b>{s.sequence}. {s.city}</b> ({s.distanceFromOrigin?.toFixed(1)} km)
//                                             <div style={{ fontSize: '13px', color: '#555', marginTop: '4px' }}>
//                                                 Arrives: {formatOccurrences(s.arrivalDay, s.arrivalTime, viewingRoute.departureDays)}
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </>
//                             )}
//                         </div>
//                         <div style={{ marginTop: '20px', textAlign: 'right' }}>
//                             <button className="btn btn-secondary" onClick={() => setViewingRoute(null)}>Close</button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* STOP EDIT MODAL */}
//             <PrimaryStopEditModal
//                 isOpen={stopEditModal.isOpen}
//                 stop={stopEditModal.stop}
//                 stopIndex={stopEditModal.index}
//                 departureDays={newRoute.departureDays}
//                 startDayIdx={getStartDayIdx()}
//                 onClose={() => setStopEditModal({ isOpen: false, stop: null, index: null, type: 'up' })}
//                 onSave={handleSaveEditedStop}
//             />

//             {logModal.show && (
//                 <RouteActivityLogModal
//                     routeId={logModal.routeId}
//                     routeName={logModal.routeName}
//                     onClose={() => setLogModal({ show: false, routeId: null, routeName: '' })}
//                     token={token}
//                 />
//             )}
//         </div>
//     );
// };

// export default PrimaryRouteManage;

// import React, { useState, useEffect, useRef, useMemo } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import { toast } from 'react-toastify';
// import '../../Styles/RouteManage.css';
// import '../../Styles/PrimaryRouteManage.css'; // <-- NEW redesign styles (keep this AFTER the two above)
// import { useNavigate } from 'react-router-dom';
// import RouteActivityLogModal from './RouteActivityLogModal';


// // ============================================================
// // DUMMY DATA
// // ============================================================
// const DUMMY_CITY_SUGGESTIONS = [
//     { id: 'c1', name: 'Kolkata', state: 'West Bengal', terminal: 'Esplanade', address: 'Esplanade, Kolkata' },
//     { id: 'c2', name: 'Digha', state: 'West Bengal', terminal: 'Digha Bus Stand', address: 'Digha, WB' },
//     { id: 'c3', name: 'Delhi', state: 'Delhi', terminal: 'Kashmere Gate', address: 'Kashmere Gate, Delhi' },
//     { id: 'c4', name: 'Manali', state: 'HP', terminal: 'Volvo Stand', address: 'Manali, HP' },
//     { id: 'c5', name: 'Kalyani', state: 'West Bengal', terminal: 'Kalyani Bus Stand', address: 'Kalyani, Nadia' },
//     { id: 'c6', name: 'Durgapur', state: 'West Bengal', terminal: 'Durgapur City Centre', address: 'Durgapur, WB' },
//     { id: 'c7', name: 'Chennai', state: 'Tamil Nadu', terminal: 'CMBT', address: 'CMBT, Chennai' },
//     { id: 'c8', name: 'Mumbai', state: 'Maharashtra', terminal: 'Dadar', address: 'Dadar, Mumbai' },
//     { id: 'c9', name: 'Bhubaneswar', state: 'Odisha', terminal: 'Baramunda', address: 'Baramunda, Odisha' },
//     { id: 'c10', name: 'Varanasi', state: 'UP', terminal: 'Cantt', address: 'Varanasi Cantt' }
// ];

// const DUMMY_PRIMARY_ROUTES = [
//     {
//         _id: 'pr_1',
//         routeName: 'Kalyani → Manali Weekly',
//         localRouteName: 'Himalayan Weekly',
//         isPrimaryRoute: true,
//         departureDays: [1, 4], // Mon + Thu (0=Sun..6=Sat)
//         isRoundTrip: false,
//         isActive: true,
//         origin: {
//             city: 'Kalyani', state: 'West Bengal', terminal: 'Kalyani Bus Stand',
//             departureDay: 1, departureTime: '21:00',
//             coordinates: { lat: 22.9750, lng: 88.4345 }
//         },
//         destination: {
//             city: 'Manali', state: 'HP', terminal: 'Volvo Stand',
//             arrivalDay: 3, arrivalTime: '07:30',
//             coordinates: { lat: 32.2432, lng: 77.1892 }
//         },
//         intermediateStops: [
//             {
//                 sequence: 1, city: 'Durgapur', state: 'WB', terminal: 'City Centre',
//                 arrivalDay: 2, arrivalTime: '10:00',
//                 departureDay: 2, departureTime: '10:20',
//                 coordinates: { lat: 23.5204, lng: 87.3119 },
//                 distanceFromOrigin: 160, stopType: 'both'
//             }
//         ],
//         routeDetails: { totalDistance: 1850, estimatedDuration: { days: 2, hours: 10, minutes: 30 } },
//         createdAt: new Date().toISOString(),
//         updatedAt: new Date().toISOString()
//     },
//     {
//         _id: 'pr_2',
//         routeName: 'Chennai → Kolkata Coastal Weekly',
//         localRouteName: 'Coastal Weekly',
//         isPrimaryRoute: true,
//         departureDays: [0, 3, 6], // Sun, Wed, Sat
//         isRoundTrip: false,
//         isActive: true,
//         origin: {
//             city: 'Chennai', state: 'TN', terminal: 'CMBT',
//             departureDay: 1, departureTime: '06:00',
//             coordinates: { lat: 13.0827, lng: 80.2707 }
//         },
//         destination: {
//             city: 'Kolkata', state: 'WB', terminal: 'Esplanade',
//             arrivalDay: 3, arrivalTime: '14:00',
//             coordinates: { lat: 22.5726, lng: 88.3639 }
//         },
//         intermediateStops: [],
//         routeDetails: { totalDistance: 1670, estimatedDuration: { days: 2, hours: 8, minutes: 0 } },
//         createdAt: new Date().toISOString(),
//         updatedAt: new Date().toISOString()
//     }
// ];

// const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
// const DAY_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// // Return array of 7 { dayNumber, dayName, dayShort, dayIndex } where dayNumber 1 starts
// // from the first selected departure day (sorted). If none selected, defaults to Sunday.
// const getWeeklySchedule = (departureDays = []) => {
//     const sorted = [...new Set(departureDays)].sort((a, b) => a - b);
//     const startIdx = sorted.length > 0 ? sorted[0] : 0;
//     const list = [];
//     for (let i = 0; i < 7; i++) {
//         const dIdx = (startIdx + i) % 7;
//         list.push({
//             dayNumber: i + 1,
//             dayName: DAY_NAMES[dIdx],
//             dayShort: DAY_SHORT[dIdx],
//             dayIndex: dIdx
//         });
//     }
//     return list;
// };

// // Format "Tue (Day 2) 10:00 AM" based on startDayIdx (0-6) or null
// const formatDayTime = (dayNum, time, startDayIdx = null) => {
//     if (!dayNum && !time) return '--:--';
//     let prefix = '';
//     if (dayNum) {
//         if (typeof startDayIdx === 'number' && startDayIdx >= 0 && startDayIdx <= 6) {
//             const idx = (startDayIdx + (dayNum - 1)) % 7;
//             prefix = `${DAY_SHORT[idx]} (Day ${dayNum})`;
//         } else {
//             prefix = `Day ${dayNum}`;
//         }
//     }
//     if (!time) return prefix || '--:--';
//     if (time.includes(':')) {
//         const [h, m] = time.split(':');
//         const hour = parseInt(h);
//         const ampm = hour >= 12 ? 'PM' : 'AM';
//         const dh = hour % 12 || 12;
//         return `${prefix} ${dh}:${m} ${ampm}`.trim();
//     }
//     return `${prefix} ${time}`.trim();
// };

// // Format the resolved per-departure-day occurrence for a stop
// // e.g. dayOffset=2, departures=[1,4] -> "Tue 10:00 AM · Fri 10:00 AM"
// const formatOccurrences = (dayOffset, time, departureDays) => {
//     if (!dayOffset || !time || !departureDays?.length) return '—';
//     const sorted = [...new Set(departureDays)].sort((a, b) => a - b);
//     const [h, m] = time.split(':').map(Number);
//     const ampm = h >= 12 ? 'PM' : 'AM';
//     const dh = h % 12 || 12;
//     return sorted
//         .map(startIdx => {
//             const actualIdx = (startIdx + (dayOffset - 1)) % 7;
//             return `${DAY_SHORT[actualIdx]} ${dh}:${String(m).padStart(2, '0')} ${ampm}`;
//         })
//         .join(' · ');
// };

// // "21:00" -> "9:00 PM"
// const fmtTime = (time) => {
//     if (!time || !time.includes(':')) return time || '--:--';
//     const [h, m] = time.split(':').map(Number);
//     if (isNaN(h) || isNaN(m)) return time;
//     return `${h % 12 || 12}:${String(m).padStart(2, '0')} ${h >= 12 ? 'PM' : 'AM'}`;
// };

// const calculatePrimaryDuration = (depDay, depTime, arrDay, arrTime) => {
//     if (!depDay || !depTime || !arrDay || !arrTime) return { days: 0, hours: 0, minutes: 0 };
//     const dDay = parseInt(depDay) || 1;
//     const aDay = parseInt(arrDay) || 1;
//     const [dh, dm] = depTime.split(':').map(Number);
//     const [ah, am] = arrTime.split(':').map(Number);
//     if ([dh, dm, ah, am].some(n => isNaN(n))) return { days: 0, hours: 0, minutes: 0 };
//     const depMins = (dDay - 1) * 1440 + dh * 60 + dm;
//     const arrMins = (aDay - 1) * 1440 + ah * 60 + am;
//     let diff = arrMins - depMins;
//     if (diff < 0) diff = 0;
//     return {
//         days: Math.floor(diff / 1440),
//         hours: Math.floor((diff % 1440) / 60),
//         minutes: diff % 60
//     };
// };

// // ============================================================
// // NEW — SMALL UI HELPERS FOR THE REDESIGN
// // ============================================================

// // Animated count-up number
// const useCountUp = (target, duration = 900) => {
//     const [value, setValue] = useState(0);
//     useEffect(() => {
//         let raf;
//         let start;
//         const step = (t) => {
//             if (!start) start = t;
//             const p = Math.min((t - start) / duration, 1);
//             setValue(Math.round(target * (1 - Math.pow(1 - p, 3))));
//             if (p < 1) raf = requestAnimationFrame(step);
//         };
//         raf = requestAnimationFrame(step);
//         return () => cancelAnimationFrame(raf);
//     }, [target, duration]);
//     return value;
// };

// const StatCard = ({ icon, label, value, hint, tone, delay = 0 }) => {
//     const shown = useCountUp(value);
//     return (
//         <div className={`prm-stat tone-${tone}`} style={{ animationDelay: `${delay}ms` }}>
//             <div className="prm-stat-icon"><Icon name={icon} size={24} /></div>
//             <div className="prm-stat-body">
//                 <div className="prm-stat-label">{label}</div>
//                 <div className="prm-stat-value">{shown}</div>
//                 <div className="prm-stat-hint">{hint}</div>
//             </div>
//         </div>
//     );
// };

// // Clean line icons + SVG bus (replaces emoji)
// const ICON_PATHS = {
//     route: 'M5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M19 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M7 17h7a3 3 0 0 0 0-6h-4a3 3 0 0 1 0-6h7',
//     check: 'M22 11.1V12a10 10 0 1 1-5.9-9.1 M22 4 12 14l-3-3',
//     moon: 'M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z',
//     calendar: 'M8 2v4 M16 2v4 M3 10h18 M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z',
//     pin: 'M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0z M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
//     clock: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 6v6l4 2',
//     stop: 'M12 3v18 M5 6h11l3 3-3 3H5z',
//     search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z M21 21l-4.3-4.3',
//     eye: 'M2 12s4-8 10-8 10 8 10 8-4 8-10 8S2 12 2 12z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
//     trash: 'M3 6h18 M8 6V4h8v2 M6 6l1 14h10l1-14 M10 11v6 M14 11v6',
//     grid: 'M3 3h7v7H3z M14 3h7v7h-7z M14 14h7v7h-7z M3 14h7v7H3z',
//     list: 'M8 6h13 M8 12h13 M8 18h13 M3 6h.01 M3 12h.01 M3 18h.01',
//     tag: 'M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z M7.5 7.5h.01',
//     plus: 'M12 5v14 M5 12h14',
//     map: 'M1 6l7-3 8 3 7-3v15l-7 3-8-3-7 3z M8 3v15 M16 6v15',
//     clipboard: 'M9 4h6v3H9z M7 5H5a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2 M9 13h6 M9 17h4',
//     bus: 'M5 3h14a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z M3 11h18 M7 21v-3 M17 21v-3 M7 15h.01 M17 15h.01',
//     edit: 'M12 20h9 M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z',
//     calc: 'M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z M8 7h8 M8 12h.01 M12 12h.01 M16 12h.01 M8 16h.01 M12 16h.01 M16 16h.01',
//     info: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 16v-4 M12 8h.01'
// };

// const Icon = ({ name, size = 18 }) => (
//     <svg className="prm-ico" viewBox="0 0 24 24" width={size} height={size} fill="none"
//         stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
//         <path d={ICON_PATHS[name]} />
//     </svg>
// );

// // Right-facing amber bus
// const BusSvg = ({ size = 34 }) => (
//     <svg viewBox="0 0 64 34" width={size} height={(size * 34) / 64} aria-hidden="true">
//         <rect x="2" y="3" width="58" height="23" rx="7" fill="#f59e0b" />
//         <rect x="2" y="19" width="58" height="4" fill="#d97706" />
//         <rect x="8" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
//         <rect x="19" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
//         <rect x="30" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
//         <path d="M43 8h10a4 4 0 0 1 4 4v4H43z" fill="#0b1f44" />
//         <rect x="57" y="20" width="4" height="3" rx="1" fill="#fff7d6" />
//         <circle cx="17" cy="27" r="5.5" fill="#0b1f44" /><circle cx="17" cy="27" r="2.2" fill="#cbd5e1" />
//         <circle cx="46" cy="27" r="5.5" fill="#0b1f44" /><circle cx="46" cy="27" r="2.2" fill="#cbd5e1" />
//     </svg>
// );

// const Switch = ({ checked, onChange, title }) => (
//     <label className="prm-switch" title={title}>
//         <input type="checkbox" checked={checked} onChange={onChange} />
//         <span />
//     </label>
// );

// const SkeletonGrid = () => (
//     <div className="prm-grid">
//         {[0, 1, 2].map(i => (
//             <div className="prm-skel" key={i}>
//                 <div className="w40" />
//                 <div className="w60" />
//                 <div className="big" />
//                 <div />
//                 <div className="w60" />
//             </div>
//         ))}
//     </div>
// );

// const RouteCard = ({ route, index, onView, onToggle, onDelete }) => {
//     const startDay = route.departureDays?.[0];
//     return (
//         <div className={`prm-card ${route.isActive ? '' : 'inactive'}`} style={{ animationDelay: `${index * 90}ms` }}>
//             <div className="prm-card-top">
//                 <div>
//                     <div className="prm-card-no">Route #{String(route.serialNo).padStart(2, '0')}</div>
//                     <h3 className="prm-card-title">{route.routeName}</h3>
//                     <div className="prm-card-sub"><Icon name="tag" size={14} /> {route.localRouteName || 'No local name'}</div>
//                 </div>
//                 <span className={`prm-status ${route.isActive ? 'active' : 'inactive'}`}>{route.status}</span>
//             </div>

//             <div className="prm-journey">
//                 <div className="prm-journey-row">
//                     <div className="prm-place">
//                         <div className="prm-place-city">{route.originCity}</div>
//                         <div className="prm-place-time">{fmtTime(route.departureTime)}</div>
//                     </div>
//                     <div className="prm-path">
//                         <span className="dot start" />
//                         {route.stops > 0 && (
//                             <div className="prm-stop-pips">
//                                 {Array.from({ length: Math.min(route.stops, 4) }).map((_, i) => <i key={i} />)}
//                             </div>
//                         )}
//                         <span className="moving-bus"><BusSvg size={34} /></span>
//                         <span className="dot end" />
//                     </div>
//                     <div className="prm-place right">
//                         <div className="prm-place-city">{route.destinationCity}</div>
//                         <div className="prm-place-time">{fmtTime(route.arrivalTime)}</div>
//                     </div>
//                 </div>
//                 <div className="prm-journey-foot">
//                     <span>Departs</span>
//                     <span>Arrives {formatDayTime(route.arrivalDay, null, startDay).replace(/\s+$/, '')}</span>
//                 </div>
//             </div>

//             <div className="prm-days">
//                 {DAY_SHORT.map((d, i) => (
//                     <div key={d} className={`prm-day ${route.departureDays?.includes(i) ? 'on' : ''}`}>{d}</div>
//                 ))}
//             </div>

//             <div className="prm-metrics">
//                 <div className="prm-metric"><div className="v"><Icon name="pin" size={15} /> {route.distance} km</div><div className="l">Distance</div></div>
//                 <div className="prm-metric"><div className="v"><Icon name="clock" size={15} /> {route.duration}</div><div className="l">Duration</div></div>
//                 <div className="prm-metric"><div className="v"><Icon name="stop" size={15} /> {route.stops}</div><div className="l">Stops</div></div>
//             </div>

//             <div className="prm-card-foot">
//                 <Switch
//                     checked={route.isActive}
//                     onChange={() => onToggle(route.id, route.isActive)}
//                     title={route.isActive ? 'Click to deactivate' : 'Click to activate'}
//                 />
//                 <button className="prm-btn view" onClick={() => onView(route)}><Icon name="eye" size={16} /> View Details</button>
//                 <button className="prm-btn danger" onClick={() => onDelete(route.id)} title="Delete route"><Icon name="trash" size={16} /></button>
//             </div>
//         </div>
//     );
// };

// // ============================================================
// // FORM PRIMITIVES (redesigned)
// // ============================================================
// const FormSection = ({ n, title, hint, children, delay = 0 }) => (
//     <section className="prm-fsec" style={{ animationDelay: `${delay}ms` }}>
//         <header className="prm-fsec-head">
//             <span className="prm-fsec-num">{n}</span>
//             <div>
//                 <h4>{title}</h4>
//                 {hint && <p>{hint}</p>}
//             </div>
//         </header>
//         <div className="prm-fsec-body">{children}</div>
//     </section>
// );

// const Field = ({ label, required, children, full, note }) => (
//     <div className={`prm-field ${full ? 'full' : ''}`}>
//         {label && <label className="prm-label">{label}{required && <em>*</em>}</label>}
//         {children}
//         {note && <small className="prm-note">{note}</small>}
//     </div>
// );

// // ============================================================
// // DAY TIME PICKER — respects startDayIdx for labels
// // ============================================================
// const DayTimePicker = ({
//     day, time, onDayChange, onTimeChange,
//     placeholder = 'Select time', disabled = false,
//     maxDay = 7, minDay = 1, startDayIdx = null
// }) => {
//     const schedule = getWeeklySchedule(startDayIdx !== null ? [startDayIdx] : []);
//     const options = schedule.filter(s => s.dayNumber >= minDay && s.dayNumber <= maxDay);

//     return (
//         <div className="prm-dtp">
//             <select
//                 value={day || minDay}
//                 onChange={(e) => onDayChange(parseInt(e.target.value))}
//                 disabled={disabled}
//                 className="prm-input prm-select"
//             >
//                 {options.map(opt => (
//                     <option key={opt.dayNumber} value={opt.dayNumber}>
//                         {startDayIdx !== null
//                             ? `${opt.dayShort} (Day ${opt.dayNumber})`
//                             : `Day ${opt.dayNumber}`}
//                     </option>
//                 ))}
//             </select>
//             <input
//                 type="time"
//                 value={time || ''}
//                 onChange={(e) => onTimeChange(e.target.value)}
//                 className="prm-input"
//                 placeholder={placeholder}
//                 disabled={disabled}
//             />
//         </div>
//     );
// };

// // ============================================================
// // WEEKLY DAYS SELECTOR
// // ============================================================
// const WeeklyDaysSelector = ({ selectedDays, onChange, disabled }) => {
//     const toggle = (idx) => {
//         if (disabled) return;
//         const set = new Set(selectedDays || []);
//         if (set.has(idx)) set.delete(idx); else set.add(idx);
//         onChange([...set].sort((a, b) => a - b));
//     };
//     return (
//         <div className="prm-daypick">
//             {DAY_SHORT.map((d, idx) => {
//                 const active = (selectedDays || []).includes(idx);
//                 return (
//                     <button
//                         key={idx}
//                         type="button"
//                         onClick={() => toggle(idx)}
//                         disabled={disabled}
//                         className={`prm-daybtn ${active ? 'on' : ''}`}
//                     >
//                         {d}
//                     </button>
//                 );
//             })}
//         </div>
//     );
// };

// const Checkbox = ({ label, checked, onChange }) => (
//     <label className={`prm-check ${checked ? 'on' : ''}`}>
//         <input type="checkbox" checked={checked} onChange={onChange} />
//         <span className="box"><Icon name="check" size={12} /></span>
//         <span className="txt">{label}</span>
//     </label>
// );

// // ============================================================
// // STOP EDIT MODAL
// // ============================================================
// const PrimaryStopEditModal = ({
//     isOpen, stop, stopIndex, departureDays, startDayIdx,
//     onClose, onSave
// }) => {
//     const [form, setForm] = useState({
//         city: '', state: '', address: '', terminal: '',
//         arrivalDay: 1, arrivalTime: '', departureDay: 1, departureTime: '',
//         manualDistFromPrev: '', manualDistToNext: '',
//         isBoarding: false, isDropping: false
//     });

//     useEffect(() => {
//         if (!isOpen || !stop) return;
//         setForm({
//             city: stop.city || '',
//             state: stop.state || '',
//             address: stop.address || '',
//             terminal: stop.terminal || '',
//             arrivalDay: stop.arrivalDay || 1,
//             arrivalTime: stop.arrivalTime || '',
//             departureDay: stop.departureDay || stop.arrivalDay || 1,
//             departureTime: stop.departureTime || '',
//             manualDistFromPrev: stop.manualDistFromPrev || '',
//             manualDistToNext: stop.manualDistToNext || '',
//             isBoarding: stop.stopType === 'boarding' || stop.stopType === 'both',
//             isDropping: stop.stopType === 'dropping' || stop.stopType === 'both'
//         });
//     }, [isOpen, stop]);

//     if (!isOpen || !stop) return null;

//     const handleSave = () => {
//         if (!form.city) return toast.error('City is required');
//         if (!form.state) return toast.error('State is required');
//         if (!form.address) return toast.error('Address is required');
//         if (!form.terminal) return toast.error('Terminal is required');
//         if (!form.arrivalTime) return toast.error('Arrival time is required');

//         let stopType = 'none';
//         if (form.isBoarding && form.isDropping) stopType = 'both';
//         else if (form.isBoarding) stopType = 'boarding';
//         else if (form.isDropping) stopType = 'dropping';

//         onSave(stopIndex, {
//             ...stop,
//             city: form.city, state: form.state,
//             address: form.address, terminal: form.terminal,
//             arrivalDay: form.arrivalDay,
//             arrivalTime: form.arrivalTime,
//             departureDay: form.departureDay,
//             departureTime: form.departureTime || form.arrivalTime,
//             stopType,
//             manualDistFromPrev: form.manualDistFromPrev !== '' ? parseFloat(form.manualDistFromPrev) : stop.manualDistFromPrev,
//             manualDistToNext: form.manualDistToNext !== '' ? parseFloat(form.manualDistToNext) : stop.manualDistToNext
//         });
//         onClose();
//     };

//     return (
//         <div className="prm-overlay prm-overlay-top" onClick={onClose}>
//             <div className="prm-form-modal prm-form-modal-sm" onClick={(e) => e.stopPropagation()}>
//                 <div className="prm-form-head">
//                     <div className="prm-form-head-row">
//                         <span className="prm-form-badge"><Icon name="edit" size={22} /></span>
//                         <div>
//                             <h3>Edit Stop #{stopIndex + 1}</h3>
//                             <p>{stop.city}</p>
//                         </div>
//                     </div>
//                     <button className="prm-modal-close" onClick={onClose}>×</button>
//                 </div>

//                 <div className="prm-form-body">
//                     <section className="prm-fsec">
//                         <div className="prm-fsec-body">
//                             <div className="prm-fgrid">
//                                 <Field label="City" required full>
//                                     <input type="text" value={form.city} className="prm-input"
//                                         onChange={(e) => setForm(p => ({ ...p, city: e.target.value }))} />
//                                 </Field>
//                                 <Field label="State">
//                                     <input type="text" value={form.state} className="prm-input"
//                                         onChange={(e) => setForm(p => ({ ...p, state: e.target.value }))} />
//                                 </Field>
//                                 <Field label="Terminal">
//                                     <input type="text" value={form.terminal} className="prm-input"
//                                         onChange={(e) => setForm(p => ({ ...p, terminal: e.target.value }))} />
//                                 </Field>
//                                 <Field label="Address" full>
//                                     <input type="text" value={form.address} className="prm-input"
//                                         onChange={(e) => setForm(p => ({ ...p, address: e.target.value }))} />
//                                 </Field>
//                                 <Field label="Distance from Previous (km)">
//                                     <input type="number" value={form.manualDistFromPrev} className="prm-input" min="0" step="0.1"
//                                         onChange={(e) => setForm(p => ({ ...p, manualDistFromPrev: e.target.value }))} />
//                                 </Field>
//                                 <Field label="Distance to Next (km)">
//                                     <input type="number" value={form.manualDistToNext} className="prm-input" min="0" step="0.1"
//                                         onChange={(e) => setForm(p => ({ ...p, manualDistToNext: e.target.value }))} />
//                                 </Field>
//                                 <Field label="Arrival (Day + Time)" required>
//                                     <DayTimePicker
//                                         day={form.arrivalDay}
//                                         time={form.arrivalTime}
//                                         onDayChange={(d) => setForm(p => ({
//                                             ...p, arrivalDay: d,
//                                             departureDay: Math.max(d, p.departureDay || 1)
//                                         }))}
//                                         onTimeChange={(t) => setForm(p => ({ ...p, arrivalTime: t }))}
//                                         startDayIdx={startDayIdx}
//                                     />
//                                 </Field>
//                                 <Field label="Departure (Day + Time)">
//                                     <DayTimePicker
//                                         day={form.departureDay || form.arrivalDay}
//                                         time={form.departureTime}
//                                         onDayChange={(d) => setForm(p => ({ ...p, departureDay: d }))}
//                                         onTimeChange={(t) => setForm(p => ({ ...p, departureTime: t }))}
//                                         minDay={form.arrivalDay || 1}
//                                         startDayIdx={startDayIdx}
//                                     />
//                                 </Field>
//                             </div>

//                             {departureDays?.length > 0 && form.arrivalTime && (
//                                 <div className="prm-callout blue">
//                                     <Icon name="bus" size={16} />
//                                     <div>
//                                         <strong>Bus reaches this stop</strong>
//                                         <span>{formatOccurrences(form.arrivalDay, form.arrivalTime, departureDays)}</span>
//                                     </div>
//                                 </div>
//                             )}

//                             <div className="prm-checks">
//                                 <Checkbox label="Boarding Point" checked={form.isBoarding}
//                                     onChange={() => setForm(p => ({ ...p, isBoarding: !p.isBoarding }))} />
//                                 <Checkbox label="Dropping Point" checked={form.isDropping}
//                                     onChange={() => setForm(p => ({ ...p, isDropping: !p.isDropping }))} />
//                             </div>
//                         </div>
//                     </section>
//                 </div>

//                 <div className="prm-form-foot">
//                     <span />
//                     <div className="prm-form-foot-actions">
//                         <button className="prm-btn ghost" onClick={onClose}>Cancel</button>
//                         <button className="prm-btn primary" onClick={handleSave}>Save Changes</button>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// // ============================================================
// // LOCATION INPUT (dummy)
// // ============================================================
// const LocationInput = ({ value, onChange, placeholder, onLocationSelect }) => {
//     const [searchQuery, setSearchQuery] = useState(value || '');
//     const [suggestions, setSuggestions] = useState([]);
//     const [showSuggestions, setShowSuggestions] = useState(false);
//     const timeoutRef = useRef(null);

//     useEffect(() => { setSearchQuery(value || ''); }, [value]);

//     const searchLocations = (query) => {
//         if (!query || query.trim().length < 2) { setSuggestions([]); return; }
//         const filtered = DUMMY_CITY_SUGGESTIONS.filter(c =>
//             c.name.toLowerCase().includes(query.toLowerCase())
//         );
//         setSuggestions(filtered);
//         setShowSuggestions(filtered.length > 0);
//     };

//     const handleSelect = (city) => {
//         setSearchQuery(city.name);
//         setShowSuggestions(false);
//         if (onLocationSelect) {
//             onLocationSelect({
//                 name: city.name,
//                 address: city.address,
//                 city: city.name,
//                 state: city.state,
//                 terminal: city.terminal,
//                 coordinates: { lat: 20 + Math.random() * 10, lng: 75 + Math.random() * 10 }
//             });
//         }
//     };

//     const handleTextChange = (e) => {
//         const v = e.target.value;
//         setSearchQuery(v);
//         onChange(v);
//         if (timeoutRef.current) clearTimeout(timeoutRef.current);
//         timeoutRef.current = setTimeout(() => searchLocations(v), 300);
//     };

//     useEffect(() => () => { if (timeoutRef.current) clearTimeout(timeoutRef.current); }, []);

//     return (
//         <div className="prm-loc">
//             <span className="prm-loc-ico"><Icon name="search" size={16} /></span>
//             <input type="text" value={searchQuery}
//                 onChange={handleTextChange}
//                 onFocus={() => { if (suggestions.length > 0) setShowSuggestions(true); }}
//                 onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
//                 className="prm-input prm-loc-input" placeholder={placeholder} />
//             {showSuggestions && suggestions.length > 0 && (
//                 <div className="prm-loc-list">
//                     <div className="prm-loc-head">Suggestions</div>
//                     {suggestions.map((city, i) => (
//                         <div key={city.id || i} className="prm-loc-item" onClick={() => handleSelect(city)}>
//                             <span className="pin"><Icon name="pin" size={15} /></span>
//                             <div>
//                                 <div className="main">{city.name}</div>
//                                 <div className="sec">{city.state} • {city.terminal}</div>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             )}
//         </div>
//     );
// };

// // ============================================================
// // MAIN COMPONENT
// // ============================================================
// const PrimaryRouteManage = () => {
//     const { token } = useSelector(state => state.user);
//     const navigate = useNavigate();

//     const [viewMode, setViewMode] = useState('regular');
//     const [routes, setRoutes] = useState([]);
//     const [pendingRoutes] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [statusFilter, setStatusFilter] = useState('all'); // NEW: all | active | inactive
//     const [layout, setLayout] = useState('cards');            // NEW: cards | table
//     const [logModal, setLogModal] = useState({ show: false, routeId: null, routeName: '' });

//     const [showAddModal, setShowAddModal] = useState(false);
//     const [viewingRoute, setViewingRoute] = useState(null);

//     const [activeRouteTab, setActiveRouteTab] = useState('UP');
//     const [isManualStop, setIsManualStop] = useState(true);
//     const [isCalculatingDistances, setIsCalculatingDistances] = useState(false);
//     const [isDistanceCalculated, setIsDistanceCalculated] = useState({ up: false, down: false });
//     const [isCreatingRoute, setIsCreatingRoute] = useState(false);

//     const [upStops, setUpStops] = useState([]);
//     const [downStops, setDownStops] = useState([]);

//     const [stopEditModal, setStopEditModal] = useState({
//         isOpen: false, stop: null, index: null, type: 'up'
//     });

//     const [newRoute, setNewRoute] = useState({
//         routeName: '',
//         localRouteName: '',
//         departureDays: [1], // default Monday
//         upOriginCity: '', upOriginState: '', upOriginAddress: '', upOriginTerminal: '',
//         upOriginCoords: null, upOriginDepTime: '',
//         upDestCity: '', upDestState: '', upDestAddress: '', upDestTerminal: '',
//         upDestCoords: null, upDestArrDay: 1, upDestArrTime: '',
//         upTotalDistance: '', upDurationDays: 0, upDurationHours: '', upDurationMinutes: '',
//         stopCity: '', stopState: '', stopAddress: '', stopTerminal: '',
//         stopCoords: null, stopArrivalDay: 1, stopArrivalTime: '',
//         stopDepartureDay: 1, stopDepartureTime: '',
//         stopDistFromPrev: '', stopDistToNext: '',
//         isBoarding: false, isDropping: false
//     });

//     // ---- Load dummy data ----
//     useEffect(() => {
//         setLoading(true);
//         setTimeout(() => {
//             setRoutes(DUMMY_PRIMARY_ROUTES.map((r, i) => ({
//                 id: r._id,
//                 serialNo: i + 1,
//                 routeName: r.routeName,
//                 localRouteName: r.localRouteName,
//                 originCity: r.origin?.city || 'N/A',
//                 destinationCity: r.destination?.city || 'N/A',
//                 distance: r.routeDetails?.totalDistance || 0,
//                 durationDays: r.routeDetails?.estimatedDuration?.days || 0,
//                 durationHours: r.routeDetails?.estimatedDuration?.hours || 0,
//                 durationMinutes: r.routeDetails?.estimatedDuration?.minutes || 0,
//                 duration: `${r.routeDetails?.estimatedDuration?.days || 0}d ${r.routeDetails?.estimatedDuration?.hours || 0}h ${r.routeDetails?.estimatedDuration?.minutes || 0}m`,
//                 stops: r.intermediateStops?.length || 0,
//                 status: r.isActive ? 'Active' : 'Inactive',
//                 departureDays: r.departureDays || [],
//                 departureTime: r.origin?.departureTime || 'N/A',
//                 arrivalDay: r.destination?.arrivalDay || 1,
//                 arrivalTime: r.destination?.arrivalTime || 'N/A',
//                 isActive: r.isActive,
//                 isRoundTrip: r.isRoundTrip || false,
//                 fullData: r
//             })));
//             setLoading(false);
//         }, 700); // slightly longer so the skeleton loader is visible
//     }, []);

//     const getActiveStops = () => activeRouteTab === 'UP' ? upStops : downStops;
//     const setActiveStops = (stops) => {
//         if (activeRouteTab === 'UP') setUpStops(stops);
//         else setDownStops(stops);
//     };

//     // The starting day index for label purposes (first selected departure day)
//     const getStartDayIdx = () => {
//         const sorted = [...new Set(newRoute.departureDays || [])].sort((a, b) => a - b);
//         return sorted.length > 0 ? sorted[0] : null;
//     };

//     // ---- Handlers ----
//     const handleSelectOrigin = (loc) => {
//         setNewRoute(p => ({
//             ...p,
//             upOriginCity: loc.city || '',
//             upOriginState: loc.state || '',
//             upOriginAddress: loc.address || '',
//             upOriginTerminal: loc.terminal || '',
//             upOriginCoords: loc.coordinates || { lat: 0, lng: 0 }
//         }));
//         setIsDistanceCalculated(prev => ({ ...prev, up: false }));
//     };

//     const handleSelectDest = (loc) => {
//         setNewRoute(p => ({
//             ...p,
//             upDestCity: loc.city || '',
//             upDestState: loc.state || '',
//             upDestAddress: loc.address || '',
//             upDestTerminal: loc.terminal || '',
//             upDestCoords: loc.coordinates || { lat: 0, lng: 0 }
//         }));
//         setIsDistanceCalculated(prev => ({ ...prev, up: false }));
//     };

//     const handleSelectStop = (loc) => {
//         setNewRoute(p => ({
//             ...p,
//             stopCity: loc.city || '',
//             stopState: loc.state || p.stopState || '',
//             stopAddress: loc.address || '',
//             stopTerminal: loc.terminal || '',
//             stopCoords: loc.coordinates || { lat: 0, lng: 0 }
//         }));
//         setIsManualStop(false);
//     };

//     const clearStopForm = () => {
//         setNewRoute(p => ({
//             ...p,
//             stopCity: '', stopState: '', stopAddress: '', stopTerminal: '',
//             stopArrivalDay: 1, stopArrivalTime: '',
//             stopDepartureDay: 1, stopDepartureTime: '',
//             stopCoords: null, stopDistFromPrev: '', stopDistToNext: '',
//             isBoarding: false, isDropping: false
//         }));
//         setIsManualStop(true);
//     };

//     const addIntermediateStop = (type = 'up') => {
//         if (!newRoute.stopCity) return toast.error('City is required.');
//         if (!newRoute.stopArrivalTime) return toast.error('Arrival time is required.');

//         const stops = getActiveStops();
//         const isManualLocation = isManualStop || !newRoute.stopCoords ||
//             (newRoute.stopCoords.lat === 0 && newRoute.stopCoords.lng === 0);

//         let coordinates = newRoute.stopCoords;
//         let manualDistFromPrev = null;
//         let distanceFromOrigin = 0;

//         if (isManualLocation) {
//             if (!newRoute.stopDistFromPrev || parseFloat(newRoute.stopDistFromPrev) <= 0) {
//                 return toast.error('Please provide distance from previous stop');
//             }
//             coordinates = { lat: 0, lng: 0 };
//             manualDistFromPrev = parseFloat(newRoute.stopDistFromPrev);
//             if (stops.length > 0) {
//                 const last = stops[stops.length - 1];
//                 distanceFromOrigin = parseFloat(((last.distanceFromOrigin || 0) + manualDistFromPrev).toFixed(2));
//             } else {
//                 distanceFromOrigin = manualDistFromPrev;
//             }
//         }

//         let stopType = 'none';
//         if (newRoute.isBoarding && newRoute.isDropping) stopType = 'both';
//         else if (newRoute.isBoarding) stopType = 'boarding';
//         else if (newRoute.isDropping) stopType = 'dropping';

//         const newStop = {
//             city: newRoute.stopCity,
//             state: newRoute.stopState || '',
//             address: newRoute.stopAddress || `${newRoute.stopCity}, ${newRoute.stopState || 'India'}`,
//             terminal: newRoute.stopTerminal || `${newRoute.stopCity} Bus Stand`,
//             arrivalDay: newRoute.stopArrivalDay || 1,
//             arrivalTime: newRoute.stopArrivalTime,
//             departureDay: newRoute.stopDepartureDay || 1,
//             departureTime: newRoute.stopDepartureTime || newRoute.stopArrivalTime,
//             stopType,
//             coordinates,
//             manualDistFromPrev,
//             manualDistToNext: newRoute.stopDistToNext ? parseFloat(newRoute.stopDistToNext) : null,
//             distanceFromOrigin,
//             isManualStop: isManualLocation,
//             sequence: stops.length + 1
//         };

//         setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));
//         if (type === 'up') setUpStops([...upStops, newStop]);
//         else setDownStops([...downStops, newStop]);
//         toast.success(`Stop "${newRoute.stopCity}" added`);
//         clearStopForm();
//     };

//     const handleDeleteStop = (index) => {
//         const isUp = activeRouteTab === 'UP';
//         setIsDistanceCalculated(prev => ({ ...prev, [isUp ? 'up' : 'down']: false }));
//         if (isUp) setUpStops(upStops.filter((_, i) => i !== index));
//         else setDownStops(downStops.filter((_, i) => i !== index));
//     };

//     const handleOpenStopEditModal = (index) => {
//         const stops = getActiveStops();
//         const stop = stops[index];
//         if (!stop) return;
//         setStopEditModal({ isOpen: true, stop, index, type: activeRouteTab === 'UP' ? 'up' : 'down' });
//     };

//     const handleSaveEditedStop = (index, updatedStop) => {
//         const type = stopEditModal.type;
//         setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));
//         if (type === 'up') {
//             const u = [...upStops]; u[index] = { ...updatedStop, sequence: index + 1 };
//             setUpStops(u);
//         } else {
//             const u = [...downStops]; u[index] = { ...updatedStop, sequence: index + 1 };
//             setDownStops(u);
//         }
//         toast.success('Stop updated');
//     };

//     const handleCalculateDistances = () => {
//         const isUp = activeRouteTab === 'UP';
//         const stops = isUp ? upStops : downStops;
//         if (!newRoute.upOriginCity || !newRoute.upDestCity) {
//             return toast.error("Origin and Destination required.");
//         }
//         setIsCalculatingDistances(true);
//         toast.info(`Calculating ${activeRouteTab} distances...`);
//         setTimeout(() => {
//             let cumulative = 0;
//             const updated = stops.map(s => {
//                 const seg = (s.manualDistFromPrev && parseFloat(s.manualDistFromPrev)) ||
//                     parseFloat((Math.random() * 80 + 40).toFixed(1));
//                 cumulative += seg;
//                 return { ...s, distanceFromOrigin: parseFloat(cumulative.toFixed(1)) };
//             });
//             const total = cumulative + parseFloat((Math.random() * 100 + 50).toFixed(1));
//             setActiveStops(updated);
//             if (isUp) setNewRoute(p => ({ ...p, upTotalDistance: total.toFixed(1) }));
//             setIsDistanceCalculated(prev => ({ ...prev, up: true }));
//             toast.success(`Total: ${total.toFixed(1)} km (dummy)`);
//             setIsCalculatingDistances(false);
//         }, 500);
//     };

//     const handleSaveRoute = () => {
//         if (!newRoute.routeName) return toast.error('Route Name is required');
//         if (!newRoute.upOriginCity || !newRoute.upDestCity) {
//             return toast.error('Origin and Destination required');
//         }
//         if (!newRoute.departureDays || newRoute.departureDays.length === 0) {
//             return toast.error('Please select at least one departure day');
//         }
//         if (!newRoute.upOriginDepTime) return toast.error('Departure time required');
//         if (!newRoute.upDestArrTime) return toast.error('Destination arrival time required');
//         if (!isDistanceCalculated.up) return toast.error('Please calculate distances first');

//         setIsCreatingRoute(true);
//         setTimeout(() => {
//             const created = {
//                 _id: 'pr_' + Date.now(),
//                 routeName: newRoute.routeName.trim(),
//                 localRouteName: newRoute.localRouteName?.trim() || null,
//                 isPrimaryRoute: true,
//                 departureDays: [...new Set(newRoute.departureDays)].sort((a, b) => a - b),
//                 isActive: true,
//                 origin: {
//                     city: newRoute.upOriginCity, state: newRoute.upOriginState,
//                     terminal: newRoute.upOriginTerminal, address: newRoute.upOriginAddress,
//                     coordinates: newRoute.upOriginCoords,
//                     departureDay: 1, departureTime: newRoute.upOriginDepTime
//                 },
//                 destination: {
//                     city: newRoute.upDestCity, state: newRoute.upDestState,
//                     terminal: newRoute.upDestTerminal, address: newRoute.upDestAddress,
//                     coordinates: newRoute.upDestCoords,
//                     arrivalDay: newRoute.upDestArrDay || 1,
//                     arrivalTime: newRoute.upDestArrTime
//                 },
//                 intermediateStops: upStops,
//                 routeDetails: {
//                     totalDistance: parseFloat(newRoute.upTotalDistance || 0),
//                     estimatedDuration: {
//                         days: parseInt(newRoute.upDurationDays || 0, 10),
//                         hours: parseInt(newRoute.upDurationHours || 0, 10),
//                         minutes: parseInt(newRoute.upDurationMinutes || 0, 10)
//                     }
//                 },
//                 createdAt: new Date().toISOString(),
//                 updatedAt: new Date().toISOString()
//             };

//             setRoutes(prev => [...prev, {
//                 id: created._id,
//                 serialNo: prev.length + 1,
//                 routeName: created.routeName,
//                 localRouteName: created.localRouteName,
//                 originCity: created.origin.city,
//                 destinationCity: created.destination.city,
//                 distance: created.routeDetails.totalDistance,
//                 durationDays: created.routeDetails.estimatedDuration.days,
//                 durationHours: created.routeDetails.estimatedDuration.hours,
//                 durationMinutes: created.routeDetails.estimatedDuration.minutes,
//                 duration: `${created.routeDetails.estimatedDuration.days}d ${created.routeDetails.estimatedDuration.hours}h ${created.routeDetails.estimatedDuration.minutes}m`,
//                 stops: created.intermediateStops.length,
//                 status: 'Active', isActive: true,
//                 departureDays: created.departureDays,
//                 departureTime: created.origin.departureTime,
//                 arrivalDay: created.destination.arrivalDay,
//                 arrivalTime: created.destination.arrivalTime,
//                 isRoundTrip: false,
//                 fullData: created
//             }]);

//             toast.success('Primary route created (dummy)!');
//             setShowAddModal(false);
//             resetNewRouteForm();
//             setIsCreatingRoute(false);
//         }, 400);
//     };

//     const resetNewRouteForm = () => {
//         setNewRoute({
//             routeName: '', localRouteName: '', departureDays: [1],
//             upOriginCity: '', upOriginState: '', upOriginAddress: '', upOriginTerminal: '',
//             upOriginCoords: null, upOriginDepTime: '',
//             upDestCity: '', upDestState: '', upDestAddress: '', upDestTerminal: '',
//             upDestCoords: null, upDestArrDay: 1, upDestArrTime: '',
//             upTotalDistance: '', upDurationDays: 0, upDurationHours: '', upDurationMinutes: '',
//             stopCity: '', stopState: '', stopAddress: '', stopTerminal: '',
//             stopCoords: null, stopArrivalDay: 1, stopArrivalTime: '',
//             stopDepartureDay: 1, stopDepartureTime: '',
//             stopDistFromPrev: '', stopDistToNext: '',
//             isBoarding: false, isDropping: false
//         });
//         setUpStops([]); setDownStops([]);
//         setIsDistanceCalculated({ up: false, down: false });
//     };

//     const handleToggleStatus = (routeId, currentStatus) => {
//         const newStatus = !currentStatus;
//         if (!window.confirm(`Are you sure you want to ${newStatus ? 'activate' : 'deactivate'} this route?`)) return;
//         setRoutes(prev => prev.map(r => r.id === routeId
//             ? { ...r, isActive: newStatus, status: newStatus ? 'Active' : 'Inactive' } : r));
//         toast.success(`Route ${newStatus ? 'activated' : 'deactivated'} (dummy)!`);
//     };

//     const handleDeleteRoute = (routeId) => {
//         if (!window.confirm('Delete this route?')) return;
//         setRoutes(prev => prev.filter(r => r.id !== routeId));
//         toast.success('Route deleted (dummy)!');
//     };

//     const handleViewRoute = (route) => setViewingRoute(route.fullData || route);

//     const currentRoutes = viewMode === 'regular' ? routes : pendingRoutes;

//     // NEW: search + status filtering (search box now actually works)
//     const filteredRoutes = useMemo(() => {
//         const q = searchTerm.trim().toLowerCase();
//         return currentRoutes.filter(r => {
//             if (statusFilter === 'active' && !r.isActive) return false;
//             if (statusFilter === 'inactive' && r.isActive) return false;
//             if (!q) return true;
//             return [r.routeName, r.localRouteName, r.originCity, r.destinationCity]
//                 .filter(Boolean)
//                 .some(v => v.toLowerCase().includes(q));
//         });
//     }, [currentRoutes, searchTerm, statusFilter]);

//     const activeCount = currentRoutes.filter(r => r.isActive).length;

//     // progress of the Add Route form (shown in the popup header)
//     const formChecks = [
//         !!newRoute.routeName.trim(),
//         newRoute.departureDays.length > 0,
//         !!newRoute.upOriginCity && !!newRoute.upOriginDepTime,
//         !!newRoute.upDestCity && !!newRoute.upDestArrTime,
//         isDistanceCalculated.up
//     ];
//     const formProgress = Math.round((formChecks.filter(Boolean).length / formChecks.length) * 100);
//     const inactiveCount = currentRoutes.length - activeCount;

//     // ============================================================
//     // RENDER
//     // ============================================================
//     if (loading) {
//         return (
//             <div className="prm-page">
//                 <div className="prm-hero">
//                     <div className="prm-hero-text">
//                         <span className="prm-eyebrow"><Icon name="bus" size={13} /> Weekly Routes</span>
//                         <h1>Primary Route Management</h1>
//                         <p>Loading your routes…</p>
//                     </div>
//                 </div>
//                 <div style={{ height: 24 }} />
//                 <SkeletonGrid />
//             </div>
//         );
//     }

//     return (
//         <div className="prm-page">
//             {/* ===================== HERO HEADER ===================== */}
//             <div className="prm-hero">
//                 <div className="prm-hero-road" aria-hidden="true"><span className="prm-hero-roadbus"><BusSvg size={46} /></span></div>
//                 <div className="prm-hero-text">
//                     <span className="prm-eyebrow"><Icon name="map" size={13} /> Weekly Recurring Routes</span>
//                     <h1>Primary Route Management</h1>
//                     <p>Plan, schedule and manage your long-distance weekly bus routes — all days, stops and timings in one place.</p>
//                 </div>
//                 <div className="prm-hero-actions">
//                     <div className="prm-search">
//                         <Icon name="search" size={17} />
//                         <input
//                             type="text"
//                             placeholder="Search route, city or local name…"
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                         />
//                         {searchTerm && (
//                             <button className="prm-search-clear" onClick={() => setSearchTerm('')}>×</button>
//                         )}
//                     </div>
//                     <button className="prm-add-btn" onClick={() => setShowAddModal(true)}>
//                         <span className="plus"><Icon name="plus" size={14} /></span> Add Primary Route
//                     </button>
//                 </div>
//             </div>

//             {/* ===================== STATS ===================== */}
//             <div className="prm-stats">
//                 <StatCard icon="route" tone="indigo" label="Total Routes" value={routes.length} hint="All primary routes" delay={80} />
//                 <StatCard icon="check" tone="green" label="Active" value={routes.filter(r => r.isActive).length} hint="Currently running" delay={160} />
//                 <StatCard icon="moon" tone="amber" label="Multi-Day" value={routes.filter(r => r.durationDays > 0).length} hint="Routes longer than 24h" delay={240} />
//                 <StatCard icon="calendar" tone="cyan" label="Weekly Runs" value={routes.reduce((s, r) => s + (r.departureDays?.length || 0), 0)} hint="Total trips per week" delay={320} />
//             </div>

//             {/* ===================== TOOLBAR ===================== */}
//             <div className="prm-toolbar">
//                 <div className="prm-toolbar-left">
//                     <div className="prm-segment">
//                         <span className="prm-segment-pill"
//                             style={{ transform: `translateX(${viewMode === 'regular' ? 0 : 100}%)` }} />
//                         <button className={viewMode === 'regular' ? 'active' : ''} onClick={() => setViewMode('regular')}><Icon name="map" size={15} /> Regular</button>
//                         <button className={viewMode === 'pending' ? 'active' : ''} onClick={() => setViewMode('pending')}><Icon name="clipboard" size={15} /> Executive Submitted</button>
//                     </div>

//                     <div className="prm-chips">
//                         <button className={`prm-chip ${statusFilter === 'all' ? 'active' : ''}`} onClick={() => setStatusFilter('all')}>
//                             All <span className="count">{currentRoutes.length}</span>
//                         </button>
//                         <button className={`prm-chip ${statusFilter === 'active' ? 'active' : ''}`} onClick={() => setStatusFilter('active')}>
//                             Active <span className="count">{activeCount}</span>
//                         </button>
//                         <button className={`prm-chip ${statusFilter === 'inactive' ? 'active' : ''}`} onClick={() => setStatusFilter('inactive')}>
//                             Inactive <span className="count">{inactiveCount}</span>
//                         </button>
//                     </div>
//                 </div>

//                 <div className="prm-toolbar-right">
//                     <span className="prm-result-count">Showing <b>{filteredRoutes.length}</b> of {currentRoutes.length}</span>
//                     <div className="prm-layout-toggle">
//                         <button className={layout === 'cards' ? 'active' : ''} onClick={() => setLayout('cards')} title="Card view"><Icon name="grid" size={17} /></button>
//                         <button className={layout === 'table' ? 'active' : ''} onClick={() => setLayout('table')} title="Table view"><Icon name="list" size={17} /></button>
//                     </div>
//                 </div>
//             </div>

//             {/* ===================== ROUTES ===================== */}
//             {filteredRoutes.length === 0 ? (
//                 <div className="prm-empty">
//                     <div className="icon"><Icon name={searchTerm || statusFilter !== 'all' ? 'search' : 'bus'} size={44} /></div>
//                     <h3>{searchTerm || statusFilter !== 'all' ? 'No routes match your filters' : 'No routes yet'}</h3>
//                     <p>
//                         {searchTerm || statusFilter !== 'all'
//                             ? 'Try a different search term or clear the filters to see all routes.'
//                             : 'Create your first weekly primary route and start scheduling buses across the country.'}
//                     </p>
//                     {searchTerm || statusFilter !== 'all' ? (
//                         <button className="prm-btn ghost" onClick={() => { setSearchTerm(''); setStatusFilter('all'); }}>Clear filters</button>
//                     ) : (
//                         <button className="prm-add-btn" onClick={() => setShowAddModal(true)}>
//                             <span className="plus"><Icon name="plus" size={14} /></span> Add Primary Route
//                         </button>
//                     )}
//                 </div>
//             ) : layout === 'cards' ? (
//                 <div className="prm-grid">
//                     {filteredRoutes.map((route, i) => (
//                         <RouteCard
//                             key={route.id}
//                             route={route}
//                             index={i}
//                             onView={handleViewRoute}
//                             onToggle={handleToggleStatus}
//                             onDelete={handleDeleteRoute}
//                         />
//                     ))}
//                 </div>
//             ) : (
//                 <div className="prm-table-wrap">
//                     <table className="prm-table">
//                         <thead>
//                             <tr>
//                                 <th>No.</th><th>Route</th><th>Origin → Destination</th>
//                                 <th>Runs On</th><th>Departure</th><th>Duration</th>
//                                 <th>Stops</th><th>Status</th><th>Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {filteredRoutes.map((route, i) => (
//                                 <tr key={route.id} style={{ animationDelay: `${i * 70}ms` }}>
//                                     <td>{route.serialNo}</td>
//                                     <td>
//                                         <div className="name">{route.routeName}</div>
//                                         <div className="sub">{route.localRouteName || '—'}</div>
//                                     </td>
//                                     <td><b>{route.originCity}</b> → <b>{route.destinationCity}</b></td>
//                                     <td>
//                                         <div className="prm-mini-days">
//                                             {route.departureDays?.map(d => <span key={d}>{DAY_SHORT[d]}</span>)}
//                                         </div>
//                                     </td>
//                                     <td>
//                                         <div className="name">{fmtTime(route.departureTime)}</div>
//                                         <div className="sub">Arrives {formatDayTime(route.arrivalDay, route.arrivalTime, route.departureDays?.[0])}</div>
//                                     </td>
//                                     <td>{route.duration}</td>
//                                     <td>{route.stops}</td>
//                                     <td><span className={`prm-status ${route.isActive ? 'active' : 'inactive'}`}>{route.status}</span></td>
//                                     <td>
//                                         <div className="prm-row-actions">
//                                             <Switch checked={route.isActive} onChange={() => handleToggleStatus(route.id, route.isActive)} />
//                                             <button className="prm-btn ghost" onClick={() => handleViewRoute(route)}>View</button>
//                                             <button className="prm-btn danger" onClick={() => handleDeleteRoute(route.id)}><Icon name="trash" size={16} /></button>
//                                         </div>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             )}

//             {/* ============================================================
//                 ADD MODAL (redesigned)
//             ============================================================ */}
//             {showAddModal && (
//                 <div className="prm-overlay" onClick={() => setShowAddModal(false)}>
//                     <div className="prm-form-modal" onClick={(e) => e.stopPropagation()}>
//                         {/* ---- header + progress ---- */}
//                         <div className="prm-form-head">
//                             <div className="prm-form-head-row">
//                                 <span className="prm-form-badge"><Icon name="bus" size={24} /></span>
//                                 <div>
//                                     <h3>Create Weekly Primary Route</h3>
//                                     <p>Set up days, timings and stops once — repeated automatically every week.</p>
//                                 </div>
//                             </div>
//                             <button className="prm-modal-close" onClick={() => setShowAddModal(false)}>×</button>
//                             <div className="prm-progress">
//                                 <div className="prm-progress-bar"><i style={{ width: `${formProgress}%` }} /></div>
//                                 <span>{formProgress}% complete</span>
//                             </div>
//                         </div>

//                         {/* ---- body ---- */}
//                         <div className="prm-form-body">
//                             <div className="prm-callout amber">
//                                 <Icon name="info" size={18} />
//                                 <div>
//                                     <strong>Weekly Recurring Route</strong>
//                                     <span>
//                                         Pick which days of the week this route runs. Buses depart at the <b>same time</b> on
//                                         every selected day. All stop timings are entered once and auto-repeated.
//                                     </span>
//                                 </div>
//                             </div>

//                             {/* 1 — Route identity */}
//                             <FormSection n="1" title="Route Identity" hint="Name your route and choose the days it runs." delay={40}>
//                                 <div className="prm-fgrid">
//                                     <Field label="Route Name" required>
//                                         <input type="text" value={newRoute.routeName} className="prm-input"
//                                             onChange={(e) => setNewRoute(p => ({ ...p, routeName: e.target.value }))}
//                                             placeholder="e.g. Kalyani → Manali Weekly" />
//                                     </Field>
//                                     <Field label="Local Route Name">
//                                         <input type="text" value={newRoute.localRouteName} className="prm-input"
//                                             onChange={(e) => setNewRoute(p => ({ ...p, localRouteName: e.target.value }))}
//                                             placeholder="Optional local name" />
//                                     </Field>
//                                     <Field label="Runs on these days (pick 1 or more)" required full>
//                                         <WeeklyDaysSelector
//                                             selectedDays={newRoute.departureDays}
//                                             onChange={(days) => {
//                                                 if (days.length === 0) {
//                                                     toast.warning('At least one day required');
//                                                     return;
//                                                 }
//                                                 setNewRoute(p => ({ ...p, departureDays: days }));
//                                             }}
//                                         />
//                                         <small className="prm-note">
//                                             Selected: {newRoute.departureDays.length > 0
//                                                 ? newRoute.departureDays.map(d => DAY_NAMES[d]).join(', ')
//                                                 : 'None'}
//                                             {newRoute.departureDays.length > 0 && (
//                                                 <>
//                                                     {' '}— <strong>{DAY_SHORT[newRoute.departureDays[0]]}</strong> is treated as <strong>Day 1</strong> for stop offsets.
//                                                 </>
//                                             )}
//                                         </small>
//                                     </Field>
//                                 </div>
//                             </FormSection>

//                             {/* 2 + 3 — Origin & Destination side by side */}
//                             <div className="prm-cols">
//                                 <FormSection n="2" title="Origin" hint="Where the bus starts." delay={90}>
//                                     <div className="prm-fgrid one">
//                                         <Field label="Search location" required>
//                                             <LocationInput value={newRoute.upOriginCity}
//                                                 onChange={(v) => setNewRoute(p => ({ ...p, upOriginCity: v }))}
//                                                 onLocationSelect={handleSelectOrigin}
//                                                 placeholder="Search origin city..." />
//                                         </Field>
//                                         <Field label="State">
//                                             <input type="text" value={newRoute.upOriginState} className="prm-input"
//                                                 onChange={(e) => setNewRoute(p => ({ ...p, upOriginState: e.target.value }))} />
//                                         </Field>
//                                         <Field label="Terminal">
//                                             <input type="text" value={newRoute.upOriginTerminal} className="prm-input"
//                                                 onChange={(e) => setNewRoute(p => ({ ...p, upOriginTerminal: e.target.value }))} />
//                                         </Field>
//                                         <Field label="Departure time (same every selected day)" required>
//                                             <input type="time" value={newRoute.upOriginDepTime} className="prm-input"
//                                                 onChange={(e) => setNewRoute(p => ({ ...p, upOriginDepTime: e.target.value }))} />
//                                             {newRoute.departureDays.length > 0 && newRoute.upOriginDepTime && (
//                                                 <span className="prm-tag teal">
//                                                     {newRoute.departureDays.map(d => DAY_SHORT[d]).join(' · ')} at {fmtTime(newRoute.upOriginDepTime)}
//                                                 </span>
//                                             )}
//                                         </Field>
//                                     </div>
//                                 </FormSection>

//                                 <FormSection n="3" title="Destination" hint="Where the bus ends." delay={140}>
//                                     <div className="prm-fgrid one">
//                                         <Field label="Search location" required>
//                                             <LocationInput value={newRoute.upDestCity}
//                                                 onChange={(v) => setNewRoute(p => ({ ...p, upDestCity: v }))}
//                                                 onLocationSelect={handleSelectDest}
//                                                 placeholder="Search destination city..." />
//                                         </Field>
//                                         <Field label="State">
//                                             <input type="text" value={newRoute.upDestState} className="prm-input"
//                                                 onChange={(e) => setNewRoute(p => ({ ...p, upDestState: e.target.value }))} />
//                                         </Field>
//                                         <Field label="Terminal">
//                                             <input type="text" value={newRoute.upDestTerminal} className="prm-input"
//                                                 onChange={(e) => setNewRoute(p => ({ ...p, upDestTerminal: e.target.value }))} />
//                                         </Field>
//                                         <Field label="Arrival (day offset + time)" required>
//                                             <DayTimePicker
//                                                 day={newRoute.upDestArrDay}
//                                                 time={newRoute.upDestArrTime}
//                                                 onDayChange={(d) => setNewRoute(p => ({ ...p, upDestArrDay: d }))}
//                                                 onTimeChange={(t) => setNewRoute(p => ({ ...p, upDestArrTime: t }))}
//                                                 maxDay={7}
//                                                 minDay={1}
//                                                 startDayIdx={getStartDayIdx()}
//                                             />
//                                             {newRoute.departureDays.length > 0 && newRoute.upDestArrTime && (
//                                                 <span className="prm-tag amber">
//                                                     Arrives: {formatOccurrences(newRoute.upDestArrDay, newRoute.upDestArrTime, newRoute.departureDays)}
//                                                 </span>
//                                             )}
//                                         </Field>
//                                     </div>
//                                 </FormSection>
//                             </div>

//                             {/* 4 — Intermediate stops */}
//                             <FormSection n="4" title="Intermediate Stops" hint="Add boarding / dropping points between origin and destination." delay={190}>
//                                 <div className="prm-stop-list">
//                                     {getActiveStops().map((stop, index) => (
//                                         <div key={index} className="prm-stop-item">
//                                             <div className="prm-stop-num">{index + 1}</div>
//                                             <div className="prm-stop-info">
//                                                 <div className="prm-stop-name">
//                                                     {stop.city}
//                                                     <span className="prm-tag navy">{stop.distanceFromOrigin?.toFixed(1) || 0} km</span>
//                                                     {stop.stopType && stop.stopType !== 'none' && (
//                                                         <span className="prm-tag teal">{stop.stopType}</span>
//                                                     )}
//                                                 </div>
//                                                 <div className="prm-stop-times">
//                                                     Arr: {formatDayTime(stop.arrivalDay, stop.arrivalTime, getStartDayIdx())}
//                                                     <i>•</i>
//                                                     Dep: {formatDayTime(stop.departureDay, stop.departureTime, getStartDayIdx())}
//                                                 </div>
//                                                 {newRoute.departureDays.length > 0 && stop.arrivalTime && (
//                                                     <span className="prm-tag amber">
//                                                         <Icon name="clock" size={12} /> {formatOccurrences(stop.arrivalDay, stop.arrivalTime, newRoute.departureDays)}
//                                                     </span>
//                                                 )}
//                                             </div>
//                                             <div className="prm-stop-actions">
//                                                 <button className="prm-btn ghost sm" onClick={() => handleOpenStopEditModal(index)}>
//                                                     <Icon name="edit" size={14} /> Edit
//                                                 </button>
//                                                 <button className="prm-btn danger sm" onClick={() => handleDeleteStop(index)}>
//                                                     <Icon name="trash" size={14} />
//                                                 </button>
//                                             </div>
//                                         </div>
//                                     ))}
//                                     {getActiveStops().length === 0 && (
//                                         <div className="prm-stop-empty">
//                                             <Icon name="stop" size={22} />
//                                             <span>No intermediate stops yet — add one below (optional).</span>
//                                         </div>
//                                     )}
//                                 </div>

//                                 <div className="prm-addstop">
//                                     <div className="prm-addstop-head">
//                                         <h5><Icon name="plus" size={15} /> Add Intermediate Stop</h5>
//                                         <Checkbox label="Manually Typed Stop"
//                                             checked={!isManualStop}
//                                             onChange={() => setIsManualStop(!isManualStop)} />
//                                     </div>

//                                     <div className="prm-fgrid">
//                                         <Field label="City" required full>
//                                             <LocationInput value={newRoute.stopCity}
//                                                 onChange={(v) => setNewRoute(p => ({ ...p, stopCity: v }))}
//                                                 onLocationSelect={handleSelectStop}
//                                                 placeholder="Search stop city..." />
//                                         </Field>

//                                         {(isManualStop || !newRoute.stopCoords) && (
//                                             <Field label="Distance from previous stop (km)" required full>
//                                                 <input type="number" value={newRoute.stopDistFromPrev} className="prm-input" min="0" step="0.1"
//                                                     onChange={(e) => setNewRoute(p => ({ ...p, stopDistFromPrev: e.target.value }))} />
//                                             </Field>
//                                         )}

//                                         <Field label="State">
//                                             <input type="text" value={newRoute.stopState} className="prm-input"
//                                                 onChange={(e) => setNewRoute(p => ({ ...p, stopState: e.target.value }))} />
//                                         </Field>
//                                         <Field label="Terminal">
//                                             <input type="text" value={newRoute.stopTerminal} className="prm-input"
//                                                 onChange={(e) => setNewRoute(p => ({ ...p, stopTerminal: e.target.value }))} />
//                                         </Field>

//                                         <Field label="Arrival (day + time)" required>
//                                             <DayTimePicker
//                                                 day={newRoute.stopArrivalDay}
//                                                 time={newRoute.stopArrivalTime}
//                                                 onDayChange={(d) => setNewRoute(p => ({
//                                                     ...p, stopArrivalDay: d,
//                                                     stopDepartureDay: Math.max(d, p.stopDepartureDay || 1)
//                                                 }))}
//                                                 onTimeChange={(t) => setNewRoute(p => ({ ...p, stopArrivalTime: t }))}
//                                                 startDayIdx={getStartDayIdx()}
//                                             />
//                                         </Field>
//                                         <Field label="Departure (day + time)">
//                                             <DayTimePicker
//                                                 day={newRoute.stopDepartureDay}
//                                                 time={newRoute.stopDepartureTime}
//                                                 onDayChange={(d) => setNewRoute(p => ({ ...p, stopDepartureDay: d }))}
//                                                 onTimeChange={(t) => setNewRoute(p => ({ ...p, stopDepartureTime: t }))}
//                                                 minDay={newRoute.stopArrivalDay || 1}
//                                                 startDayIdx={getStartDayIdx()}
//                                             />
//                                         </Field>
//                                     </div>

//                                     {newRoute.departureDays.length > 0 && newRoute.stopArrivalTime && (
//                                         <div className="prm-callout teal">
//                                             <Icon name="check" size={16} />
//                                             <div>
//                                                 <strong>Bus will reach {newRoute.stopCity || 'this stop'} at</strong>
//                                                 <span>{formatOccurrences(newRoute.stopArrivalDay, newRoute.stopArrivalTime, newRoute.departureDays)}</span>
//                                             </div>
//                                         </div>
//                                     )}

//                                     <div className="prm-addstop-foot">
//                                         <div className="prm-checks">
//                                             <Checkbox label="Boarding Point" checked={newRoute.isBoarding}
//                                                 onChange={() => setNewRoute(p => ({ ...p, isBoarding: !p.isBoarding }))} />
//                                             <Checkbox label="Dropping Point" checked={newRoute.isDropping}
//                                                 onChange={() => setNewRoute(p => ({ ...p, isDropping: !p.isDropping }))} />
//                                         </div>
//                                         <button className="prm-btn view sm-fit"
//                                             onClick={() => addIntermediateStop('up')}
//                                             disabled={!newRoute.stopCity || !newRoute.stopArrivalTime}>
//                                             <Icon name="plus" size={15} /> Add Stop
//                                         </button>
//                                     </div>
//                                 </div>
//                             </FormSection>

//                             {/* 5 — Summary */}
//                             <FormSection n="5" title="Summary" hint="Calculate the total distance, then confirm the duration." delay={240}>
//                                 <div className="prm-summary">
//                                     <button className="prm-btn teal"
//                                         onClick={handleCalculateDistances}
//                                         disabled={isCalculatingDistances}>
//                                         <Icon name="calc" size={16} />
//                                         {isCalculatingDistances ? 'Calculating...' : 'Auto-Calculate Distances'}
//                                     </button>
//                                     <span className={`prm-tag ${isDistanceCalculated.up ? 'teal' : 'amber'}`}>
//                                         {isDistanceCalculated.up ? 'Distances calculated' : 'Not calculated yet'}
//                                     </span>
//                                 </div>

//                                 <div className="prm-fgrid">
//                                     <Field label="Total distance (KM)">
//                                         <input type="number" value={newRoute.upTotalDistance} className="prm-input" min="0" step="0.1"
//                                             onChange={(e) => setNewRoute(p => ({ ...p, upTotalDistance: e.target.value }))} />
//                                     </Field>
//                                     <Field label="Estimated duration">
//                                         <div className="prm-dur">
//                                             <input type="number" value={newRoute.upDurationDays} className="prm-input" placeholder="0" min="0" max="7"
//                                                 onChange={(e) => setNewRoute(p => ({ ...p, upDurationDays: Math.min(7, Math.max(0, parseInt(e.target.value) || 0)) }))} />
//                                             <span>days</span>
//                                             <input type="number" value={newRoute.upDurationHours} className="prm-input" placeholder="0" min="0" max="23"
//                                                 onChange={(e) => setNewRoute(p => ({ ...p, upDurationHours: Math.min(23, Math.max(0, parseInt(e.target.value) || 0)) }))} />
//                                             <span>h</span>
//                                             <input type="number" value={newRoute.upDurationMinutes} className="prm-input" placeholder="0" min="0" max="59"
//                                                 onChange={(e) => setNewRoute(p => ({ ...p, upDurationMinutes: Math.min(59, Math.max(0, parseInt(e.target.value) || 0)) }))} />
//                                             <span>m</span>
//                                         </div>
//                                     </Field>
//                                 </div>
//                             </FormSection>
//                         </div>

//                         {/* ---- sticky footer ---- */}
//                         <div className="prm-form-foot">
//                             <span className="prm-foot-hint">Fields marked <em>*</em> are required</span>
//                             <div className="prm-form-foot-actions">
//                                 <button className="prm-btn ghost" onClick={() => setShowAddModal(false)}>Cancel</button>
//                                 <button className="prm-btn primary" onClick={handleSaveRoute} disabled={isCreatingRoute}>
//                                     {isCreatingRoute ? 'Creating...' : <><Icon name="check" size={16} /> Add Primary Route</>}
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* ===================== VIEW MODAL (redesigned) ===================== */}
//             {viewingRoute && (
//                 <div className="prm-overlay" onClick={() => setViewingRoute(null)}>
//                     <div className="prm-modal" onClick={(e) => e.stopPropagation()}>
//                         <div className="prm-modal-head">
//                             <h3>{viewingRoute.routeName}</h3>
//                             <p><Icon name="tag" size={14} /> {viewingRoute.localRouteName || 'No local name'}</p>
//                             <button className="prm-modal-close" onClick={() => setViewingRoute(null)}>×</button>
//                         </div>

//                         <div className="prm-modal-body">
//                             <div className="prm-info-grid">
//                                 <div className="prm-info" style={{ animationDelay: '60ms' }}>
//                                     <div className="l">Distance</div>
//                                     <div className="v"><Icon name="pin" size={17} /> {viewingRoute.routeDetails?.totalDistance} km</div>
//                                 </div>
//                                 <div className="prm-info" style={{ animationDelay: '120ms' }}>
//                                     <div className="l">Duration</div>
//                                     <div className="v"><Icon name="clock" size={17} /> {viewingRoute.routeDetails?.estimatedDuration?.days || 0}d {viewingRoute.routeDetails?.estimatedDuration?.hours || 0}h {viewingRoute.routeDetails?.estimatedDuration?.minutes || 0}m</div>
//                                 </div>
//                                 <div className="prm-info" style={{ animationDelay: '180ms' }}>
//                                     <div className="l">Stops</div>
//                                     <div className="v"><Icon name="stop" size={17} /> {viewingRoute.intermediateStops?.length || 0}</div>
//                                 </div>
//                             </div>

//                             <div className="prm-section-title">Runs On</div>
//                             <div className="prm-days" style={{ marginBottom: 24 }}>
//                                 {DAY_SHORT.map((d, i) => (
//                                     <div key={d} className={`prm-day ${viewingRoute.departureDays?.includes(i) ? 'on' : ''}`}>{d}</div>
//                                 ))}
//                             </div>

//                             <div className="prm-section-title">Journey Timeline</div>
//                             <div className="prm-timeline">
//                                 <div className="prm-tl-item origin">
//                                     <div className="prm-tl-city">
//                                         {viewingRoute.origin?.city}
//                                         <small>{viewingRoute.origin?.terminal}</small>
//                                     </div>
//                                     <div className="prm-tl-time">
//                                         Departs <b>{fmtTime(viewingRoute.origin?.departureTime)}</b> on all selected days
//                                     </div>
//                                 </div>

//                                 {viewingRoute.intermediateStops?.map((s, i) => (
//                                     <div key={i} className="prm-tl-item stop" style={{ animationDelay: `${(i + 1) * 90}ms` }}>
//                                         <div className="prm-tl-city">
//                                             {s.sequence}. {s.city}
//                                             <small>{s.distanceFromOrigin?.toFixed(1)} km from origin</small>
//                                         </div>
//                                         <div className="prm-tl-time">
//                                             Arrives: {formatOccurrences(s.arrivalDay, s.arrivalTime, viewingRoute.departureDays)}
//                                         </div>
//                                     </div>
//                                 ))}

//                                 <div className="prm-tl-item dest" style={{ animationDelay: `${((viewingRoute.intermediateStops?.length || 0) + 1) * 90}ms` }}>
//                                     <div className="prm-tl-city">
//                                         {viewingRoute.destination?.city}
//                                         <small>{viewingRoute.destination?.terminal}</small>
//                                     </div>
//                                     <div className="prm-tl-time">
//                                         Arrives: {formatOccurrences(
//                                             viewingRoute.destination?.arrivalDay || 1,
//                                             viewingRoute.destination?.arrivalTime,
//                                             viewingRoute.departureDays
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="prm-modal-foot">
//                             <button className="prm-btn view" style={{ flex: 'none', padding: '11px 28px' }} onClick={() => setViewingRoute(null)}>Close</button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* STOP EDIT MODAL */}
//             <PrimaryStopEditModal
//                 isOpen={stopEditModal.isOpen}
//                 stop={stopEditModal.stop}
//                 stopIndex={stopEditModal.index}
//                 departureDays={newRoute.departureDays}
//                 startDayIdx={getStartDayIdx()}
//                 onClose={() => setStopEditModal({ isOpen: false, stop: null, index: null, type: 'up' })}
//                 onSave={handleSaveEditedStop}
//             />

//             {logModal.show && (
//                 <RouteActivityLogModal
//                     routeId={logModal.routeId}
//                     routeName={logModal.routeName}
//                     onClose={() => setLogModal({ show: false, routeId: null, routeName: '' })}
//                     token={token}
//                 />
//             )}
//         </div>
//     );
// };

// export default PrimaryRouteManage;

import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useSelector } from 'react-redux';
import '../../Styles/ManagementPages.css';
import { toast } from 'react-toastify';
import '../../Styles/RouteManage.css';
import '../../Styles/PrimaryRouteManage.css';
import { useNavigate } from 'react-router-dom';
import RouteActivityLogModal from './RouteActivityLogModal';

// ============================================================
// DUMMY DATA
// ============================================================
const DUMMY_CITY_SUGGESTIONS = [
    { id: 'c1', name: 'Kolkata', state: 'West Bengal', terminal: 'Esplanade', address: 'Esplanade, Kolkata' },
    { id: 'c2', name: 'Digha', state: 'West Bengal', terminal: 'Digha Bus Stand', address: 'Digha, WB' },
    { id: 'c3', name: 'Delhi', state: 'Delhi', terminal: 'Kashmere Gate', address: 'Kashmere Gate, Delhi' },
    { id: 'c4', name: 'Manali', state: 'HP', terminal: 'Volvo Stand', address: 'Manali, HP' },
    { id: 'c5', name: 'Kalyani', state: 'West Bengal', terminal: 'Kalyani Bus Stand', address: 'Kalyani, Nadia' },
    { id: 'c6', name: 'Durgapur', state: 'West Bengal', terminal: 'Durgapur City Centre', address: 'Durgapur, WB' },
    { id: 'c7', name: 'Chennai', state: 'Tamil Nadu', terminal: 'CMBT', address: 'CMBT, Chennai' },
    { id: 'c8', name: 'Mumbai', state: 'Maharashtra', terminal: 'Dadar', address: 'Dadar, Mumbai' },
    { id: 'c9', name: 'Bhubaneswar', state: 'Odisha', terminal: 'Baramunda', address: 'Baramunda, Odisha' },
    { id: 'c10', name: 'Varanasi', state: 'UP', terminal: 'Cantt', address: 'Varanasi Cantt' }
];

const DUMMY_PRIMARY_ROUTES = [
    {
        _id: 'pr_1',
        routeName: 'Kalyani → Manali Weekly',
        localRouteName: 'Himalayan Weekly',
        isPrimaryRoute: true,
        departureMode: 'weekly',
        departureDays: [1, 4],
        departureDates: [],
        isRoundTrip: false,
        isActive: true,
        origin: {
            city: 'Kalyani', state: 'West Bengal', terminal: 'Kalyani Bus Stand',
            departureDay: 1, departureTime: '21:00',
            coordinates: { lat: 22.9750, lng: 88.4345 }
        },
        destination: {
            city: 'Manali', state: 'HP', terminal: 'Volvo Stand',
            arrivalDay: 3, arrivalTime: '07:30',
            coordinates: { lat: 32.2432, lng: 77.1892 }
        },
        intermediateStops: [
            {
                sequence: 1, city: 'Durgapur', state: 'WB', terminal: 'City Centre',
                arrivalDay: 2, arrivalTime: '10:00',
                departureDay: 2, departureTime: '10:20',
                coordinates: { lat: 23.5204, lng: 87.3119 },
                distanceFromOrigin: 160, stopType: 'both'
            }
        ],
        routeDetails: { totalDistance: 1850, estimatedDuration: { days: 2, hours: 10, minutes: 30 } },
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
    },
    {
        _id: 'pr_2',
        routeName: 'Chennai → Kolkata Coastal Monthly',
        localRouteName: 'Coastal Monthly',
        isPrimaryRoute: true,
        departureMode: 'monthly',
        departureDays: [],
        departureDates: [5, 12, 26],
        isRoundTrip: false,
        isActive: true,
        origin: {
            city: 'Chennai', state: 'TN', terminal: 'CMBT',
            departureDay: 1, departureTime: '06:00',
            coordinates: { lat: 13.0827, lng: 80.2707 }
        },
        destination: {
            city: 'Kolkata', state: 'WB', terminal: 'Esplanade',
            arrivalDay: 3, arrivalTime: '14:00',
            coordinates: { lat: 22.5726, lng: 88.3639 }
        },
        intermediateStops: [],
        routeDetails: { totalDistance: 1670, estimatedDuration: { days: 2, hours: 8, minutes: 0 } },
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
    }
];

const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const DAY_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTH_DAY_LABELS = Array.from({ length: 31 }, (_, i) => i + 1);

// ---- Weekly helpers (unchanged) ----
const getWeeklySchedule = (departureDays = []) => {
    const sorted = [...new Set(departureDays)].sort((a, b) => a - b);
    const startIdx = sorted.length > 0 ? sorted[0] : 0;
    const list = [];
    for (let i = 0; i < 7; i++) {
        const dIdx = (startIdx + i) % 7;
        list.push({
            dayNumber: i + 1,
            dayName: DAY_NAMES[dIdx],
            dayShort: DAY_SHORT[dIdx],
            dayIndex: dIdx
        });
    }
    return list;
};

// ---- Monthly helpers (NEW) ----
const getMonthlySchedule = (selectedDates = []) => {
    const sorted = [...new Set(selectedDates)].sort((a, b) => a - b).slice(0, 7);
    return sorted.map((dateNum, idx) => ({
        dayNumber: idx + 1,
        dateNumber: dateNum,
        label: `Date ${dateNum}`
    }));
};

// Resolve an offset (Day 2, Day 3 …) into a readable label for either mode
const resolveOffsetLabel = (dayOffset, departureMode, departureDays, departureDates) => {
    if (!dayOffset) return '';
    if (departureMode === 'monthly') {
        const sorted = [...new Set(departureDates || [])].sort((a, b) => a - b);
        const dateNum = sorted[dayOffset - 1];
        return dateNum ? `Date ${dateNum} (Day ${dayOffset})` : `Day ${dayOffset}`;
    }
    const sorted = [...new Set(departureDays || [])].sort((a, b) => a - b);
    const startIdx = sorted.length > 0 ? sorted[0] : 0;
    const actualIdx = (startIdx + (dayOffset - 1)) % 7;
    return `${DAY_SHORT[actualIdx]} (Day ${dayOffset})`;
};

// Format occurrences list based on mode
const formatOccurrencesDynamic = (dayOffset, time, departureMode, departureDays, departureDates) => {
    if (!dayOffset || !time || !time.includes(':')) return '—';
    const [h, m] = time.split(':').map(Number);
    if (isNaN(h) || isNaN(m)) return '—';
    const ampm = h >= 12 ? 'PM' : 'AM';
    const dh = h % 12 || 12;
    const mm = String(m).padStart(2, '0');

    if (departureMode === 'monthly') {
        const sorted = [...new Set(departureDates || [])].sort((a, b) => a - b);
        const results = sorted
            .map(startDate => {
                const actualDate = startDate + (dayOffset - 1);
                if (actualDate > 31) return null;
                return `Date ${actualDate} ${dh}:${mm} ${ampm}`;
            })
            .filter(Boolean);
        return results.length > 0 ? results.join(' · ') : '—';
    }

    const sorted = [...new Set(departureDays || [])].sort((a, b) => a - b);
    return sorted
        .map(startIdx => {
            const actualIdx = (startIdx + (dayOffset - 1)) % 7;
            return `${DAY_SHORT[actualIdx]} ${dh}:${mm} ${ampm}`;
        })
        .join(' · ');
};

const formatDayTime = (dayNum, time, startDayIdx = null) => {
    if (!dayNum && !time) return '--:--';
    let prefix = '';
    if (dayNum) {
        if (typeof startDayIdx === 'number' && startDayIdx >= 0 && startDayIdx <= 6) {
            const idx = (startDayIdx + (dayNum - 1)) % 7;
            prefix = `${DAY_SHORT[idx]} (Day ${dayNum})`;
        } else {
            prefix = `Day ${dayNum}`;
        }
    }
    if (!time) return prefix || '--:--';
    if (time.includes(':')) {
        const [h, m] = time.split(':');
        const hour = parseInt(h);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const dh = hour % 12 || 12;
        return `${prefix} ${dh}:${m} ${ampm}`.trim();
    }
    return `${prefix} ${time}`.trim();
};

const formatOccurrences = (dayOffset, time, departureDays) =>
    formatOccurrencesDynamic(dayOffset, time, 'weekly', departureDays, []);

const fmtTime = (time) => {
    if (!time || !time.includes(':')) return time || '--:--';
    const [h, m] = time.split(':').map(Number);
    if (isNaN(h) || isNaN(m)) return time;
    return `${h % 12 || 12}:${String(m).padStart(2, '0')} ${h >= 12 ? 'PM' : 'AM'}`;
};

// ============================================================
// NEW — SMALL UI HELPERS
// ============================================================
const useCountUp = (target, duration = 900) => {
    const [value, setValue] = useState(0);
    useEffect(() => {
        let raf;
        let start;
        const step = (t) => {
            if (!start) start = t;
            const p = Math.min((t - start) / duration, 1);
            setValue(Math.round(target * (1 - Math.pow(1 - p, 3))));
            if (p < 1) raf = requestAnimationFrame(step);
        };
        raf = requestAnimationFrame(step);
        return () => cancelAnimationFrame(raf);
    }, [target, duration]);
    return value;
};

const ICON_PATHS = {
    route: 'M5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M19 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M7 17h7a3 3 0 0 0 0-6h-4a3 3 0 0 1 0-6h7',
    check: 'M22 11.1V12a10 10 0 1 1-5.9-9.1 M22 4 12 14l-3-3',
    moon: 'M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z',
    calendar: 'M8 2v4 M16 2v4 M3 10h18 M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z',
    pin: 'M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0z M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    clock: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 6v6l4 2',
    stop: 'M12 3v18 M5 6h11l3 3-3 3H5z',
    search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z M21 21l-4.3-4.3',
    eye: 'M2 12s4-8 10-8 10 8 10 8-4 8-10 8S2 12 2 12z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    trash: 'M3 6h18 M8 6V4h8v2 M6 6l1 14h10l1-14 M10 11v6 M14 11v6',
    grid: 'M3 3h7v7H3z M14 3h7v7h-7z M14 14h7v7h-7z M3 14h7v7H3z',
    list: 'M8 6h13 M8 12h13 M8 18h13 M3 6h.01 M3 12h.01 M3 18h.01',
    tag: 'M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z M7.5 7.5h.01',
    plus: 'M12 5v14 M5 12h14',
    map: 'M1 6l7-3 8 3 7-3v15l-7 3-8-3-7 3z M8 3v15 M16 6v15',
    clipboard: 'M9 4h6v3H9z M7 5H5a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2 M9 13h6 M9 17h4',
    bus: 'M5 3h14a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z M3 11h18 M7 21v-3 M17 21v-3 M7 15h.01 M17 15h.01',
    edit: 'M12 20h9 M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z',
    calc: 'M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z M8 7h8 M8 12h.01 M12 12h.01 M16 12h.01 M8 16h.01 M12 16h.01 M16 16h.01',
    info: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 16v-4 M12 8h.01'
};

const Icon = ({ name, size = 18 }) => (
    <svg className="prm-ico" viewBox="0 0 24 24" width={size} height={size} fill="none"
        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d={ICON_PATHS[name]} />
    </svg>
);

const BusSvg = ({ size = 34 }) => (
    <svg viewBox="0 0 64 34" width={size} height={(size * 34) / 64} aria-hidden="true">
        <rect x="2" y="3" width="58" height="23" rx="7" fill="#f59e0b" />
        <rect x="2" y="19" width="58" height="4" fill="#d97706" />
        <rect x="8" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
        <rect x="19" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
        <rect x="30" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
        <path d="M43 8h10a4 4 0 0 1 4 4v4H43z" fill="#0b1f44" />
        <rect x="57" y="20" width="4" height="3" rx="1" fill="#fff7d6" />
        <circle cx="17" cy="27" r="5.5" fill="#0b1f44" /><circle cx="17" cy="27" r="2.2" fill="#cbd5e1" />
        <circle cx="46" cy="27" r="5.5" fill="#0b1f44" /><circle cx="46" cy="27" r="2.2" fill="#cbd5e1" />
    </svg>
);

const StatCard = ({ icon, label, value, hint, tone, delay = 0 }) => {
    const shown = useCountUp(value);
    return (
        <div className={`prm-stat tone-${tone}`} style={{ animationDelay: `${delay}ms` }}>
            <div className="prm-stat-icon"><Icon name={icon} size={24} /></div>
            <div className="prm-stat-body">
                <div className="prm-stat-label">{label}</div>
                <div className="prm-stat-value">{shown}</div>
                <div className="prm-stat-hint">{hint}</div>
            </div>
        </div>
    );
};

const Switch = ({ checked, onChange, title }) => (
    <label className="prm-switch" title={title}>
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span />
    </label>
);

const SkeletonGrid = () => (
    <div className="prm-grid">
        {[0, 1, 2].map(i => (
            <div className="prm-skel" key={i}>
                <div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" />
            </div>
        ))}
    </div>
);

// ============================================================
// ROUTE CARD
// ============================================================
const RouteCard = ({ route, index, onView, onToggle, onDelete }) => {
    const startDay = route.departureDays?.[0];
    const isMonthly = route.departureMode === 'monthly';
    return (
        <div className={`prm-card ${route.isActive ? '' : 'inactive'}`} style={{ animationDelay: `${index * 90}ms` }}>
            <div className="prm-card-top">
                <div>
                    <div className="prm-card-no">Route #{String(route.serialNo).padStart(2, '0')}</div>
                    <h3 className="prm-card-title">{route.routeName}</h3>
                    <div className="prm-card-sub"><Icon name="tag" size={14} /> {route.localRouteName || 'No local name'}</div>
                </div>
                <span className={`prm-status ${route.isActive ? 'active' : 'inactive'}`}>{route.status}</span>
            </div>

            <div className="prm-journey">
                <div className="prm-journey-row">
                    <div className="prm-place">
                        <div className="prm-place-city">{route.originCity}</div>
                        <div className="prm-place-time">{fmtTime(route.departureTime)}</div>
                    </div>
                    <div className="prm-path">
                        <span className="dot start" />
                        {route.stops > 0 && (
                            <div className="prm-stop-pips">
                                {Array.from({ length: Math.min(route.stops, 4) }).map((_, i) => <i key={i} />)}
                            </div>
                        )}
                        <span className="moving-bus"><BusSvg size={34} /></span>
                        <span className="dot end" />
                    </div>
                    <div className="prm-place right">
                        <div className="prm-place-city">{route.destinationCity}</div>
                        <div className="prm-place-time">{fmtTime(route.arrivalTime)}</div>
                    </div>
                </div>
                <div className="prm-journey-foot">
                    <span>Departs</span>
                    <span>Arrives {formatDayTime(route.arrivalDay, null, startDay).replace(/\s+$/, '')}</span>
                </div>
            </div>

            {isMonthly ? (
                <div className="prm-month-chips">
                    {(route.departureDates || []).slice(0, 7).map(d => (
                        <span key={d} className="prm-month-chip">{d}</span>
                    ))}
                    {(route.departureDates || []).length > 7 && (
                        <span className="prm-month-chip more">+{(route.departureDates || []).length - 7}</span>
                    )}
                </div>
            ) : (
                <div className="prm-days">
                    {DAY_SHORT.map((d, i) => (
                        <div key={d} className={`prm-day ${route.departureDays?.includes(i) ? 'on' : ''}`}>{d}</div>
                    ))}
                </div>
            )}

            <div className="prm-metrics">
                <div className="prm-metric"><div className="v"><Icon name="pin" size={15} /> {route.distance} km</div><div className="l">Distance</div></div>
                <div className="prm-metric"><div className="v"><Icon name="clock" size={15} /> {route.duration}</div><div className="l">Duration</div></div>
                <div className="prm-metric"><div className="v"><Icon name="stop" size={15} /> {route.stops}</div><div className="l">Stops</div></div>
            </div>

            <div className="prm-card-foot">
                <Switch
                    checked={route.isActive}
                    onChange={() => onToggle(route.id, route.isActive)}
                    title={route.isActive ? 'Click to deactivate' : 'Click to activate'}
                />
                <button className="prm-btn view" onClick={() => onView(route)}><Icon name="eye" size={16} /> View Details</button>
                <button className="prm-btn danger" onClick={() => onDelete(route.id)} title="Delete route"><Icon name="trash" size={16} /></button>
            </div>
        </div>
    );
};

// ============================================================
// FORM PRIMITIVES
// ============================================================
const FormSection = ({ n, title, hint, children, delay = 0 }) => (
    <section className="prm-fsec" style={{ animationDelay: `${delay}ms` }}>
        <header className="prm-fsec-head">
            <span className="prm-fsec-num">{n}</span>
            <div>
                <h4>{title}</h4>
                {hint && <p>{hint}</p>}
            </div>
        </header>
        <div className="prm-fsec-body">{children}</div>
    </section>
);

const Field = ({ label, required, children, full, note }) => (
    <div className={`prm-field ${full ? 'full' : ''}`}>
        {label && <label className="prm-label">{label}{required && <em>*</em>}</label>}
        {children}
        {note && <small className="prm-note">{note}</small>}
    </div>
);

// ============================================================
// DAY TIME PICKER — mode-aware
// ============================================================
const DayTimePicker = ({
    day, time, onDayChange, onTimeChange,
    placeholder = 'Select time', disabled = false,
    maxDay = 7, minDay = 1, startDayIdx = null,
    departureMode = 'weekly', departureDates = []
}) => {
    const weeklyOptions = getWeeklySchedule(startDayIdx !== null ? [startDayIdx] : [])
        .filter(s => s.dayNumber >= minDay && s.dayNumber <= maxDay);
    const monthlyOptions = getMonthlySchedule(departureDates)
        .filter(s => s.dayNumber >= minDay && s.dayNumber <= maxDay);
    const options = departureMode === 'monthly' ? monthlyOptions : weeklyOptions;

    return (
        <div className="prm-dtp">
            <select
                value={day || minDay}
                onChange={(e) => onDayChange(parseInt(e.target.value))}
                disabled={disabled}
                className="prm-input prm-select"
            >
                {options.length === 0 && (
                    <option value={minDay}>Day {minDay}</option>
                )}
                {options.map(opt => (
                    <option key={opt.dayNumber} value={opt.dayNumber}>
                        {departureMode === 'monthly'
                            ? `${opt.label} (Day ${opt.dayNumber})`
                            : (startDayIdx !== null ? `${opt.dayShort} (Day ${opt.dayNumber})` : `Day ${opt.dayNumber}`)}
                    </option>
                ))}
            </select>
            <input
                type="time"
                value={time || ''}
                onChange={(e) => onTimeChange(e.target.value)}
                className="prm-input"
                placeholder={placeholder}
                disabled={disabled}
            />
        </div>
    );
};

// ============================================================
// WEEKLY DAYS SELECTOR
// ============================================================
const WeeklyDaysSelector = ({ selectedDays, onChange, disabled }) => {
    const toggle = (idx) => {
        if (disabled) return;
        const set = new Set(selectedDays || []);
        if (set.has(idx)) set.delete(idx); else set.add(idx);
        onChange([...set].sort((a, b) => a - b));
    };
    return (
        <div className="prm-daypick">
            {DAY_SHORT.map((d, idx) => {
                const active = (selectedDays || []).includes(idx);
                return (
                    <button
                        key={idx}
                        type="button"
                        onClick={() => toggle(idx)}
                        disabled={disabled}
                        className={`prm-daybtn ${active ? 'on' : ''}`}
                    >
                        {d}
                    </button>
                );
            })}
        </div>
    );
};

// ============================================================
// MONTHLY DATES SELECTOR (NEW)
// ============================================================
const MonthlyDatesSelector = ({ selectedDates, onChange, disabled }) => {
    const toggle = (dateNum) => {
        if (disabled) return;
        const set = new Set(selectedDates || []);
        if (set.has(dateNum)) set.delete(dateNum); else set.add(dateNum);
        onChange([...set].sort((a, b) => a - b));
    };
    return (
        <div className="prm-monthpick">
            {MONTH_DAY_LABELS.map(d => {
                const active = (selectedDates || []).includes(d);
                return (
                    <button
                        key={d}
                        type="button"
                        onClick={() => toggle(d)}
                        disabled={disabled}
                        className={`prm-monthbtn ${active ? 'on' : ''}`}
                    >
                        {d}
                    </button>
                );
            })}
        </div>
    );
};

const Checkbox = ({ label, checked, onChange }) => (
    <label className={`prm-check ${checked ? 'on' : ''}`}>
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span className="box"><Icon name="check" size={12} /></span>
        <span className="txt">{label}</span>
    </label>
);

// ============================================================
// STOP EDIT MODAL — mode-aware occurrences
// ============================================================
const PrimaryStopEditModal = ({
    isOpen, stop, stopIndex, departureDays, departureDates,
    departureMode = 'weekly', startDayIdx, onClose, onSave
}) => {
    const [form, setForm] = useState({
        city: '', state: '', address: '', terminal: '',
        arrivalDay: 1, arrivalTime: '', departureDay: 1, departureTime: '',
        manualDistFromPrev: '', manualDistToNext: '',
        isBoarding: false, isDropping: false
    });

    useEffect(() => {
        if (!isOpen || !stop) return;
        setForm({
            city: stop.city || '',
            state: stop.state || '',
            address: stop.address || '',
            terminal: stop.terminal || '',
            arrivalDay: stop.arrivalDay || 1,
            arrivalTime: stop.arrivalTime || '',
            departureDay: stop.departureDay || stop.arrivalDay || 1,
            departureTime: stop.departureTime || '',
            manualDistFromPrev: stop.manualDistFromPrev || '',
            manualDistToNext: stop.manualDistToNext || '',
            isBoarding: stop.stopType === 'boarding' || stop.stopType === 'both',
            isDropping: stop.stopType === 'dropping' || stop.stopType === 'both'
        });
    }, [isOpen, stop]);

    if (!isOpen || !stop) return null;

    const handleSave = () => {
        if (!form.city) return toast.error('City is required');
        if (!form.state) return toast.error('State is required');
        if (!form.address) return toast.error('Address is required');
        if (!form.terminal) return toast.error('Terminal is required');
        if (!form.arrivalTime) return toast.error('Arrival time is required');

        let stopType = 'none';
        if (form.isBoarding && form.isDropping) stopType = 'both';
        else if (form.isBoarding) stopType = 'boarding';
        else if (form.isDropping) stopType = 'dropping';

        onSave(stopIndex, {
            ...stop,
            city: form.city, state: form.state,
            address: form.address, terminal: form.terminal,
            arrivalDay: form.arrivalDay,
            arrivalTime: form.arrivalTime,
            departureDay: form.departureDay,
            departureTime: form.departureTime || form.arrivalTime,
            stopType,
            manualDistFromPrev: form.manualDistFromPrev !== '' ? parseFloat(form.manualDistFromPrev) : stop.manualDistFromPrev,
            manualDistToNext: form.manualDistToNext !== '' ? parseFloat(form.manualDistToNext) : stop.manualDistToNext
        });
        onClose();
    };

    const hasSchedule = departureMode === 'monthly'
        ? (departureDates || []).length > 0
        : (departureDays || []).length > 0;

    return (
        <div className="prm-overlay prm-overlay-top" onClick={onClose}>
            <div className="prm-form-modal prm-form-modal-sm" onClick={(e) => e.stopPropagation()}>
                <div className="prm-form-head">
                    <div className="prm-form-head-row">
                        <span className="prm-form-badge"><Icon name="edit" size={22} /></span>
                        <div>
                            <h3>Edit Stop #{stopIndex + 1}</h3>
                            <p>{stop.city}</p>
                        </div>
                    </div>
                    <button className="prm-modal-close" onClick={onClose}>×</button>
                </div>

                <div className="prm-form-body">
                    <section className="prm-fsec">
                        <div className="prm-fsec-body">
                            <div className="prm-fgrid">
                                <Field label="City" required full>
                                    <input type="text" value={form.city} className="prm-input"
                                        onChange={(e) => setForm(p => ({ ...p, city: e.target.value }))} />
                                </Field>
                                <Field label="State">
                                    <input type="text" value={form.state} className="prm-input"
                                        onChange={(e) => setForm(p => ({ ...p, state: e.target.value }))} />
                                </Field>
                                <Field label="Terminal">
                                    <input type="text" value={form.terminal} className="prm-input"
                                        onChange={(e) => setForm(p => ({ ...p, terminal: e.target.value }))} />
                                </Field>
                                <Field label="Address" full>
                                    <input type="text" value={form.address} className="prm-input"
                                        onChange={(e) => setForm(p => ({ ...p, address: e.target.value }))} />
                                </Field>
                                <Field label="Distance from Previous (km)">
                                    <input type="number" value={form.manualDistFromPrev} className="prm-input" min="0" step="0.1"
                                        onChange={(e) => setForm(p => ({ ...p, manualDistFromPrev: e.target.value }))} />
                                </Field>
                                <Field label="Distance to Next (km)">
                                    <input type="number" value={form.manualDistToNext} className="prm-input" min="0" step="0.1"
                                        onChange={(e) => setForm(p => ({ ...p, manualDistToNext: e.target.value }))} />
                                </Field>
                                <Field label="Arrival (Day + Time)" required>
                                    <DayTimePicker
                                        day={form.arrivalDay}
                                        time={form.arrivalTime}
                                        onDayChange={(d) => setForm(p => ({
                                            ...p, arrivalDay: d,
                                            departureDay: Math.max(d, p.departureDay || 1)
                                        }))}
                                        onTimeChange={(t) => setForm(p => ({ ...p, arrivalTime: t }))}
                                        startDayIdx={startDayIdx}
                                        departureMode={departureMode}
                                        departureDates={departureDates}
                                    />
                                </Field>
                                <Field label="Departure (Day + Time)">
                                    <DayTimePicker
                                        day={form.departureDay || form.arrivalDay}
                                        time={form.departureTime}
                                        onDayChange={(d) => setForm(p => ({ ...p, departureDay: d }))}
                                        onTimeChange={(t) => setForm(p => ({ ...p, departureTime: t }))}
                                        minDay={form.arrivalDay || 1}
                                        startDayIdx={startDayIdx}
                                        departureMode={departureMode}
                                        departureDates={departureDates}
                                    />
                                </Field>
                            </div>

                            {hasSchedule && form.arrivalTime && (
                                <div className="prm-callout blue">
                                    <Icon name="bus" size={16} />
                                    <div>
                                        <strong>Bus reaches this stop</strong>
                                        <span>
                                            {formatOccurrencesDynamic(
                                                form.arrivalDay, form.arrivalTime,
                                                departureMode, departureDays, departureDates
                                            )}
                                        </span>
                                    </div>
                                </div>
                            )}

                            <div className="prm-checks">
                                <Checkbox label="Boarding Point" checked={form.isBoarding}
                                    onChange={() => setForm(p => ({ ...p, isBoarding: !p.isBoarding }))} />
                                <Checkbox label="Dropping Point" checked={form.isDropping}
                                    onChange={() => setForm(p => ({ ...p, isDropping: !p.isDropping }))} />
                            </div>
                        </div>
                    </section>
                </div>

                <div className="prm-form-foot">
                    <span />
                    <div className="prm-form-foot-actions">
                        <button className="prm-btn ghost" onClick={onClose}>Cancel</button>
                        <button className="prm-btn primary" onClick={handleSave}>Save Changes</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

// ============================================================
// LOCATION INPUT
// ============================================================
const LocationInput = ({ value, onChange, placeholder, onLocationSelect }) => {
    const [searchQuery, setSearchQuery] = useState(value || '');
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => { setSearchQuery(value || ''); }, [value]);

    const searchLocations = (query) => {
        if (!query || query.trim().length < 2) { setSuggestions([]); return; }
        const filtered = DUMMY_CITY_SUGGESTIONS.filter(c =>
            c.name.toLowerCase().includes(query.toLowerCase())
        );
        setSuggestions(filtered);
        setShowSuggestions(filtered.length > 0);
    };

    const handleSelect = (city) => {
        setSearchQuery(city.name);
        setShowSuggestions(false);
        if (onLocationSelect) {
            onLocationSelect({
                name: city.name,
                address: city.address,
                city: city.name,
                state: city.state,
                terminal: city.terminal,
                coordinates: { lat: 20 + Math.random() * 10, lng: 75 + Math.random() * 10 }
            });
        }
    };

    const handleTextChange = (e) => {
        const v = e.target.value;
        setSearchQuery(v);
        onChange(v);
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => searchLocations(v), 300);
    };

    useEffect(() => () => { if (timeoutRef.current) clearTimeout(timeoutRef.current); }, []);

    return (
        <div className="prm-loc">
            <span className="prm-loc-ico"><Icon name="search" size={16} /></span>
            <input type="text" value={searchQuery}
                onChange={handleTextChange}
                onFocus={() => { if (suggestions.length > 0) setShowSuggestions(true); }}
                onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                className="prm-input prm-loc-input" placeholder={placeholder} />
            {showSuggestions && suggestions.length > 0 && (
                <div className="prm-loc-list">
                    <div className="prm-loc-head">Suggestions</div>
                    {suggestions.map((city, i) => (
                        <div key={city.id || i} className="prm-loc-item" onClick={() => handleSelect(city)}>
                            <span className="pin"><Icon name="pin" size={15} /></span>
                            <div>
                                <div className="main">{city.name}</div>
                                <div className="sec">{city.state} • {city.terminal}</div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

// ============================================================
// MAIN COMPONENT
// ============================================================
const PrimaryRouteManage = () => {
    const { token } = useSelector(state => state.user);
    const navigate = useNavigate();

    const [viewMode, setViewMode] = useState('regular');
    const [routes, setRoutes] = useState([]);
    const [pendingRoutes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('all');
    const [layout, setLayout] = useState('cards');
    const [logModal, setLogModal] = useState({ show: false, routeId: null, routeName: '' });

    const [showAddModal, setShowAddModal] = useState(false);
    const [viewingRoute, setViewingRoute] = useState(null);

    const [activeRouteTab, setActiveRouteTab] = useState('UP');
    const [isManualStop, setIsManualStop] = useState(true);
    const [isCalculatingDistances, setIsCalculatingDistances] = useState(false);
    const [isDistanceCalculated, setIsDistanceCalculated] = useState({ up: false, down: false });
    const [isCreatingRoute, setIsCreatingRoute] = useState(false);

    const [upStops, setUpStops] = useState([]);
    const [downStops, setDownStops] = useState([]);

    const [stopEditModal, setStopEditModal] = useState({
        isOpen: false, stop: null, index: null, type: 'up'
    });

    const [newRoute, setNewRoute] = useState({
        routeName: '',
        localRouteName: '',

        // ⭐ Departure mode
        departureMode: 'weekly',
        departureDays: [1],
        departureDates: [],

        upOriginCity: '', upOriginState: '', upOriginAddress: '', upOriginTerminal: '',
        upOriginCoords: null, upOriginDepTime: '',
        upDestCity: '', upDestState: '', upDestAddress: '', upDestTerminal: '',
        upDestCoords: null, upDestArrDay: 1, upDestArrTime: '',
        upTotalDistance: '', upDurationDays: 0, upDurationHours: '', upDurationMinutes: '',
        stopCity: '', stopState: '', stopAddress: '', stopTerminal: '',
        stopCoords: null, stopArrivalDay: 1, stopArrivalTime: '',
        stopDepartureDay: 1, stopDepartureTime: '',
        stopDistFromPrev: '', stopDistToNext: '',
        isBoarding: false, isDropping: false
    });

    // ---- Load dummy data ----
    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setRoutes(DUMMY_PRIMARY_ROUTES.map((r, i) => ({
                id: r._id,
                serialNo: i + 1,
                routeName: r.routeName,
                localRouteName: r.localRouteName,
                originCity: r.origin?.city || 'N/A',
                destinationCity: r.destination?.city || 'N/A',
                distance: r.routeDetails?.totalDistance || 0,
                durationDays: r.routeDetails?.estimatedDuration?.days || 0,
                durationHours: r.routeDetails?.estimatedDuration?.hours || 0,
                durationMinutes: r.routeDetails?.estimatedDuration?.minutes || 0,
                duration: `${r.routeDetails?.estimatedDuration?.days || 0}d ${r.routeDetails?.estimatedDuration?.hours || 0}h ${r.routeDetails?.estimatedDuration?.minutes || 0}m`,
                stops: r.intermediateStops?.length || 0,
                status: r.isActive ? 'Active' : 'Inactive',
                departureMode: r.departureMode || 'weekly',
                departureDays: r.departureDays || [],
                departureDates: r.departureDates || [],
                departureTime: r.origin?.departureTime || 'N/A',
                arrivalDay: r.destination?.arrivalDay || 1,
                arrivalTime: r.destination?.arrivalTime || 'N/A',
                isActive: r.isActive,
                isRoundTrip: r.isRoundTrip || false,
                fullData: r
            })));
            setLoading(false);
        }, 700);
    }, []);

    const getActiveStops = () => activeRouteTab === 'UP' ? upStops : downStops;
    const setActiveStops = (stops) => {
        if (activeRouteTab === 'UP') setUpStops(stops);
        else setDownStops(stops);
    };

    // First offset anchor for labels (weekly → day index; monthly → null)
    const getStartDayIdx = () => {
        if (newRoute.departureMode === 'monthly') return null;
        const sorted = [...new Set(newRoute.departureDays || [])].sort((a, b) => a - b);
        return sorted.length > 0 ? sorted[0] : null;
    };

    const hasScheduleSelected = () =>
        newRoute.departureMode === 'monthly'
            ? (newRoute.departureDates || []).length > 0
            : (newRoute.departureDays || []).length > 0;

    // ---- Handlers ----
    const handleSelectOrigin = (loc) => {
        setNewRoute(p => ({
            ...p,
            upOriginCity: loc.city || '',
            upOriginState: loc.state || '',
            upOriginAddress: loc.address || '',
            upOriginTerminal: loc.terminal || '',
            upOriginCoords: loc.coordinates || { lat: 0, lng: 0 }
        }));
        setIsDistanceCalculated(prev => ({ ...prev, up: false }));
    };

    const handleSelectDest = (loc) => {
        setNewRoute(p => ({
            ...p,
            upDestCity: loc.city || '',
            upDestState: loc.state || '',
            upDestAddress: loc.address || '',
            upDestTerminal: loc.terminal || '',
            upDestCoords: loc.coordinates || { lat: 0, lng: 0 }
        }));
        setIsDistanceCalculated(prev => ({ ...prev, up: false }));
    };

    const handleSelectStop = (loc) => {
        setNewRoute(p => ({
            ...p,
            stopCity: loc.city || '',
            stopState: loc.state || p.stopState || '',
            stopAddress: loc.address || '',
            stopTerminal: loc.terminal || '',
            stopCoords: loc.coordinates || { lat: 0, lng: 0 }
        }));
        setIsManualStop(false);
    };

    const clearStopForm = () => {
        setNewRoute(p => ({
            ...p,
            stopCity: '', stopState: '', stopAddress: '', stopTerminal: '',
            stopArrivalDay: 1, stopArrivalTime: '',
            stopDepartureDay: 1, stopDepartureTime: '',
            stopCoords: null, stopDistFromPrev: '', stopDistToNext: '',
            isBoarding: false, isDropping: false
        }));
        setIsManualStop(true);
    };

    const addIntermediateStop = (type = 'up') => {
        if (!newRoute.stopCity) return toast.error('City is required.');
        if (!newRoute.stopArrivalTime) return toast.error('Arrival time is required.');

        const stops = getActiveStops();
        const isManualLocation = isManualStop || !newRoute.stopCoords ||
            (newRoute.stopCoords.lat === 0 && newRoute.stopCoords.lng === 0);

        let coordinates = newRoute.stopCoords;
        let manualDistFromPrev = null;
        let distanceFromOrigin = 0;

        if (isManualLocation) {
            if (!newRoute.stopDistFromPrev || parseFloat(newRoute.stopDistFromPrev) <= 0) {
                return toast.error('Please provide distance from previous stop');
            }
            coordinates = { lat: 0, lng: 0 };
            manualDistFromPrev = parseFloat(newRoute.stopDistFromPrev);
            if (stops.length > 0) {
                const last = stops[stops.length - 1];
                distanceFromOrigin = parseFloat(((last.distanceFromOrigin || 0) + manualDistFromPrev).toFixed(2));
            } else {
                distanceFromOrigin = manualDistFromPrev;
            }
        }

        let stopType = 'none';
        if (newRoute.isBoarding && newRoute.isDropping) stopType = 'both';
        else if (newRoute.isBoarding) stopType = 'boarding';
        else if (newRoute.isDropping) stopType = 'dropping';

        const newStop = {
            city: newRoute.stopCity,
            state: newRoute.stopState || '',
            address: newRoute.stopAddress || `${newRoute.stopCity}, ${newRoute.stopState || 'India'}`,
            terminal: newRoute.stopTerminal || `${newRoute.stopCity} Bus Stand`,
            arrivalDay: newRoute.stopArrivalDay || 1,
            arrivalTime: newRoute.stopArrivalTime,
            departureDay: newRoute.stopDepartureDay || 1,
            departureTime: newRoute.stopDepartureTime || newRoute.stopArrivalTime,
            stopType,
            coordinates,
            manualDistFromPrev,
            manualDistToNext: newRoute.stopDistToNext ? parseFloat(newRoute.stopDistToNext) : null,
            distanceFromOrigin,
            isManualStop: isManualLocation,
            sequence: stops.length + 1
        };

        setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));
        if (type === 'up') setUpStops([...upStops, newStop]);
        else setDownStops([...downStops, newStop]);
        toast.success(`Stop "${newRoute.stopCity}" added`);
        clearStopForm();
    };

    const handleDeleteStop = (index) => {
        const isUp = activeRouteTab === 'UP';
        setIsDistanceCalculated(prev => ({ ...prev, [isUp ? 'up' : 'down']: false }));
        if (isUp) setUpStops(upStops.filter((_, i) => i !== index));
        else setDownStops(downStops.filter((_, i) => i !== index));
    };

    const handleOpenStopEditModal = (index) => {
        const stops = getActiveStops();
        const stop = stops[index];
        if (!stop) return;
        setStopEditModal({ isOpen: true, stop, index, type: activeRouteTab === 'UP' ? 'up' : 'down' });
    };

    const handleSaveEditedStop = (index, updatedStop) => {
        const type = stopEditModal.type;
        setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));
        if (type === 'up') {
            const u = [...upStops]; u[index] = { ...updatedStop, sequence: index + 1 };
            setUpStops(u);
        } else {
            const u = [...downStops]; u[index] = { ...updatedStop, sequence: index + 1 };
            setDownStops(u);
        }
        toast.success('Stop updated');
    };

    const handleCalculateDistances = () => {
        const isUp = activeRouteTab === 'UP';
        const stops = isUp ? upStops : downStops;
        if (!newRoute.upOriginCity || !newRoute.upDestCity) {
            return toast.error("Origin and Destination required.");
        }
        setIsCalculatingDistances(true);
        toast.info(`Calculating ${activeRouteTab} distances...`);
        setTimeout(() => {
            let cumulative = 0;
            const updated = stops.map(s => {
                const seg = (s.manualDistFromPrev && parseFloat(s.manualDistFromPrev)) ||
                    parseFloat((Math.random() * 80 + 40).toFixed(1));
                cumulative += seg;
                return { ...s, distanceFromOrigin: parseFloat(cumulative.toFixed(1)) };
            });
            const total = cumulative + parseFloat((Math.random() * 100 + 50).toFixed(1));
            setActiveStops(updated);
            if (isUp) setNewRoute(p => ({ ...p, upTotalDistance: total.toFixed(1) }));
            setIsDistanceCalculated(prev => ({ ...prev, up: true }));
            toast.success(`Total: ${total.toFixed(1)} km (dummy)`);
            setIsCalculatingDistances(false);
        }, 500);
    };

    const handleSaveRoute = () => {
        if (!newRoute.routeName) return toast.error('Route Name is required');
        if (!newRoute.upOriginCity || !newRoute.upDestCity) {
            return toast.error('Origin and Destination required');
        }

        // mode-aware day/date validation
        if (newRoute.departureMode === 'weekly') {
            if (!newRoute.departureDays || newRoute.departureDays.length === 0) {
                return toast.error('Please select at least one departure day');
            }
        } else {
            if (!newRoute.departureDates || newRoute.departureDates.length === 0) {
                return toast.error('Please select at least one departure date');
            }
        }

        if (!newRoute.upOriginDepTime) return toast.error('Departure time required');
        if (!newRoute.upDestArrTime) return toast.error('Destination arrival time required');
        if (!isDistanceCalculated.up) return toast.error('Please calculate distances first');

        setIsCreatingRoute(true);
        setTimeout(() => {
            const created = {
                _id: 'pr_' + Date.now(),
                routeName: newRoute.routeName.trim(),
                localRouteName: newRoute.localRouteName?.trim() || null,
                isPrimaryRoute: true,
                departureMode: newRoute.departureMode,
                departureDays: newRoute.departureMode === 'weekly'
                    ? [...new Set(newRoute.departureDays)].sort((a, b) => a - b) : [],
                departureDates: newRoute.departureMode === 'monthly'
                    ? [...new Set(newRoute.departureDates)].sort((a, b) => a - b) : [],
                isActive: true,
                origin: {
                    city: newRoute.upOriginCity, state: newRoute.upOriginState,
                    terminal: newRoute.upOriginTerminal, address: newRoute.upOriginAddress,
                    coordinates: newRoute.upOriginCoords,
                    departureDay: 1, departureTime: newRoute.upOriginDepTime
                },
                destination: {
                    city: newRoute.upDestCity, state: newRoute.upDestState,
                    terminal: newRoute.upDestTerminal, address: newRoute.upDestAddress,
                    coordinates: newRoute.upDestCoords,
                    arrivalDay: newRoute.upDestArrDay || 1,
                    arrivalTime: newRoute.upDestArrTime
                },
                intermediateStops: upStops,
                routeDetails: {
                    totalDistance: parseFloat(newRoute.upTotalDistance || 0),
                    estimatedDuration: {
                        days: parseInt(newRoute.upDurationDays || 0, 10),
                        hours: parseInt(newRoute.upDurationHours || 0, 10),
                        minutes: parseInt(newRoute.upDurationMinutes || 0, 10)
                    }
                },
                createdAt: new Date().toISOString(),
                updatedAt: new Date().toISOString()
            };

            setRoutes(prev => [...prev, {
                id: created._id,
                serialNo: prev.length + 1,
                routeName: created.routeName,
                localRouteName: created.localRouteName,
                originCity: created.origin.city,
                destinationCity: created.destination.city,
                distance: created.routeDetails.totalDistance,
                durationDays: created.routeDetails.estimatedDuration.days,
                durationHours: created.routeDetails.estimatedDuration.hours,
                durationMinutes: created.routeDetails.estimatedDuration.minutes,
                duration: `${created.routeDetails.estimatedDuration.days}d ${created.routeDetails.estimatedDuration.hours}h ${created.routeDetails.estimatedDuration.minutes}m`,
                stops: created.intermediateStops.length,
                status: 'Active', isActive: true,
                departureMode: created.departureMode,
                departureDays: created.departureDays,
                departureDates: created.departureDates,
                departureTime: created.origin.departureTime,
                arrivalDay: created.destination.arrivalDay,
                arrivalTime: created.destination.arrivalTime,
                isRoundTrip: false,
                fullData: created
            }]);

            toast.success('Primary route created (dummy)!');
            setShowAddModal(false);
            resetNewRouteForm();
            setIsCreatingRoute(false);
        }, 400);
    };

    const resetNewRouteForm = () => {
        setNewRoute({
            routeName: '', localRouteName: '',
            departureMode: 'weekly', departureDays: [1], departureDates: [],
            upOriginCity: '', upOriginState: '', upOriginAddress: '', upOriginTerminal: '',
            upOriginCoords: null, upOriginDepTime: '',
            upDestCity: '', upDestState: '', upDestAddress: '', upDestTerminal: '',
            upDestCoords: null, upDestArrDay: 1, upDestArrTime: '',
            upTotalDistance: '', upDurationDays: 0, upDurationHours: '', upDurationMinutes: '',
            stopCity: '', stopState: '', stopAddress: '', stopTerminal: '',
            stopCoords: null, stopArrivalDay: 1, stopArrivalTime: '',
            stopDepartureDay: 1, stopDepartureTime: '',
            stopDistFromPrev: '', stopDistToNext: '',
            isBoarding: false, isDropping: false
        });
        setUpStops([]); setDownStops([]);
        setIsDistanceCalculated({ up: false, down: false });
    };

    const handleToggleStatus = (routeId, currentStatus) => {
        const newStatus = !currentStatus;
        if (!window.confirm(`Are you sure you want to ${newStatus ? 'activate' : 'deactivate'} this route?`)) return;
        setRoutes(prev => prev.map(r => r.id === routeId
            ? { ...r, isActive: newStatus, status: newStatus ? 'Active' : 'Inactive' } : r));
        toast.success(`Route ${newStatus ? 'activated' : 'deactivated'} (dummy)!`);
    };

    const handleDeleteRoute = (routeId) => {
        if (!window.confirm('Delete this route?')) return;
        setRoutes(prev => prev.filter(r => r.id !== routeId));
        toast.success('Route deleted (dummy)!');
    };

    const handleViewRoute = (route) => setViewingRoute(route.fullData || route);

    const currentRoutes = viewMode === 'regular' ? routes : pendingRoutes;

    const filteredRoutes = useMemo(() => {
        const q = searchTerm.trim().toLowerCase();
        return currentRoutes.filter(r => {
            if (statusFilter === 'active' && !r.isActive) return false;
            if (statusFilter === 'inactive' && r.isActive) return false;
            if (!q) return true;
            return [r.routeName, r.localRouteName, r.originCity, r.destinationCity]
                .filter(Boolean)
                .some(v => v.toLowerCase().includes(q));
        });
    }, [currentRoutes, searchTerm, statusFilter]);

    const activeCount = currentRoutes.filter(r => r.isActive).length;

    const formChecks = [
        !!newRoute.routeName.trim(),
        hasScheduleSelected(),
        !!newRoute.upOriginCity && !!newRoute.upOriginDepTime,
        !!newRoute.upDestCity && !!newRoute.upDestArrTime,
        isDistanceCalculated.up
    ];
    const formProgress = Math.round((formChecks.filter(Boolean).length / formChecks.length) * 100);
    const inactiveCount = currentRoutes.length - activeCount;

    // ============================================================
    // RENDER
    // ============================================================
    if (loading) {
        return (
            <div className="prm-page">
                <div className="prm-hero">
                    <div className="prm-hero-text">
                        <span className="prm-eyebrow"><Icon name="bus" size={13} /> Weekly & Monthly Routes</span>
                        <h1>Primary Route Management</h1>
                        <p>Loading your routes…</p>
                    </div>
                </div>
                <div style={{ height: 24 }} />
                <SkeletonGrid />
            </div>
        );
    }

    return (
        <div className="prm-page">
            {/* ===================== HERO ===================== */}
            <div className="prm-hero">
                <div className="prm-hero-road" aria-hidden="true"><span className="prm-hero-roadbus"><BusSvg size={46} /></span></div>
                <div className="prm-hero-text">
                    <span className="prm-eyebrow"><Icon name="map" size={13} /> Weekly & Monthly Routes</span>
                    <h1>Primary Route Management</h1>
                    <p>Plan, schedule and manage long-distance recurring routes — weekly or monthly, all days, stops and timings in one place.</p>
                </div>
                <div className="prm-hero-actions">
                    <div className="prm-search">
                        <Icon name="search" size={17} />
                        <input
                            type="text"
                            placeholder="Search route, city or local name…"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        {searchTerm && (
                            <button className="prm-search-clear" onClick={() => setSearchTerm('')}>×</button>
                        )}
                    </div>
                    <button className="prm-add-btn" onClick={() => setShowAddModal(true)}>
                        <span className="plus"><Icon name="plus" size={14} /></span> Add Primary Route
                    </button>
                </div>
            </div>

            {/* ===================== STATS ===================== */}
            <div className="prm-stats">
                <StatCard icon="route" tone="indigo" label="Total Routes" value={routes.length} hint="All primary routes" delay={80} />
                <StatCard icon="check" tone="green" label="Active" value={routes.filter(r => r.isActive).length} hint="Currently running" delay={160} />
                <StatCard icon="moon" tone="amber" label="Multi-Day" value={routes.filter(r => r.durationDays > 0).length} hint="Routes longer than 24h" delay={240} />
                <StatCard
                    icon="calendar"
                    tone="cyan"
                    label="Runs per Cycle"
                    value={routes.reduce((s, r) => s + (r.departureMode === 'monthly'
                        ? (r.departureDates?.length || 0)
                        : (r.departureDays?.length || 0)), 0)}
                    hint="Trips per week / month"
                    delay={320}
                />
            </div>

            {/* ===================== TOOLBAR ===================== */}
            <div className="prm-toolbar">
                <div className="prm-toolbar-left">
                    <div className="prm-segment">
                        <span className="prm-segment-pill"
                            style={{ transform: `translateX(${viewMode === 'regular' ? 0 : 100}%)` }} />
                        <button className={viewMode === 'regular' ? 'active' : ''} onClick={() => setViewMode('regular')}><Icon name="map" size={15} /> Regular</button>
                        <button className={viewMode === 'pending' ? 'active' : ''} onClick={() => setViewMode('pending')}><Icon name="clipboard" size={15} /> Executive Submitted</button>
                    </div>

                    <div className="prm-chips">
                        <button className={`prm-chip ${statusFilter === 'all' ? 'active' : ''}`} onClick={() => setStatusFilter('all')}>
                            All <span className="count">{currentRoutes.length}</span>
                        </button>
                        <button className={`prm-chip ${statusFilter === 'active' ? 'active' : ''}`} onClick={() => setStatusFilter('active')}>
                            Active <span className="count">{activeCount}</span>
                        </button>
                        <button className={`prm-chip ${statusFilter === 'inactive' ? 'active' : ''}`} onClick={() => setStatusFilter('inactive')}>
                            Inactive <span className="count">{inactiveCount}</span>
                        </button>
                    </div>
                </div>

                <div className="prm-toolbar-right">
                    <span className="prm-result-count">Showing <b>{filteredRoutes.length}</b> of {currentRoutes.length}</span>
                    <div className="prm-layout-toggle">
                        <button className={layout === 'cards' ? 'active' : ''} onClick={() => setLayout('cards')} title="Card view"><Icon name="grid" size={17} /></button>
                        <button className={layout === 'table' ? 'active' : ''} onClick={() => setLayout('table')} title="Table view"><Icon name="list" size={17} /></button>
                    </div>
                </div>
            </div>

            {/* ===================== ROUTES ===================== */}
            {filteredRoutes.length === 0 ? (
                <div className="prm-empty">
                    <div className="icon"><Icon name={searchTerm || statusFilter !== 'all' ? 'search' : 'bus'} size={44} /></div>
                    <h3>{searchTerm || statusFilter !== 'all' ? 'No routes match your filters' : 'No routes yet'}</h3>
                    <p>
                        {searchTerm || statusFilter !== 'all'
                            ? 'Try a different search term or clear the filters to see all routes.'
                            : 'Create your first recurring primary route and start scheduling buses across the country.'}
                    </p>
                    {searchTerm || statusFilter !== 'all' ? (
                        <button className="prm-btn ghost" onClick={() => { setSearchTerm(''); setStatusFilter('all'); }}>Clear filters</button>
                    ) : (
                        <button className="prm-add-btn" onClick={() => setShowAddModal(true)}>
                            <span className="plus"><Icon name="plus" size={14} /></span> Add Primary Route
                        </button>
                    )}
                </div>
            ) : layout === 'cards' ? (
                <div className="prm-grid">
                    {filteredRoutes.map((route, i) => (
                        <RouteCard
                            key={route.id}
                            route={route}
                            index={i}
                            onView={handleViewRoute}
                            onToggle={handleToggleStatus}
                            onDelete={handleDeleteRoute}
                        />
                    ))}
                </div>
            ) : (
                <div className="prm-table-wrap">
                    <table className="prm-table">
                        <thead>
                            <tr>
                                <th>No.</th><th>Route</th><th>Origin → Destination</th>
                                <th>Runs On</th><th>Departure</th><th>Duration</th>
                                <th>Stops</th><th>Status</th><th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredRoutes.map((route, i) => (
                                <tr key={route.id} style={{ animationDelay: `${i * 70}ms` }}>
                                    <td>{route.serialNo}</td>
                                    <td>
                                        <div className="name">{route.routeName}</div>
                                        <div className="sub">{route.localRouteName || '—'}</div>
                                    </td>
                                    <td><b>{route.originCity}</b> → <b>{route.destinationCity}</b></td>
                                    <td>
                                        <div className="prm-mini-days">
                                            {route.departureMode === 'monthly'
                                                ? (route.departureDates || []).slice(0, 5).map(d => <span key={d} title={`Date ${d}`}>D{d}</span>)
                                                : (route.departureDays || []).map(d => <span key={d}>{DAY_SHORT[d]}</span>)}
                                            {route.departureMode === 'monthly' && (route.departureDates || []).length > 5 && (
                                                <span>+{(route.departureDates.length - 5)}</span>
                                            )}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="name">{fmtTime(route.departureTime)}</div>
                                        <div className="sub">
                                            Arrives {
                                                route.departureMode === 'monthly'
                                                    ? resolveOffsetLabel(route.arrivalDay, 'monthly', [], route.departureDates)
                                                    : formatDayTime(route.arrivalDay, null, route.departureDays?.[0])
                                            }
                                        </div>
                                    </td>
                                    <td>{route.duration}</td>
                                    <td>{route.stops}</td>
                                    <td><span className={`prm-status ${route.isActive ? 'active' : 'inactive'}`}>{route.status}</span></td>
                                    <td>
                                        <div className="prm-row-actions">
                                            <Switch checked={route.isActive} onChange={() => handleToggleStatus(route.id, route.isActive)} />
                                            <button className="prm-btn ghost icon-only" onClick={() => handleViewRoute(route)} title="View" aria-label="View"><Icon name="eye" size={14} /></button>
                                            <button className="prm-btn danger icon-only" onClick={() => handleDeleteRoute(route.id)} title="Delete" aria-label="Delete"><Icon name="trash" size={16} /></button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* ============================================================
                ADD MODAL
            ============================================================ */}
            {showAddModal && (
                <div className="prm-overlay" onClick={() => setShowAddModal(false)}>
                    <div className="prm-form-modal" onClick={(e) => e.stopPropagation()}>
                        {/* Header */}
                        <div className="prm-form-head">
                            <div className="prm-form-head-row">
                                <span className="prm-form-badge"><Icon name="bus" size={24} /></span>
                                <div>
                                    <h3>Create Recurring Primary Route</h3>
                                    <p>Set up weekly or monthly runs — timings and stops repeat automatically.</p>
                                </div>
                            </div>
                            <button className="prm-modal-close" onClick={() => setShowAddModal(false)}>×</button>
                            <div className="prm-progress">
                                <div className="prm-progress-bar"><i style={{ width: `${formProgress}%` }} /></div>
                                <span>{formProgress}% complete</span>
                            </div>
                        </div>

                        {/* Body */}
                        <div className="prm-form-body">
                            <div className="prm-callout amber">
                                <Icon name="info" size={18} />
                                <div>
                                    <strong>Recurring Route</strong>
                                    <span>
                                        Pick <b>Weekly</b> to run on specific days of the week, or <b>Monthly</b> to run on specific
                                        dates of the month. Buses depart at the <b>same time</b> on every selected day / date.
                                        All stop timings are entered once and auto-repeated.
                                    </span>
                                </div>
                            </div>

                            {/* 1 — Route Identity */}
                            <FormSection n="1" title="Route Identity" hint="Name your route and choose the schedule." delay={40}>
                                <div className="prm-fgrid">
                                    <Field label="Route Name" required>
                                        <input type="text" value={newRoute.routeName} className="prm-input"
                                            onChange={(e) => setNewRoute(p => ({ ...p, routeName: e.target.value }))}
                                            placeholder="e.g. Kalyani → Manali Weekly" />
                                    </Field>
                                    <Field label="Local Route Name">
                                        <input type="text" value={newRoute.localRouteName} className="prm-input"
                                            onChange={(e) => setNewRoute(p => ({ ...p, localRouteName: e.target.value }))}
                                            placeholder="Optional local name" />
                                    </Field>

                                    <Field label="Departure schedule (pick mode + 1 or more)" required full>
                                        <div className="prm-mode-toggle">
                                            <button
                                                type="button"
                                                className={`prm-mode-btn ${newRoute.departureMode === 'weekly' ? 'active' : ''}`}
                                                onClick={() => setNewRoute(p => ({ ...p, departureMode: 'weekly' }))}
                                            >
                                                <Icon name="calendar" size={14} /> Weekly
                                            </button>
                                            <button
                                                type="button"
                                                className={`prm-mode-btn ${newRoute.departureMode === 'monthly' ? 'active' : ''}`}
                                                onClick={() => setNewRoute(p => ({ ...p, departureMode: 'monthly' }))}
                                            >
                                                <Icon name="calendar" size={14} /> Monthly
                                            </button>
                                        </div>

                                        {newRoute.departureMode === 'weekly' ? (
                                            <WeeklyDaysSelector
                                                selectedDays={newRoute.departureDays}
                                                onChange={(days) => {
                                                    if (days.length === 0) { toast.warning('At least one day required'); return; }
                                                    setNewRoute(p => ({ ...p, departureDays: days }));
                                                }}
                                            />
                                        ) : (
                                            <MonthlyDatesSelector
                                                selectedDates={newRoute.departureDates}
                                                onChange={(dates) => {
                                                    if (dates.length === 0) { toast.warning('At least one date required'); return; }
                                                    setNewRoute(p => ({ ...p, departureDates: dates }));
                                                }}
                                            />
                                        )}

                                        <small className="prm-note">
                                            {newRoute.departureMode === 'weekly'
                                                ? (newRoute.departureDays.length > 0
                                                    ? `Selected: ${newRoute.departureDays.map(d => DAY_NAMES[d]).join(', ')} — ${DAY_SHORT[newRoute.departureDays[0]]} is Day 1 for offsets.`
                                                    : 'No days selected.')
                                                : (newRoute.departureDates.length > 0
                                                    ? `Selected dates: ${newRoute.departureDates.map(d => `Date ${d}`).join(', ')} — Date ${newRoute.departureDates[0]} is Day 1 for offsets.`
                                                    : 'No dates selected.')}
                                        </small>
                                    </Field>
                                </div>
                            </FormSection>

                            {/* 2 + 3 — Origin & Destination */}
                            <div className="prm-cols">
                                <FormSection n="2" title="Origin" hint="Where the bus starts." delay={90}>
                                    <div className="prm-fgrid one">
                                        <Field label="Search location" required>
                                            <LocationInput value={newRoute.upOriginCity}
                                                onChange={(v) => setNewRoute(p => ({ ...p, upOriginCity: v }))}
                                                onLocationSelect={handleSelectOrigin}
                                                placeholder="Search origin city..." />
                                        </Field>
                                        <Field label="State">
                                            <input type="text" value={newRoute.upOriginState} className="prm-input"
                                                onChange={(e) => setNewRoute(p => ({ ...p, upOriginState: e.target.value }))} />
                                        </Field>
                                        <Field label="Terminal">
                                            <input type="text" value={newRoute.upOriginTerminal} className="prm-input"
                                                onChange={(e) => setNewRoute(p => ({ ...p, upOriginTerminal: e.target.value }))} />
                                        </Field>
                                        <Field label="Departure time (same on every selected day / date)" required>
                                            <input type="time" value={newRoute.upOriginDepTime} className="prm-input"
                                                onChange={(e) => setNewRoute(p => ({ ...p, upOriginDepTime: e.target.value }))} />
                                            {hasScheduleSelected() && newRoute.upOriginDepTime && (
                                                <span className="prm-tag teal">
                                                    {newRoute.departureMode === 'weekly'
                                                        ? newRoute.departureDays.map(d => DAY_SHORT[d]).join(' · ')
                                                        : newRoute.departureDates.map(d => `Date ${d}`).join(' · ')} at {fmtTime(newRoute.upOriginDepTime)}
                                                </span>
                                            )}
                                        </Field>
                                    </div>
                                </FormSection>

                                <FormSection n="3" title="Destination" hint="Where the bus ends." delay={140}>
                                    <div className="prm-fgrid one">
                                        <Field label="Search location" required>
                                            <LocationInput value={newRoute.upDestCity}
                                                onChange={(v) => setNewRoute(p => ({ ...p, upDestCity: v }))}
                                                onLocationSelect={handleSelectDest}
                                                placeholder="Search destination city..." />
                                        </Field>
                                        <Field label="State">
                                            <input type="text" value={newRoute.upDestState} className="prm-input"
                                                onChange={(e) => setNewRoute(p => ({ ...p, upDestState: e.target.value }))} />
                                        </Field>
                                        <Field label="Terminal">
                                            <input type="text" value={newRoute.upDestTerminal} className="prm-input"
                                                onChange={(e) => setNewRoute(p => ({ ...p, upDestTerminal: e.target.value }))} />
                                        </Field>
                                        <Field label="Arrival (offset + time)" required>
                                            <DayTimePicker
                                                day={newRoute.upDestArrDay}
                                                time={newRoute.upDestArrTime}
                                                onDayChange={(d) => setNewRoute(p => ({ ...p, upDestArrDay: d }))}
                                                onTimeChange={(t) => setNewRoute(p => ({ ...p, upDestArrTime: t }))}
                                                maxDay={7}
                                                minDay={1}
                                                startDayIdx={getStartDayIdx()}
                                                departureMode={newRoute.departureMode}
                                                departureDates={newRoute.departureDates}
                                            />
                                            {hasScheduleSelected() && newRoute.upDestArrTime && (
                                                <span className="prm-tag amber">
                                                    Arrives: {formatOccurrencesDynamic(
                                                        newRoute.upDestArrDay, newRoute.upDestArrTime,
                                                        newRoute.departureMode, newRoute.departureDays, newRoute.departureDates
                                                    )}
                                                </span>
                                            )}
                                        </Field>
                                    </div>
                                </FormSection>
                            </div>

                            {/* 4 — Intermediate Stops */}
                            <FormSection n="4" title="Intermediate Stops" hint="Add boarding / dropping points between origin and destination." delay={190}>
                                <div className="prm-stop-list">
                                    {getActiveStops().map((stop, index) => (
                                        <div key={index} className="prm-stop-item">
                                            <div className="prm-stop-num">{index + 1}</div>
                                            <div className="prm-stop-info">
                                                <div className="prm-stop-name">
                                                    {stop.city}
                                                    <span className="prm-tag navy">{stop.distanceFromOrigin?.toFixed(1) || 0} km</span>
                                                    {stop.stopType && stop.stopType !== 'none' && (
                                                        <span className="prm-tag teal">{stop.stopType}</span>
                                                    )}
                                                </div>
                                                <div className="prm-stop-times">
                                                    Arr: {resolveOffsetLabel(stop.arrivalDay, newRoute.departureMode, newRoute.departureDays, newRoute.departureDates)}
                                                    <i>•</i>
                                                    Dep: {resolveOffsetLabel(stop.departureDay, newRoute.departureMode, newRoute.departureDays, newRoute.departureDates)}
                                                </div>
                                                {hasScheduleSelected() && stop.arrivalTime && (
                                                    <span className="prm-tag amber">
                                                        <Icon name="clock" size={12} /> {formatOccurrencesDynamic(
                                                            stop.arrivalDay, stop.arrivalTime,
                                                            newRoute.departureMode, newRoute.departureDays, newRoute.departureDates
                                                        )}
                                                    </span>
                                                )}
                                            </div>
                                            <div className="prm-stop-actions">
                                                <button className="prm-btn ghost sm" onClick={() => handleOpenStopEditModal(index)}>
                                                    <Icon name="edit" size={14} /> Edit
                                                </button>
                                                <button className="prm-btn danger sm" onClick={() => handleDeleteStop(index)}>
                                                    <Icon name="trash" size={14} />
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                    {getActiveStops().length === 0 && (
                                        <div className="prm-stop-empty">
                                            <Icon name="stop" size={22} />
                                            <span>No intermediate stops yet — add one below (optional).</span>
                                        </div>
                                    )}
                                </div>

                                <div className="prm-addstop">
                                    <div className="prm-addstop-head">
                                        <h5><Icon name="plus" size={15} /> Add Intermediate Stop</h5>
                                        <Checkbox label="Manually Typed Stop"
                                            checked={!isManualStop}
                                            onChange={() => setIsManualStop(!isManualStop)} />
                                    </div>

                                    <div className="prm-fgrid">
                                        <Field label="City" required full>
                                            <LocationInput value={newRoute.stopCity}
                                                onChange={(v) => setNewRoute(p => ({ ...p, stopCity: v }))}
                                                onLocationSelect={handleSelectStop}
                                                placeholder="Search stop city..." />
                                        </Field>

                                        {(isManualStop || !newRoute.stopCoords) && (
                                            <Field label="Distance from previous stop (km)" required full>
                                                <input type="number" value={newRoute.stopDistFromPrev} className="prm-input" min="0" step="0.1"
                                                    onChange={(e) => setNewRoute(p => ({ ...p, stopDistFromPrev: e.target.value }))} />
                                            </Field>
                                        )}

                                        <Field label="State">
                                            <input type="text" value={newRoute.stopState} className="prm-input"
                                                onChange={(e) => setNewRoute(p => ({ ...p, stopState: e.target.value }))} />
                                        </Field>
                                        <Field label="Terminal">
                                            <input type="text" value={newRoute.stopTerminal} className="prm-input"
                                                onChange={(e) => setNewRoute(p => ({ ...p, stopTerminal: e.target.value }))} />
                                        </Field>

                                        <Field label="Arrival (offset + time)" required>
                                            <DayTimePicker
                                                day={newRoute.stopArrivalDay}
                                                time={newRoute.stopArrivalTime}
                                                onDayChange={(d) => setNewRoute(p => ({
                                                    ...p, stopArrivalDay: d,
                                                    stopDepartureDay: Math.max(d, p.stopDepartureDay || 1)
                                                }))}
                                                onTimeChange={(t) => setNewRoute(p => ({ ...p, stopArrivalTime: t }))}
                                                startDayIdx={getStartDayIdx()}
                                                departureMode={newRoute.departureMode}
                                                departureDates={newRoute.departureDates}
                                            />
                                        </Field>
                                        <Field label="Departure (offset + time)">
                                            <DayTimePicker
                                                day={newRoute.stopDepartureDay}
                                                time={newRoute.stopDepartureTime}
                                                onDayChange={(d) => setNewRoute(p => ({ ...p, stopDepartureDay: d }))}
                                                onTimeChange={(t) => setNewRoute(p => ({ ...p, stopDepartureTime: t }))}
                                                minDay={newRoute.stopArrivalDay || 1}
                                                startDayIdx={getStartDayIdx()}
                                                departureMode={newRoute.departureMode}
                                                departureDates={newRoute.departureDates}
                                            />
                                        </Field>
                                    </div>

                                    {hasScheduleSelected() && newRoute.stopArrivalTime && (
                                        <div className="prm-callout teal">
                                            <Icon name="check" size={16} />
                                            <div>
                                                <strong>Bus will reach {newRoute.stopCity || 'this stop'} at</strong>
                                                <span>{formatOccurrencesDynamic(
                                                    newRoute.stopArrivalDay, newRoute.stopArrivalTime,
                                                    newRoute.departureMode, newRoute.departureDays, newRoute.departureDates
                                                )}</span>
                                            </div>
                                        </div>
                                    )}

                                    <div className="prm-addstop-foot">
                                        <div className="prm-checks">
                                            <Checkbox label="Boarding Point" checked={newRoute.isBoarding}
                                                onChange={() => setNewRoute(p => ({ ...p, isBoarding: !p.isBoarding }))} />
                                            <Checkbox label="Dropping Point" checked={newRoute.isDropping}
                                                onChange={() => setNewRoute(p => ({ ...p, isDropping: !p.isDropping }))} />
                                        </div>
                                        <button className="prm-btn view sm-fit"
                                            onClick={() => addIntermediateStop('up')}
                                            disabled={!newRoute.stopCity || !newRoute.stopArrivalTime}>
                                            <Icon name="plus" size={15} /> Add Stop
                                        </button>
                                    </div>
                                </div>
                            </FormSection>

                            {/* 5 — Summary */}
                            <FormSection n="5" title="Summary" hint="Calculate the total distance, then confirm the duration." delay={240}>
                                <div className="prm-summary">
                                    <button className="prm-btn teal"
                                        onClick={handleCalculateDistances}
                                        disabled={isCalculatingDistances}>
                                        <Icon name="calc" size={16} />
                                        {isCalculatingDistances ? 'Calculating...' : 'Auto-Calculate Distances'}
                                    </button>
                                    <span className={`prm-tag ${isDistanceCalculated.up ? 'teal' : 'amber'}`}>
                                        {isDistanceCalculated.up ? 'Distances calculated' : 'Not calculated yet'}
                                    </span>
                                </div>

                                <div className="prm-fgrid">
                                    <Field label="Total distance (KM)">
                                        <input type="number" value={newRoute.upTotalDistance} className="prm-input" min="0" step="0.1"
                                            onChange={(e) => setNewRoute(p => ({ ...p, upTotalDistance: e.target.value }))} />
                                    </Field>
                                    <Field label="Estimated duration">
                                        <div className="prm-dur">
                                            <input type="number" value={newRoute.upDurationDays} className="prm-input" placeholder="0" min="0" max="7"
                                                onChange={(e) => setNewRoute(p => ({ ...p, upDurationDays: Math.min(7, Math.max(0, parseInt(e.target.value) || 0)) }))} />
                                            <span>days</span>
                                            <input type="number" value={newRoute.upDurationHours} className="prm-input" placeholder="0" min="0" max="23"
                                                onChange={(e) => setNewRoute(p => ({ ...p, upDurationHours: Math.min(23, Math.max(0, parseInt(e.target.value) || 0)) }))} />
                                            <span>h</span>
                                            <input type="number" value={newRoute.upDurationMinutes} className="prm-input" placeholder="0" min="0" max="59"
                                                onChange={(e) => setNewRoute(p => ({ ...p, upDurationMinutes: Math.min(59, Math.max(0, parseInt(e.target.value) || 0)) }))} />
                                            <span>m</span>
                                        </div>
                                    </Field>
                                </div>
                            </FormSection>
                        </div>

                        {/* Footer */}
                        <div className="prm-form-foot">
                            <span className="prm-foot-hint">Fields marked <em>*</em> are required</span>
                            <div className="prm-form-foot-actions">
                                <button className="prm-btn ghost" onClick={() => setShowAddModal(false)}>Cancel</button>
                                <button className="prm-btn primary" onClick={handleSaveRoute} disabled={isCreatingRoute}>
                                    {isCreatingRoute ? 'Creating...' : <><Icon name="check" size={16} /> Add Primary Route</>}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ===================== VIEW MODAL ===================== */}
            {viewingRoute && (
                <div className="prm-overlay" onClick={() => setViewingRoute(null)}>
                    <div className="prm-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="prm-modal-head">
                            <h3>{viewingRoute.routeName}</h3>
                            <p><Icon name="tag" size={14} /> {viewingRoute.localRouteName || 'No local name'}</p>
                            <button className="prm-modal-close" onClick={() => setViewingRoute(null)}>×</button>
                        </div>

                        <div className="prm-modal-body">
                            <div className="prm-info-grid">
                                <div className="prm-info" style={{ animationDelay: '60ms' }}>
                                    <div className="l">Distance</div>
                                    <div className="v"><Icon name="pin" size={17} /> {viewingRoute.routeDetails?.totalDistance} km</div>
                                </div>
                                <div className="prm-info" style={{ animationDelay: '120ms' }}>
                                    <div className="l">Duration</div>
                                    <div className="v"><Icon name="clock" size={17} /> {viewingRoute.routeDetails?.estimatedDuration?.days || 0}d {viewingRoute.routeDetails?.estimatedDuration?.hours || 0}h {viewingRoute.routeDetails?.estimatedDuration?.minutes || 0}m</div>
                                </div>
                                <div className="prm-info" style={{ animationDelay: '180ms' }}>
                                    <div className="l">Stops</div>
                                    <div className="v"><Icon name="stop" size={17} /> {viewingRoute.intermediateStops?.length || 0}</div>
                                </div>
                            </div>

                            <div className="prm-section-title">
                                Runs {viewingRoute.departureMode === 'monthly' ? 'on dates' : 'on days'}
                            </div>
                            {viewingRoute.departureMode === 'monthly' ? (
                                <div className="prm-month-chips" style={{ marginBottom: 24 }}>
                                    {(viewingRoute.departureDates || []).map(d => (
                                        <span key={d} className="prm-month-chip">{d}</span>
                                    ))}
                                </div>
                            ) : (
                                <div className="prm-days" style={{ marginBottom: 24 }}>
                                    {DAY_SHORT.map((d, i) => (
                                        <div key={d} className={`prm-day ${viewingRoute.departureDays?.includes(i) ? 'on' : ''}`}>{d}</div>
                                    ))}
                                </div>
                            )}

                            <div className="prm-section-title">Journey Timeline</div>
                            <div className="prm-timeline">
                                <div className="prm-tl-item origin">
                                    <div className="prm-tl-city">
                                        {viewingRoute.origin?.city}
                                        <small>{viewingRoute.origin?.terminal}</small>
                                    </div>
                                    <div className="prm-tl-time">
                                        Departs <b>{fmtTime(viewingRoute.origin?.departureTime)}</b> on all selected {viewingRoute.departureMode === 'monthly' ? 'dates' : 'days'}
                                    </div>
                                </div>

                                {viewingRoute.intermediateStops?.map((s, i) => (
                                    <div key={i} className="prm-tl-item stop" style={{ animationDelay: `${(i + 1) * 90}ms` }}>
                                        <div className="prm-tl-city">
                                            {s.sequence}. {s.city}
                                            <small>{s.distanceFromOrigin?.toFixed(1)} km from origin</small>
                                        </div>
                                        <div className="prm-tl-time">
                                            Arrives: {formatOccurrencesDynamic(
                                                s.arrivalDay, s.arrivalTime,
                                                viewingRoute.departureMode,
                                                viewingRoute.departureDays,
                                                viewingRoute.departureDates
                                            )}
                                        </div>
                                    </div>
                                ))}

                                <div className="prm-tl-item dest" style={{ animationDelay: `${((viewingRoute.intermediateStops?.length || 0) + 1) * 90}ms` }}>
                                    <div className="prm-tl-city">
                                        {viewingRoute.destination?.city}
                                        <small>{viewingRoute.destination?.terminal}</small>
                                    </div>
                                    <div className="prm-tl-time">
                                        Arrives: {formatOccurrencesDynamic(
                                            viewingRoute.destination?.arrivalDay || 1,
                                            viewingRoute.destination?.arrivalTime,
                                            viewingRoute.departureMode,
                                            viewingRoute.departureDays,
                                            viewingRoute.departureDates
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="prm-modal-foot">
                            <button className="prm-btn view" style={{ flex: 'none', padding: '11px 28px' }} onClick={() => setViewingRoute(null)}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {/* STOP EDIT MODAL */}
            <PrimaryStopEditModal
                isOpen={stopEditModal.isOpen}
                stop={stopEditModal.stop}
                stopIndex={stopEditModal.index}
                departureDays={newRoute.departureDays}
                departureDates={newRoute.departureDates}
                departureMode={newRoute.departureMode}
                startDayIdx={getStartDayIdx()}
                onClose={() => setStopEditModal({ isOpen: false, stop: null, index: null, type: 'up' })}
                onSave={handleSaveEditedStop}
            />

            {logModal.show && (
                <RouteActivityLogModal
                    routeId={logModal.routeId}
                    routeName={logModal.routeName}
                    onClose={() => setLogModal({ show: false, routeId: null, routeName: '' })}
                    token={token}
                />
            )}
        </div>
    );
};

export default PrimaryRouteManage;
